/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const saveRecordBriefing = /* GraphQL */ `mutation SaveRecordBriefing($recordBriefingId: ID!, $appointmentId: ID!) {
  saveRecordBriefing(
    recordBriefingId: $recordBriefingId
    appointmentId: $appointmentId
  ) {
    success
    recordBriefingId
    publishedAt
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SaveRecordBriefingMutationVariables,
  APITypes.SaveRecordBriefingMutation
>;
export const resetRecordBriefingDrafts = /* GraphQL */ `mutation ResetRecordBriefingDrafts($recordBriefingId: ID!) {
  resetRecordBriefingDrafts(recordBriefingId: $recordBriefingId) {
    success
    recordBriefingId
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ResetRecordBriefingDraftsMutationVariables,
  APITypes.ResetRecordBriefingDraftsMutation
>;
export const batchUpdateRecordBriefingMappings = /* GraphQL */ `mutation BatchUpdateRecordBriefingMappings(
  $recordBriefingId: ID!
  $mappingIds: [ID!]!
  $action: String!
) {
  batchUpdateRecordBriefingMappings(
    recordBriefingId: $recordBriefingId
    mappingIds: $mappingIds
    action: $action
  ) {
    success
    error
    succeededIds
    failedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BatchUpdateRecordBriefingMappingsMutationVariables,
  APITypes.BatchUpdateRecordBriefingMappingsMutation
>;
export const createAppointmentFileReference = /* GraphQL */ `mutation CreateAppointmentFileReference(
  $input: CreateAppointmentFileReferenceInput!
  $condition: ModelAppointmentFileReferenceConditionInput
) {
  createAppointmentFileReference(input: $input, condition: $condition) {
    id
    appointmentID
    uploadedFileID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAppointmentFileReferenceMutationVariables,
  APITypes.CreateAppointmentFileReferenceMutation
>;
export const updateAppointmentFileReference = /* GraphQL */ `mutation UpdateAppointmentFileReference(
  $input: UpdateAppointmentFileReferenceInput!
  $condition: ModelAppointmentFileReferenceConditionInput
) {
  updateAppointmentFileReference(input: $input, condition: $condition) {
    id
    appointmentID
    uploadedFileID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAppointmentFileReferenceMutationVariables,
  APITypes.UpdateAppointmentFileReferenceMutation
>;
export const deleteAppointmentFileReference = /* GraphQL */ `mutation DeleteAppointmentFileReference(
  $input: DeleteAppointmentFileReferenceInput!
  $condition: ModelAppointmentFileReferenceConditionInput
) {
  deleteAppointmentFileReference(input: $input, condition: $condition) {
    id
    appointmentID
    uploadedFileID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAppointmentFileReferenceMutationVariables,
  APITypes.DeleteAppointmentFileReferenceMutation
>;
export const createUploadedFile = /* GraphQL */ `mutation CreateUploadedFile(
  $input: CreateUploadedFileInput!
  $condition: ModelUploadedFileConditionInput
) {
  createUploadedFile(input: $input, condition: $condition) {
    id
    key
    fileName
    type
    provider
    uploadedBy
    uploadedAt
    fileSizeBytes
    fileSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    fileSetID
    sourceAppointmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUploadedFileMutationVariables,
  APITypes.CreateUploadedFileMutation
>;
export const updateUploadedFile = /* GraphQL */ `mutation UpdateUploadedFile(
  $input: UpdateUploadedFileInput!
  $condition: ModelUploadedFileConditionInput
) {
  updateUploadedFile(input: $input, condition: $condition) {
    id
    key
    fileName
    type
    provider
    uploadedBy
    uploadedAt
    fileSizeBytes
    fileSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    fileSetID
    sourceAppointmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUploadedFileMutationVariables,
  APITypes.UpdateUploadedFileMutation
>;
export const deleteUploadedFile = /* GraphQL */ `mutation DeleteUploadedFile(
  $input: DeleteUploadedFileInput!
  $condition: ModelUploadedFileConditionInput
) {
  deleteUploadedFile(input: $input, condition: $condition) {
    id
    key
    fileName
    type
    provider
    uploadedBy
    uploadedAt
    fileSizeBytes
    fileSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    fileSetID
    sourceAppointmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUploadedFileMutationVariables,
  APITypes.DeleteUploadedFileMutation
>;
export const createDocument = /* GraphQL */ `mutation CreateDocument(
  $input: CreateDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  createDocument(input: $input, condition: $condition) {
    id
    uploadedFileID
    providerTag
    pageCount
    executionArn
    recordBriefingId
    segmentSplits
    segmentIntervals {
      startPageNumber
      endPageNumber
      startLineNumber
      endLineNumber
      confidence
      confidenceReasoning
      edited
      needsReSummary
      __typename
    }
    segmentIntervalRows {
      items {
        id
        documentID
        startPageNumber
        endPageNumber
        startLineNumber
        endLineNumber
        confidence
        confidenceReasoning
        edited
        needsReSummary
        archived
        parentIntervals
        lastEditAction
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    pages {
      items {
        id
        documentID
        pageNumber
        imageS3Key
        text
        isBlank
        citations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    preview {
      bucket
      key
      __typename
    }
    hasUnresolvedSplits
    videoDurationSeconds
    ingestionSteps {
      items {
        id
        documentID
        name
        status
        startedAt
        endedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    documentMrrValidationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentMutationVariables,
  APITypes.CreateDocumentMutation
>;
export const updateDocument = /* GraphQL */ `mutation UpdateDocument(
  $input: UpdateDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  updateDocument(input: $input, condition: $condition) {
    id
    uploadedFileID
    providerTag
    pageCount
    executionArn
    recordBriefingId
    segmentSplits
    segmentIntervals {
      startPageNumber
      endPageNumber
      startLineNumber
      endLineNumber
      confidence
      confidenceReasoning
      edited
      needsReSummary
      __typename
    }
    segmentIntervalRows {
      items {
        id
        documentID
        startPageNumber
        endPageNumber
        startLineNumber
        endLineNumber
        confidence
        confidenceReasoning
        edited
        needsReSummary
        archived
        parentIntervals
        lastEditAction
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    pages {
      items {
        id
        documentID
        pageNumber
        imageS3Key
        text
        isBlank
        citations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    preview {
      bucket
      key
      __typename
    }
    hasUnresolvedSplits
    videoDurationSeconds
    ingestionSteps {
      items {
        id
        documentID
        name
        status
        startedAt
        endedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    documentMrrValidationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentMutationVariables,
  APITypes.UpdateDocumentMutation
>;
export const deleteDocument = /* GraphQL */ `mutation DeleteDocument(
  $input: DeleteDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  deleteDocument(input: $input, condition: $condition) {
    id
    uploadedFileID
    providerTag
    pageCount
    executionArn
    recordBriefingId
    segmentSplits
    segmentIntervals {
      startPageNumber
      endPageNumber
      startLineNumber
      endLineNumber
      confidence
      confidenceReasoning
      edited
      needsReSummary
      __typename
    }
    segmentIntervalRows {
      items {
        id
        documentID
        startPageNumber
        endPageNumber
        startLineNumber
        endLineNumber
        confidence
        confidenceReasoning
        edited
        needsReSummary
        archived
        parentIntervals
        lastEditAction
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    pages {
      items {
        id
        documentID
        pageNumber
        imageS3Key
        text
        isBlank
        citations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    preview {
      bucket
      key
      __typename
    }
    hasUnresolvedSplits
    videoDurationSeconds
    ingestionSteps {
      items {
        id
        documentID
        name
        status
        startedAt
        endedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    documentMrrValidationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentMutationVariables,
  APITypes.DeleteDocumentMutation
>;
export const createDocumentIngestionStep = /* GraphQL */ `mutation CreateDocumentIngestionStep(
  $input: CreateDocumentIngestionStepInput!
  $condition: ModelDocumentIngestionStepConditionInput
) {
  createDocumentIngestionStep(input: $input, condition: $condition) {
    id
    documentID
    name
    status
    startedAt
    endedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentIngestionStepMutationVariables,
  APITypes.CreateDocumentIngestionStepMutation
>;
export const updateDocumentIngestionStep = /* GraphQL */ `mutation UpdateDocumentIngestionStep(
  $input: UpdateDocumentIngestionStepInput!
  $condition: ModelDocumentIngestionStepConditionInput
) {
  updateDocumentIngestionStep(input: $input, condition: $condition) {
    id
    documentID
    name
    status
    startedAt
    endedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentIngestionStepMutationVariables,
  APITypes.UpdateDocumentIngestionStepMutation
>;
export const deleteDocumentIngestionStep = /* GraphQL */ `mutation DeleteDocumentIngestionStep(
  $input: DeleteDocumentIngestionStepInput!
  $condition: ModelDocumentIngestionStepConditionInput
) {
  deleteDocumentIngestionStep(input: $input, condition: $condition) {
    id
    documentID
    name
    status
    startedAt
    endedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentIngestionStepMutationVariables,
  APITypes.DeleteDocumentIngestionStepMutation
>;
export const createOperationStatus = /* GraphQL */ `mutation CreateOperationStatus(
  $input: CreateOperationStatusInput!
  $condition: ModelOperationStatusConditionInput
) {
  createOperationStatus(input: $input, condition: $condition) {
    id
    scope
    operation
    name
    status
    startedAt
    heartbeatAt
    endedAt
    attempt
    errorMessage
    correlationId
    metadata
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOperationStatusMutationVariables,
  APITypes.CreateOperationStatusMutation
>;
export const updateOperationStatus = /* GraphQL */ `mutation UpdateOperationStatus(
  $input: UpdateOperationStatusInput!
  $condition: ModelOperationStatusConditionInput
) {
  updateOperationStatus(input: $input, condition: $condition) {
    id
    scope
    operation
    name
    status
    startedAt
    heartbeatAt
    endedAt
    attempt
    errorMessage
    correlationId
    metadata
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOperationStatusMutationVariables,
  APITypes.UpdateOperationStatusMutation
>;
export const deleteOperationStatus = /* GraphQL */ `mutation DeleteOperationStatus(
  $input: DeleteOperationStatusInput!
  $condition: ModelOperationStatusConditionInput
) {
  deleteOperationStatus(input: $input, condition: $condition) {
    id
    scope
    operation
    name
    status
    startedAt
    heartbeatAt
    endedAt
    attempt
    errorMessage
    correlationId
    metadata
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOperationStatusMutationVariables,
  APITypes.DeleteOperationStatusMutation
>;
export const createDocumentPage = /* GraphQL */ `mutation CreateDocumentPage(
  $input: CreateDocumentPageInput!
  $condition: ModelDocumentPageConditionInput
) {
  createDocumentPage(input: $input, condition: $condition) {
    id
    documentID
    pageNumber
    imageS3Key
    text
    isBlank
    citations {
      items {
        id
        documentPageID
        documentID
        pageNumber
        blockIndex
        text
        bbox {
          yMin
          xMin
          yMax
          xMax
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentPageMutationVariables,
  APITypes.CreateDocumentPageMutation
>;
export const updateDocumentPage = /* GraphQL */ `mutation UpdateDocumentPage(
  $input: UpdateDocumentPageInput!
  $condition: ModelDocumentPageConditionInput
) {
  updateDocumentPage(input: $input, condition: $condition) {
    id
    documentID
    pageNumber
    imageS3Key
    text
    isBlank
    citations {
      items {
        id
        documentPageID
        documentID
        pageNumber
        blockIndex
        text
        bbox {
          yMin
          xMin
          yMax
          xMax
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentPageMutationVariables,
  APITypes.UpdateDocumentPageMutation
>;
export const deleteDocumentPage = /* GraphQL */ `mutation DeleteDocumentPage(
  $input: DeleteDocumentPageInput!
  $condition: ModelDocumentPageConditionInput
) {
  deleteDocumentPage(input: $input, condition: $condition) {
    id
    documentID
    pageNumber
    imageS3Key
    text
    isBlank
    citations {
      items {
        id
        documentPageID
        documentID
        pageNumber
        blockIndex
        text
        bbox {
          yMin
          xMin
          yMax
          xMax
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentPageMutationVariables,
  APITypes.DeleteDocumentPageMutation
>;
export const createDocumentSegmentInterval = /* GraphQL */ `mutation CreateDocumentSegmentInterval(
  $input: CreateDocumentSegmentIntervalInput!
  $condition: ModelDocumentSegmentIntervalConditionInput
) {
  createDocumentSegmentInterval(input: $input, condition: $condition) {
    id
    documentID
    startPageNumber
    endPageNumber
    startLineNumber
    endLineNumber
    confidence
    confidenceReasoning
    edited
    needsReSummary
    archived
    parentIntervals
    lastEditAction
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentSegmentIntervalMutationVariables,
  APITypes.CreateDocumentSegmentIntervalMutation
>;
export const updateDocumentSegmentInterval = /* GraphQL */ `mutation UpdateDocumentSegmentInterval(
  $input: UpdateDocumentSegmentIntervalInput!
  $condition: ModelDocumentSegmentIntervalConditionInput
) {
  updateDocumentSegmentInterval(input: $input, condition: $condition) {
    id
    documentID
    startPageNumber
    endPageNumber
    startLineNumber
    endLineNumber
    confidence
    confidenceReasoning
    edited
    needsReSummary
    archived
    parentIntervals
    lastEditAction
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentSegmentIntervalMutationVariables,
  APITypes.UpdateDocumentSegmentIntervalMutation
>;
export const deleteDocumentSegmentInterval = /* GraphQL */ `mutation DeleteDocumentSegmentInterval(
  $input: DeleteDocumentSegmentIntervalInput!
  $condition: ModelDocumentSegmentIntervalConditionInput
) {
  deleteDocumentSegmentInterval(input: $input, condition: $condition) {
    id
    documentID
    startPageNumber
    endPageNumber
    startLineNumber
    endLineNumber
    confidence
    confidenceReasoning
    edited
    needsReSummary
    archived
    parentIntervals
    lastEditAction
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentSegmentIntervalMutationVariables,
  APITypes.DeleteDocumentSegmentIntervalMutation
>;
export const createAudio = /* GraphQL */ `mutation CreateAudio(
  $input: CreateAudioInput!
  $condition: ModelAudioConditionInput
) {
  createAudio(input: $input, condition: $condition) {
    id
    uploadedFileID
    executionArn
    fileFormat
    durationSeconds
    transcript {
      bucket
      key
      __typename
    }
    transcriptWordCount
    transcriptGrammarCorrected {
      bucket
      key
      __typename
    }
    transcriptGrammarCorrectedWordCount
    transcriptPreview {
      bucket
      key
      __typename
    }
    detectedLanguages
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAudioMutationVariables,
  APITypes.CreateAudioMutation
>;
export const updateAudio = /* GraphQL */ `mutation UpdateAudio(
  $input: UpdateAudioInput!
  $condition: ModelAudioConditionInput
) {
  updateAudio(input: $input, condition: $condition) {
    id
    uploadedFileID
    executionArn
    fileFormat
    durationSeconds
    transcript {
      bucket
      key
      __typename
    }
    transcriptWordCount
    transcriptGrammarCorrected {
      bucket
      key
      __typename
    }
    transcriptGrammarCorrectedWordCount
    transcriptPreview {
      bucket
      key
      __typename
    }
    detectedLanguages
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAudioMutationVariables,
  APITypes.UpdateAudioMutation
>;
export const deleteAudio = /* GraphQL */ `mutation DeleteAudio(
  $input: DeleteAudioInput!
  $condition: ModelAudioConditionInput
) {
  deleteAudio(input: $input, condition: $condition) {
    id
    uploadedFileID
    executionArn
    fileFormat
    durationSeconds
    transcript {
      bucket
      key
      __typename
    }
    transcriptWordCount
    transcriptGrammarCorrected {
      bucket
      key
      __typename
    }
    transcriptGrammarCorrectedWordCount
    transcriptPreview {
      bucket
      key
      __typename
    }
    detectedLanguages
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAudioMutationVariables,
  APITypes.DeleteAudioMutation
>;
export const createHistoryTranscript = /* GraphQL */ `mutation CreateHistoryTranscript(
  $input: CreateHistoryTranscriptInput!
  $condition: ModelHistoryTranscriptConditionInput
) {
  createHistoryTranscript(input: $input, condition: $condition) {
    id
    uploadedFileID
    callId
    recordingId
    callStartTime
    callDurationSeconds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHistoryTranscriptMutationVariables,
  APITypes.CreateHistoryTranscriptMutation
>;
export const updateHistoryTranscript = /* GraphQL */ `mutation UpdateHistoryTranscript(
  $input: UpdateHistoryTranscriptInput!
  $condition: ModelHistoryTranscriptConditionInput
) {
  updateHistoryTranscript(input: $input, condition: $condition) {
    id
    uploadedFileID
    callId
    recordingId
    callStartTime
    callDurationSeconds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHistoryTranscriptMutationVariables,
  APITypes.UpdateHistoryTranscriptMutation
>;
export const deleteHistoryTranscript = /* GraphQL */ `mutation DeleteHistoryTranscript(
  $input: DeleteHistoryTranscriptInput!
  $condition: ModelHistoryTranscriptConditionInput
) {
  deleteHistoryTranscript(input: $input, condition: $condition) {
    id
    uploadedFileID
    callId
    recordingId
    callStartTime
    callDurationSeconds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHistoryTranscriptMutationVariables,
  APITypes.DeleteHistoryTranscriptMutation
>;
export const createPanelFile = /* GraphQL */ `mutation CreatePanelFile(
  $input: CreatePanelFileInput!
  $condition: ModelPanelFileConditionInput
) {
  createPanelFile(input: $input, condition: $condition) {
    id
    uploadedFileID
    sourceAppointmentID
    correlationId
    panelNumber
    panelIssueDate
    numberOfRequests
    requestingParty
    claim {
      claimNumber
      dateOfInjury
      __typename
    }
    patient {
      name
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    employer {
      name
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    adjuster {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    applicantAttorney {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    defenseAttorney {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    physicians {
      name
      specialty
      address {
        street
        city
        state
        zip
        __typename
      }
      yearsInPractice
      education
      phoneNumber
      isStruck
      strikeDate
      strikeParty
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePanelFileMutationVariables,
  APITypes.CreatePanelFileMutation
>;
export const updatePanelFile = /* GraphQL */ `mutation UpdatePanelFile(
  $input: UpdatePanelFileInput!
  $condition: ModelPanelFileConditionInput
) {
  updatePanelFile(input: $input, condition: $condition) {
    id
    uploadedFileID
    sourceAppointmentID
    correlationId
    panelNumber
    panelIssueDate
    numberOfRequests
    requestingParty
    claim {
      claimNumber
      dateOfInjury
      __typename
    }
    patient {
      name
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    employer {
      name
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    adjuster {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    applicantAttorney {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    defenseAttorney {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    physicians {
      name
      specialty
      address {
        street
        city
        state
        zip
        __typename
      }
      yearsInPractice
      education
      phoneNumber
      isStruck
      strikeDate
      strikeParty
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePanelFileMutationVariables,
  APITypes.UpdatePanelFileMutation
>;
export const deletePanelFile = /* GraphQL */ `mutation DeletePanelFile(
  $input: DeletePanelFileInput!
  $condition: ModelPanelFileConditionInput
) {
  deletePanelFile(input: $input, condition: $condition) {
    id
    uploadedFileID
    sourceAppointmentID
    correlationId
    panelNumber
    panelIssueDate
    numberOfRequests
    requestingParty
    claim {
      claimNumber
      dateOfInjury
      __typename
    }
    patient {
      name
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    employer {
      name
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    adjuster {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    applicantAttorney {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    defenseAttorney {
      name
      company
      address {
        street
        city
        state
        zip
        __typename
      }
      __typename
    }
    physicians {
      name
      specialty
      address {
        street
        city
        state
        zip
        __typename
      }
      yearsInPractice
      education
      phoneNumber
      isStruck
      strikeDate
      strikeParty
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePanelFileMutationVariables,
  APITypes.DeletePanelFileMutation
>;
export const createNotes = /* GraphQL */ `mutation CreateNotes(
  $input: CreateNotesInput!
  $condition: ModelNotesConditionInput
) {
  createNotes(input: $input, condition: $condition) {
    id
    content
    author {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    type
    timeStamp
    appointmentrecordID
    createdAt
    updatedAt
    notesAuthorId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotesMutationVariables,
  APITypes.CreateNotesMutation
>;
export const updateNotes = /* GraphQL */ `mutation UpdateNotes(
  $input: UpdateNotesInput!
  $condition: ModelNotesConditionInput
) {
  updateNotes(input: $input, condition: $condition) {
    id
    content
    author {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    type
    timeStamp
    appointmentrecordID
    createdAt
    updatedAt
    notesAuthorId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotesMutationVariables,
  APITypes.UpdateNotesMutation
>;
export const deleteNotes = /* GraphQL */ `mutation DeleteNotes(
  $input: DeleteNotesInput!
  $condition: ModelNotesConditionInput
) {
  deleteNotes(input: $input, condition: $condition) {
    id
    content
    author {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    type
    timeStamp
    appointmentrecordID
    createdAt
    updatedAt
    notesAuthorId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotesMutationVariables,
  APITypes.DeleteNotesMutation
>;
export const createHuddleNote = /* GraphQL */ `mutation CreateHuddleNote(
  $input: CreateHuddleNoteInput!
  $condition: ModelHuddleNoteConditionInput
) {
  createHuddleNote(input: $input, condition: $condition) {
    id
    appointmentRecordID
    contentMarkdown
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHuddleNoteMutationVariables,
  APITypes.CreateHuddleNoteMutation
>;
export const updateHuddleNote = /* GraphQL */ `mutation UpdateHuddleNote(
  $input: UpdateHuddleNoteInput!
  $condition: ModelHuddleNoteConditionInput
) {
  updateHuddleNote(input: $input, condition: $condition) {
    id
    appointmentRecordID
    contentMarkdown
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHuddleNoteMutationVariables,
  APITypes.UpdateHuddleNoteMutation
>;
export const deleteHuddleNote = /* GraphQL */ `mutation DeleteHuddleNote(
  $input: DeleteHuddleNoteInput!
  $condition: ModelHuddleNoteConditionInput
) {
  deleteHuddleNote(input: $input, condition: $condition) {
    id
    appointmentRecordID
    contentMarkdown
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHuddleNoteMutationVariables,
  APITypes.DeleteHuddleNoteMutation
>;
export const createMedicalAssistant = /* GraphQL */ `mutation CreateMedicalAssistant(
  $input: CreateMedicalAssistantInput!
  $condition: ModelMedicalAssistantConditionInput
) {
  createMedicalAssistant(input: $input, condition: $condition) {
    id
    name
    email
    preVisitCallScheduleLink
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    enableCalendarNotify
    inactive
    languages
    assignmentCriteria {
      languageWeights {
        language
        weight
        doctorSpecialty
        __typename
      }
      __typename
    }
    isDemo
    dismissedProTips
    phoneNumber
    joinedDate
    level
    capacityPercent
    supportedDoctors {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    supportedSpecialtyCategories {
      items {
        id
        medicalAssistantId
        specialtyCategoryId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        specialtyCategory {
          id
          name
          specialties
          createdAt
          updatedAt
          specialtyCategoryFallbackMAId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    availabilityExceptions {
      type
      during {
        start
        end
        __typename
      }
      startTime
      endTime
      allDay
      __typename
    }
    roles
    createdAt
    updatedAt
    medicalAssistantUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMedicalAssistantMutationVariables,
  APITypes.CreateMedicalAssistantMutation
>;
export const updateMedicalAssistant = /* GraphQL */ `mutation UpdateMedicalAssistant(
  $input: UpdateMedicalAssistantInput!
  $condition: ModelMedicalAssistantConditionInput
) {
  updateMedicalAssistant(input: $input, condition: $condition) {
    id
    name
    email
    preVisitCallScheduleLink
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    enableCalendarNotify
    inactive
    languages
    assignmentCriteria {
      languageWeights {
        language
        weight
        doctorSpecialty
        __typename
      }
      __typename
    }
    isDemo
    dismissedProTips
    phoneNumber
    joinedDate
    level
    capacityPercent
    supportedDoctors {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    supportedSpecialtyCategories {
      items {
        id
        medicalAssistantId
        specialtyCategoryId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        specialtyCategory {
          id
          name
          specialties
          createdAt
          updatedAt
          specialtyCategoryFallbackMAId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    availabilityExceptions {
      type
      during {
        start
        end
        __typename
      }
      startTime
      endTime
      allDay
      __typename
    }
    roles
    createdAt
    updatedAt
    medicalAssistantUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMedicalAssistantMutationVariables,
  APITypes.UpdateMedicalAssistantMutation
>;
export const deleteMedicalAssistant = /* GraphQL */ `mutation DeleteMedicalAssistant(
  $input: DeleteMedicalAssistantInput!
  $condition: ModelMedicalAssistantConditionInput
) {
  deleteMedicalAssistant(input: $input, condition: $condition) {
    id
    name
    email
    preVisitCallScheduleLink
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    enableCalendarNotify
    inactive
    languages
    assignmentCriteria {
      languageWeights {
        language
        weight
        doctorSpecialty
        __typename
      }
      __typename
    }
    isDemo
    dismissedProTips
    phoneNumber
    joinedDate
    level
    capacityPercent
    supportedDoctors {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    supportedSpecialtyCategories {
      items {
        id
        medicalAssistantId
        specialtyCategoryId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        specialtyCategory {
          id
          name
          specialties
          createdAt
          updatedAt
          specialtyCategoryFallbackMAId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    availabilityExceptions {
      type
      during {
        start
        end
        __typename
      }
      startTime
      endTime
      allDay
      __typename
    }
    roles
    createdAt
    updatedAt
    medicalAssistantUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMedicalAssistantMutationVariables,
  APITypes.DeleteMedicalAssistantMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    cognitoUserId
    avatarUrl
    firstName
    lastName
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    assistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    appointmentFilterPreset {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    onboardingDismissals {
      itemId
      dismissedAt
      __typename
    }
    settings {
      opsChecklistDefaultExpanded
      __typename
    }
    createdAt
    updatedAt
    userDoctorId
    userAssistantId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    cognitoUserId
    avatarUrl
    firstName
    lastName
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    assistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    appointmentFilterPreset {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    onboardingDismissals {
      itemId
      dismissedAt
      __typename
    }
    settings {
      opsChecklistDefaultExpanded
      __typename
    }
    createdAt
    updatedAt
    userDoctorId
    userAssistantId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    cognitoUserId
    avatarUrl
    firstName
    lastName
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    assistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    appointmentFilterPreset {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    onboardingDismissals {
      itemId
      dismissedAt
      __typename
    }
    settings {
      opsChecklistDefaultExpanded
      __typename
    }
    createdAt
    updatedAt
    userDoctorId
    userAssistantId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createStoredAddress = /* GraphQL */ `mutation CreateStoredAddress(
  $input: CreateStoredAddressInput!
  $condition: ModelStoredAddressConditionInput
) {
  createStoredAddress(input: $input, condition: $condition) {
    id
    street
    city
    state
    zip
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStoredAddressMutationVariables,
  APITypes.CreateStoredAddressMutation
>;
export const updateStoredAddress = /* GraphQL */ `mutation UpdateStoredAddress(
  $input: UpdateStoredAddressInput!
  $condition: ModelStoredAddressConditionInput
) {
  updateStoredAddress(input: $input, condition: $condition) {
    id
    street
    city
    state
    zip
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStoredAddressMutationVariables,
  APITypes.UpdateStoredAddressMutation
>;
export const deleteStoredAddress = /* GraphQL */ `mutation DeleteStoredAddress(
  $input: DeleteStoredAddressInput!
  $condition: ModelStoredAddressConditionInput
) {
  deleteStoredAddress(input: $input, condition: $condition) {
    id
    street
    city
    state
    zip
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStoredAddressMutationVariables,
  APITypes.DeleteStoredAddressMutation
>;
export const createStoredFaxNumber = /* GraphQL */ `mutation CreateStoredFaxNumber(
  $input: CreateStoredFaxNumberInput!
  $condition: ModelStoredFaxNumberConditionInput
) {
  createStoredFaxNumber(input: $input, condition: $condition) {
    id
    faxNumber
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStoredFaxNumberMutationVariables,
  APITypes.CreateStoredFaxNumberMutation
>;
export const updateStoredFaxNumber = /* GraphQL */ `mutation UpdateStoredFaxNumber(
  $input: UpdateStoredFaxNumberInput!
  $condition: ModelStoredFaxNumberConditionInput
) {
  updateStoredFaxNumber(input: $input, condition: $condition) {
    id
    faxNumber
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStoredFaxNumberMutationVariables,
  APITypes.UpdateStoredFaxNumberMutation
>;
export const deleteStoredFaxNumber = /* GraphQL */ `mutation DeleteStoredFaxNumber(
  $input: DeleteStoredFaxNumberInput!
  $condition: ModelStoredFaxNumberConditionInput
) {
  deleteStoredFaxNumber(input: $input, condition: $condition) {
    id
    faxNumber
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStoredFaxNumberMutationVariables,
  APITypes.DeleteStoredFaxNumberMutation
>;
export const createStoredPhoneNumber = /* GraphQL */ `mutation CreateStoredPhoneNumber(
  $input: CreateStoredPhoneNumberInput!
  $condition: ModelStoredPhoneNumberConditionInput
) {
  createStoredPhoneNumber(input: $input, condition: $condition) {
    id
    phoneNumber
    extension
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStoredPhoneNumberMutationVariables,
  APITypes.CreateStoredPhoneNumberMutation
>;
export const updateStoredPhoneNumber = /* GraphQL */ `mutation UpdateStoredPhoneNumber(
  $input: UpdateStoredPhoneNumberInput!
  $condition: ModelStoredPhoneNumberConditionInput
) {
  updateStoredPhoneNumber(input: $input, condition: $condition) {
    id
    phoneNumber
    extension
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStoredPhoneNumberMutationVariables,
  APITypes.UpdateStoredPhoneNumberMutation
>;
export const deleteStoredPhoneNumber = /* GraphQL */ `mutation DeleteStoredPhoneNumber(
  $input: DeleteStoredPhoneNumberInput!
  $condition: ModelStoredPhoneNumberConditionInput
) {
  deleteStoredPhoneNumber(input: $input, condition: $condition) {
    id
    phoneNumber
    extension
    insuranceCarrierID
    lawFirmID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStoredPhoneNumberMutationVariables,
  APITypes.DeleteStoredPhoneNumberMutation
>;
export const createFaxJob = /* GraphQL */ `mutation CreateFaxJob(
  $input: CreateFaxJobInput!
  $condition: ModelFaxJobConditionInput
) {
  createFaxJob(input: $input, condition: $condition) {
    id
    appointmentID
    uploadedFileID
    recipientParty
    recipientEntityID
    faxNumber
    iFaxJobId
    status
    failureCode
    failureMessage
    submittedAt
    completedAt
    submittedByUserID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFaxJobMutationVariables,
  APITypes.CreateFaxJobMutation
>;
export const updateFaxJob = /* GraphQL */ `mutation UpdateFaxJob(
  $input: UpdateFaxJobInput!
  $condition: ModelFaxJobConditionInput
) {
  updateFaxJob(input: $input, condition: $condition) {
    id
    appointmentID
    uploadedFileID
    recipientParty
    recipientEntityID
    faxNumber
    iFaxJobId
    status
    failureCode
    failureMessage
    submittedAt
    completedAt
    submittedByUserID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFaxJobMutationVariables,
  APITypes.UpdateFaxJobMutation
>;
export const deleteFaxJob = /* GraphQL */ `mutation DeleteFaxJob(
  $input: DeleteFaxJobInput!
  $condition: ModelFaxJobConditionInput
) {
  deleteFaxJob(input: $input, condition: $condition) {
    id
    appointmentID
    uploadedFileID
    recipientParty
    recipientEntityID
    faxNumber
    iFaxJobId
    status
    failureCode
    failureMessage
    submittedAt
    completedAt
    submittedByUserID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFaxJobMutationVariables,
  APITypes.DeleteFaxJobMutation
>;
export const createN110PartyDelivery = /* GraphQL */ `mutation CreateN110PartyDelivery(
  $input: CreateN110PartyDeliveryInput!
  $condition: ModelN110PartyDeliveryConditionInput
) {
  createN110PartyDelivery(input: $input, condition: $condition) {
    id
    appointmentID
    uploadedFileID
    party
    status
    reason
    driveFileID
    uploadedAt
    submittedByUserID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateN110PartyDeliveryMutationVariables,
  APITypes.CreateN110PartyDeliveryMutation
>;
export const updateN110PartyDelivery = /* GraphQL */ `mutation UpdateN110PartyDelivery(
  $input: UpdateN110PartyDeliveryInput!
  $condition: ModelN110PartyDeliveryConditionInput
) {
  updateN110PartyDelivery(input: $input, condition: $condition) {
    id
    appointmentID
    uploadedFileID
    party
    status
    reason
    driveFileID
    uploadedAt
    submittedByUserID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateN110PartyDeliveryMutationVariables,
  APITypes.UpdateN110PartyDeliveryMutation
>;
export const deleteN110PartyDelivery = /* GraphQL */ `mutation DeleteN110PartyDelivery(
  $input: DeleteN110PartyDeliveryInput!
  $condition: ModelN110PartyDeliveryConditionInput
) {
  deleteN110PartyDelivery(input: $input, condition: $condition) {
    id
    appointmentID
    uploadedFileID
    party
    status
    reason
    driveFileID
    uploadedAt
    submittedByUserID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteN110PartyDeliveryMutationVariables,
  APITypes.DeleteN110PartyDeliveryMutation
>;
export const createInsuranceCarrier = /* GraphQL */ `mutation CreateInsuranceCarrier(
  $input: CreateInsuranceCarrierInput!
  $condition: ModelInsuranceCarrierConditionInput
) {
  createInsuranceCarrier(input: $input, condition: $condition) {
    id
    name
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultEmail
    supportedDomains
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInsuranceCarrierMutationVariables,
  APITypes.CreateInsuranceCarrierMutation
>;
export const updateInsuranceCarrier = /* GraphQL */ `mutation UpdateInsuranceCarrier(
  $input: UpdateInsuranceCarrierInput!
  $condition: ModelInsuranceCarrierConditionInput
) {
  updateInsuranceCarrier(input: $input, condition: $condition) {
    id
    name
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultEmail
    supportedDomains
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInsuranceCarrierMutationVariables,
  APITypes.UpdateInsuranceCarrierMutation
>;
export const deleteInsuranceCarrier = /* GraphQL */ `mutation DeleteInsuranceCarrier(
  $input: DeleteInsuranceCarrierInput!
  $condition: ModelInsuranceCarrierConditionInput
) {
  deleteInsuranceCarrier(input: $input, condition: $condition) {
    id
    name
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultEmail
    supportedDomains
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInsuranceCarrierMutationVariables,
  APITypes.DeleteInsuranceCarrierMutation
>;
export const createLawFirm = /* GraphQL */ `mutation CreateLawFirm(
  $input: CreateLawFirmInput!
  $condition: ModelLawFirmConditionInput
) {
  createLawFirm(input: $input, condition: $condition) {
    id
    name
    type
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultEmail
    supportedDomains
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLawFirmMutationVariables,
  APITypes.CreateLawFirmMutation
>;
export const updateLawFirm = /* GraphQL */ `mutation UpdateLawFirm(
  $input: UpdateLawFirmInput!
  $condition: ModelLawFirmConditionInput
) {
  updateLawFirm(input: $input, condition: $condition) {
    id
    name
    type
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultEmail
    supportedDomains
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLawFirmMutationVariables,
  APITypes.UpdateLawFirmMutation
>;
export const deleteLawFirm = /* GraphQL */ `mutation DeleteLawFirm(
  $input: DeleteLawFirmInput!
  $condition: ModelLawFirmConditionInput
) {
  deleteLawFirm(input: $input, condition: $condition) {
    id
    name
    type
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultEmail
    supportedDomains
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLawFirmMutationVariables,
  APITypes.DeleteLawFirmMutation
>;
export const createCaseRecord = /* GraphQL */ `mutation CreateCaseRecord(
  $input: CreateCaseRecordInput!
  $condition: ModelCaseRecordConditionInput
) {
  createCaseRecord(input: $input, condition: $condition) {
    id
    state
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          appointmentId
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCaseRecordMutationVariables,
  APITypes.CreateCaseRecordMutation
>;
export const updateCaseRecord = /* GraphQL */ `mutation UpdateCaseRecord(
  $input: UpdateCaseRecordInput!
  $condition: ModelCaseRecordConditionInput
) {
  updateCaseRecord(input: $input, condition: $condition) {
    id
    state
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          appointmentId
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCaseRecordMutationVariables,
  APITypes.UpdateCaseRecordMutation
>;
export const deleteCaseRecord = /* GraphQL */ `mutation DeleteCaseRecord(
  $input: DeleteCaseRecordInput!
  $condition: ModelCaseRecordConditionInput
) {
  deleteCaseRecord(input: $input, condition: $condition) {
    id
    state
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          appointmentId
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCaseRecordMutationVariables,
  APITypes.DeleteCaseRecordMutation
>;
export const createAppointmentRecord = /* GraphQL */ `mutation CreateAppointmentRecord(
  $input: CreateAppointmentRecordInput!
  $condition: ModelAppointmentRecordConditionInput
) {
  createAppointmentRecord(input: $input, condition: $condition) {
    id
    doctorOwnerCognitoId
    assistantCognitoIds
    globalPartitionKey
    originalAppointmentID
    supplementalAppointmentIDs
    supplementalSourceAppointmentIDs
    depositionAppointmentIDs
    depositionSourceAppointmentIDs
    rescheduledFromAppointmentID
    rescheduledToAppointmentID
    date
    yearMonth
    doctorYearMonth
    time
    bookedInFlexibleTime
    inquiryDate
    inquiryYearMonth
    type
    doctorID
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    locationID
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    visitForm
    jotformSubmissions {
      id
      receivedAt
      populatedAt
      __typename
    }
    historyTranscriptPopulations {
      uploadedFileID
      populatedAt
      __typename
    }
    active
    durationMinutes
    reportDue
    reportSubmitted
    status
    reportStatus
    paymentStatus
    billingStatus
    difficultyLevel
    scheduler {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    schedulingAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    onSiteOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    reportOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    billingOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    preVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    inquirerInfo {
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      inquiringParty
      name
      inquiryDate
      notification_110_required
      __typename
    }
    notes {
      items {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      nextToken
      __typename
    }
    huddleNote {
      id
      appointmentRecordID
      contentMarkdown
      createdAt
      updatedAt
      __typename
    }
    patientCases {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    employments {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    employmentGaps {
      type
      startDate {
        value
        precision
        __typename
      }
      endDate {
        value
        precision
        __typename
      }
      notes
      __typename
    }
    patientDescribedInjuries
    uploadedFilesSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    uploadedFilesSetID
    referredBy
    s3FileKey
    medicalRecordsReceived
    medicalRecordsBriefingFileID
    medicalRecordsBriefingExecutionArn
    medicalRecordsTotalPagesProcessed
    reportGenerationFileID
    reportGenerationExecutionArn
    reportGenerationGeneratedAt
    historyOfInjuryFileID
    historyOfInjuryGeneratedAt
    evaluationFileID
    assessmentFileID
    depositionPreparationFileID
    documentStatus {
      evaluationPublished
      assessmentPublished
      historyInProgress
      historyPublished
      historyCleaned
      reportPublished
      briefingInProgress
      briefingPublished
      briefingCleaned
      __typename
    }
    cancellationReason
    cancellationRequestedBy
    cancellationRequestedInternally
    cancellationNote
    cancellationDate
    inquiryClosingReason
    inquiryClosingNote
    inquiryClosingDate
    noShowReason
    noShowNote
    reschedulingReason
    reschedulingOthersReason
    reschedulingRequestedBy
    reschedulingRequestedInternally
    reschedulingNote
    reschedulingDate
    interpreter {
      certificateId
      name
      companyName
      phoneNumber
      phoneExtension
      note
      confirmed
      __typename
    }
    historyOfInjuryNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    currentComplaintNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    historyCallDate
    historyCallTime
    historyCallAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    historyCallCompleted
    historyCallCompletedWithoutRecords
    historyCallCompletedOnSite
    historyCallNoShow
    historyCallCalendarEventID
    historyCallCalendarLink
    billingInfo {
      diagnosisMappings {
        code
        pointer
        description
        __typename
      }
      serviceDetails {
        dateOfStart
        dateOfEnd
        place
        emergencyIndicator
        serviceType
        modifiers
        diagnosisPointers
        chargedAmount
        quantity
        amountPaid
        renderingProviderId
        __typename
      }
      totalCharge
      amountPaid
      billingCounter
      billedDate
      paidDate
      correctionDate
      __typename
    }
    caseInfo {
      confirmationEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      recordsFollowupEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      attendanceEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      __typename
    }
    isProd
    isDemo
    primaryPatientCaseID
    calendarEventID
    reportConfiguration {
      history
      physicalExamination
      assessment
      __typename
    }
    workflowExecutions {
      items {
        executionArn
        appointmentRecordID
        type
        status
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    historyOfInjuryInsights {
      id
      appointmentRecordID
      mechanismOfInjury
      employerJobDescription
      injuryCausations {
        injuryType
        dateOfInjury
        dateOfInjuryEnd
        bodyParts
        mechanismOfInjury
        employerJobDescription
        __typename
      }
      currentSymptoms {
        bodyParts
        description
        __typename
      }
      priorSymptomsBeforeCurrentInjury {
        bodyParts
        description
        __typename
      }
      previousSurgeries {
        date
        bodyParts
        type
        __typename
      }
      previousWorkInjuries {
        date
        bodyParts
        description
        __typename
      }
      previousInjuries {
        date
        bodyParts
        description
        __typename
      }
      injuryEmploymentStatus
      currentWorkRestrictionsFromPatient
      activitiesOfDailyLiving
      createdAt
      updatedAt
      __typename
    }
    reviewOfMedicalRecordsInsights {
      id
      appointmentRecordID
      latestDiagnosis {
        bodyPart
        date
        descriptions
        __typename
      }
      diagnosticStudies {
        date
        typeOfStudy
        bodyPart
        impression
        source
        __typename
      }
      treatments {
        discreteTreatment {
          date
          treatmentType
          bodyPart
          description
          __typename
        }
        recurringTreatment {
          year
          treatmentType
          frequency
          description
          __typename
        }
        __typename
      }
      currentWorkRestrictionsFromMedicalRecords
      previousReports {
        date
        reportType
        reportContent
        __typename
      }
      durableMedicalEquipment {
        startDate
        endDate
        bodyParts
        equipmentType
        description
        __typename
      }
      derivedFromDocumentInsightIDs
      derivedAt
      createdAt
      updatedAt
      __typename
    }
    physicalExamInsights {
      id
      appointmentRecordID
      physicalExaminationInfo
      createdAt
      updatedAt
      __typename
    }
    pastInjuryMatrix {
      id
      appointmentRecordID
      preExistingConditions
      familyHistory
      injuryMatrix {
        date
        bodyPart
        status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    briefing {
      id
      logicalBriefingID
      segmentMappings {
        items {
          id
          briefingID
          logicalSegmentID
          publishedSegmentID
          draftSegmentID
          markedForDeletion
          markedForCreation
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      generatedAt
      lastEditedAt
      lastEditedBy
      googleDocExportLink
      googleDocExportedAt
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
        __typename
      }
      editingPresence
      createdAt
      updatedAt
      __typename
    }
    introParagraph {
      id
      appointmentRecordID
      introParagraphText
      sourceRecaps {
        coverLetterRecapID
        uploadedFileID
        recapText
        generatedAt
        __typename
      }
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    impairmentRatingResults {
      ts
      bodyParts
      enabledStrictRating
      enabledPainRating
      enabledAG
      enabledStrengthRating
      enabledDBE
      autoMode
      result
      resultFeedback {
        exists
        isGood
        notes
        __typename
      }
      __typename
    }
    defenseAttorneyPagesDeclaration
    applicantAttorneyPagesDeclaration
    fieldTemplateRef {
      id
      version
      __typename
    }
    dataFieldValuesMappings {
      dataFieldID
      value
      __typename
    }
    physicalEvalTemplateRef {
      id
      version
      __typename
    }
    physicalExamValues {
      sectionID
      questionID
      side
      value
      note
      excluded
      __typename
    }
    physicalExamOtherFindings {
      sectionID
      text
      __typename
    }
    assessment {
      id
      appointmentId
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussedBodyParts
      bodyPartsNotDiscussedReason
      discussions
      diagnoses {
        diagnosis
        icdCode
        evidenceSources
        evidence
        __typename
      }
      bodyPartMMIStatus {
        discussByBodyPart
        allBodyPartsMMI {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        bodyPartMMIStatuses {
          bodyPart
          __typename
        }
        __typename
      }
      workStatus
      markedAsDone
      discussDiagnosesFreeForm
      diagnosesFreeform
      discussCausationFreeForm
      causationFreeForm
      discussMMIImpairmentRatingApportionmentFreeForm
      hasPatientReachedMMIFreeForm
      discussMMIByBodyPartFreeForm
      impairmentRatingByBodyPartFreeForm
      apportionmentByBodyPartFreeForm
      impairmentRatingOtherComments
      apportionmentOtherComments
      assessmentMode
      assessmentFreeForm {
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussions
        diagnosesAndEvidence
        causation
        hasPatientReachedMMI
        discussMMIByBodyPart
        impairmentRatingByBodyPart
        apportionmentByBodyPart
        workStatus
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    assessmentValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    opinionRecap {
      id
      appointmentRecordID
      causation
      diagnosis
      mmiFutureMedicalTreatment
      impairmentRating
      apportionment
      workStatus
      sourceReportFileID
      createdAt
      updatedAt
      __typename
    }
    tempUploadedIntakeFormS3Keys
    featureFlags {
      featureFlagKey
      enabled
      __typename
    }
    opsChecklist {
      panel
      contact_info
      all_parties
      notice_110
      cover_letter
      record_review
      history_call
      history_of_injury
      interpreter_info
      jotform
      deu_100
      final_report
      __typename
    }
    panelUnavailable
    panelSpecialty
    defenseAttorneyNotPresent
    applicantAttorneyNotPresent
    contactUnavailability {
      patient {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      adjuster {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      applicantAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      defenseAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      __typename
    }
    historyValidation {
      id
      appointmentRecordID
      status
      groups {
        id
        title
        status
        issues {
          id
          title
          description
          patientInfoSection
          issueType
          __typename
        }
        __typename
      }
      validatedAt
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    patientHistoryValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    videoCallLink
    additionalTimeslots {
      date
      time
      locationID
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    historyMrrCrossValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    caseID
    briefingModelVersion
    briefingGdocExportLink
    briefingGdocExportedAt
    createdAt
    updatedAt
    appointmentRecordMedicalAssistantId
    appointmentRecordSchedulingAssistantId
    appointmentRecordOnSiteOpId
    appointmentRecordReportOpId
    appointmentRecordBillingOpId
    appointmentRecordPreVisitReviewerId
    appointmentRecordHuddleNoteId
    appointmentRecordHistoryOfInjuryNotesId
    appointmentRecordCurrentComplaintNotesId
    appointmentRecordHistoryCallAssistantId
    appointmentRecordHistoryOfInjuryInsightsId
    appointmentRecordReviewOfMedicalRecordsInsightsId
    appointmentRecordPhysicalExamInsightsId
    appointmentRecordPastInjuryMatrixId
    appointmentRecordBriefingId
    appointmentRecordIntroParagraphId
    appointmentRecordAssessmentId
    appointmentRecordAssessmentValidationId
    appointmentRecordOpinionRecapId
    appointmentRecordHistoryValidationId
    appointmentRecordPatientHistoryValidationId
    appointmentRecordMrrValidationId
    appointmentRecordHistoryMrrCrossValidationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAppointmentRecordMutationVariables,
  APITypes.CreateAppointmentRecordMutation
>;
export const updateAppointmentRecord = /* GraphQL */ `mutation UpdateAppointmentRecord(
  $input: UpdateAppointmentRecordInput!
  $condition: ModelAppointmentRecordConditionInput
) {
  updateAppointmentRecord(input: $input, condition: $condition) {
    id
    doctorOwnerCognitoId
    assistantCognitoIds
    globalPartitionKey
    originalAppointmentID
    supplementalAppointmentIDs
    supplementalSourceAppointmentIDs
    depositionAppointmentIDs
    depositionSourceAppointmentIDs
    rescheduledFromAppointmentID
    rescheduledToAppointmentID
    date
    yearMonth
    doctorYearMonth
    time
    bookedInFlexibleTime
    inquiryDate
    inquiryYearMonth
    type
    doctorID
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    locationID
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    visitForm
    jotformSubmissions {
      id
      receivedAt
      populatedAt
      __typename
    }
    historyTranscriptPopulations {
      uploadedFileID
      populatedAt
      __typename
    }
    active
    durationMinutes
    reportDue
    reportSubmitted
    status
    reportStatus
    paymentStatus
    billingStatus
    difficultyLevel
    scheduler {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    schedulingAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    onSiteOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    reportOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    billingOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    preVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    inquirerInfo {
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      inquiringParty
      name
      inquiryDate
      notification_110_required
      __typename
    }
    notes {
      items {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      nextToken
      __typename
    }
    huddleNote {
      id
      appointmentRecordID
      contentMarkdown
      createdAt
      updatedAt
      __typename
    }
    patientCases {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    employments {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    employmentGaps {
      type
      startDate {
        value
        precision
        __typename
      }
      endDate {
        value
        precision
        __typename
      }
      notes
      __typename
    }
    patientDescribedInjuries
    uploadedFilesSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    uploadedFilesSetID
    referredBy
    s3FileKey
    medicalRecordsReceived
    medicalRecordsBriefingFileID
    medicalRecordsBriefingExecutionArn
    medicalRecordsTotalPagesProcessed
    reportGenerationFileID
    reportGenerationExecutionArn
    reportGenerationGeneratedAt
    historyOfInjuryFileID
    historyOfInjuryGeneratedAt
    evaluationFileID
    assessmentFileID
    depositionPreparationFileID
    documentStatus {
      evaluationPublished
      assessmentPublished
      historyInProgress
      historyPublished
      historyCleaned
      reportPublished
      briefingInProgress
      briefingPublished
      briefingCleaned
      __typename
    }
    cancellationReason
    cancellationRequestedBy
    cancellationRequestedInternally
    cancellationNote
    cancellationDate
    inquiryClosingReason
    inquiryClosingNote
    inquiryClosingDate
    noShowReason
    noShowNote
    reschedulingReason
    reschedulingOthersReason
    reschedulingRequestedBy
    reschedulingRequestedInternally
    reschedulingNote
    reschedulingDate
    interpreter {
      certificateId
      name
      companyName
      phoneNumber
      phoneExtension
      note
      confirmed
      __typename
    }
    historyOfInjuryNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    currentComplaintNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    historyCallDate
    historyCallTime
    historyCallAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    historyCallCompleted
    historyCallCompletedWithoutRecords
    historyCallCompletedOnSite
    historyCallNoShow
    historyCallCalendarEventID
    historyCallCalendarLink
    billingInfo {
      diagnosisMappings {
        code
        pointer
        description
        __typename
      }
      serviceDetails {
        dateOfStart
        dateOfEnd
        place
        emergencyIndicator
        serviceType
        modifiers
        diagnosisPointers
        chargedAmount
        quantity
        amountPaid
        renderingProviderId
        __typename
      }
      totalCharge
      amountPaid
      billingCounter
      billedDate
      paidDate
      correctionDate
      __typename
    }
    caseInfo {
      confirmationEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      recordsFollowupEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      attendanceEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      __typename
    }
    isProd
    isDemo
    primaryPatientCaseID
    calendarEventID
    reportConfiguration {
      history
      physicalExamination
      assessment
      __typename
    }
    workflowExecutions {
      items {
        executionArn
        appointmentRecordID
        type
        status
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    historyOfInjuryInsights {
      id
      appointmentRecordID
      mechanismOfInjury
      employerJobDescription
      injuryCausations {
        injuryType
        dateOfInjury
        dateOfInjuryEnd
        bodyParts
        mechanismOfInjury
        employerJobDescription
        __typename
      }
      currentSymptoms {
        bodyParts
        description
        __typename
      }
      priorSymptomsBeforeCurrentInjury {
        bodyParts
        description
        __typename
      }
      previousSurgeries {
        date
        bodyParts
        type
        __typename
      }
      previousWorkInjuries {
        date
        bodyParts
        description
        __typename
      }
      previousInjuries {
        date
        bodyParts
        description
        __typename
      }
      injuryEmploymentStatus
      currentWorkRestrictionsFromPatient
      activitiesOfDailyLiving
      createdAt
      updatedAt
      __typename
    }
    reviewOfMedicalRecordsInsights {
      id
      appointmentRecordID
      latestDiagnosis {
        bodyPart
        date
        descriptions
        __typename
      }
      diagnosticStudies {
        date
        typeOfStudy
        bodyPart
        impression
        source
        __typename
      }
      treatments {
        discreteTreatment {
          date
          treatmentType
          bodyPart
          description
          __typename
        }
        recurringTreatment {
          year
          treatmentType
          frequency
          description
          __typename
        }
        __typename
      }
      currentWorkRestrictionsFromMedicalRecords
      previousReports {
        date
        reportType
        reportContent
        __typename
      }
      durableMedicalEquipment {
        startDate
        endDate
        bodyParts
        equipmentType
        description
        __typename
      }
      derivedFromDocumentInsightIDs
      derivedAt
      createdAt
      updatedAt
      __typename
    }
    physicalExamInsights {
      id
      appointmentRecordID
      physicalExaminationInfo
      createdAt
      updatedAt
      __typename
    }
    pastInjuryMatrix {
      id
      appointmentRecordID
      preExistingConditions
      familyHistory
      injuryMatrix {
        date
        bodyPart
        status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    briefing {
      id
      logicalBriefingID
      segmentMappings {
        items {
          id
          briefingID
          logicalSegmentID
          publishedSegmentID
          draftSegmentID
          markedForDeletion
          markedForCreation
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      generatedAt
      lastEditedAt
      lastEditedBy
      googleDocExportLink
      googleDocExportedAt
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
        __typename
      }
      editingPresence
      createdAt
      updatedAt
      __typename
    }
    introParagraph {
      id
      appointmentRecordID
      introParagraphText
      sourceRecaps {
        coverLetterRecapID
        uploadedFileID
        recapText
        generatedAt
        __typename
      }
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    impairmentRatingResults {
      ts
      bodyParts
      enabledStrictRating
      enabledPainRating
      enabledAG
      enabledStrengthRating
      enabledDBE
      autoMode
      result
      resultFeedback {
        exists
        isGood
        notes
        __typename
      }
      __typename
    }
    defenseAttorneyPagesDeclaration
    applicantAttorneyPagesDeclaration
    fieldTemplateRef {
      id
      version
      __typename
    }
    dataFieldValuesMappings {
      dataFieldID
      value
      __typename
    }
    physicalEvalTemplateRef {
      id
      version
      __typename
    }
    physicalExamValues {
      sectionID
      questionID
      side
      value
      note
      excluded
      __typename
    }
    physicalExamOtherFindings {
      sectionID
      text
      __typename
    }
    assessment {
      id
      appointmentId
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussedBodyParts
      bodyPartsNotDiscussedReason
      discussions
      diagnoses {
        diagnosis
        icdCode
        evidenceSources
        evidence
        __typename
      }
      bodyPartMMIStatus {
        discussByBodyPart
        allBodyPartsMMI {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        bodyPartMMIStatuses {
          bodyPart
          __typename
        }
        __typename
      }
      workStatus
      markedAsDone
      discussDiagnosesFreeForm
      diagnosesFreeform
      discussCausationFreeForm
      causationFreeForm
      discussMMIImpairmentRatingApportionmentFreeForm
      hasPatientReachedMMIFreeForm
      discussMMIByBodyPartFreeForm
      impairmentRatingByBodyPartFreeForm
      apportionmentByBodyPartFreeForm
      impairmentRatingOtherComments
      apportionmentOtherComments
      assessmentMode
      assessmentFreeForm {
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussions
        diagnosesAndEvidence
        causation
        hasPatientReachedMMI
        discussMMIByBodyPart
        impairmentRatingByBodyPart
        apportionmentByBodyPart
        workStatus
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    assessmentValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    opinionRecap {
      id
      appointmentRecordID
      causation
      diagnosis
      mmiFutureMedicalTreatment
      impairmentRating
      apportionment
      workStatus
      sourceReportFileID
      createdAt
      updatedAt
      __typename
    }
    tempUploadedIntakeFormS3Keys
    featureFlags {
      featureFlagKey
      enabled
      __typename
    }
    opsChecklist {
      panel
      contact_info
      all_parties
      notice_110
      cover_letter
      record_review
      history_call
      history_of_injury
      interpreter_info
      jotform
      deu_100
      final_report
      __typename
    }
    panelUnavailable
    panelSpecialty
    defenseAttorneyNotPresent
    applicantAttorneyNotPresent
    contactUnavailability {
      patient {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      adjuster {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      applicantAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      defenseAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      __typename
    }
    historyValidation {
      id
      appointmentRecordID
      status
      groups {
        id
        title
        status
        issues {
          id
          title
          description
          patientInfoSection
          issueType
          __typename
        }
        __typename
      }
      validatedAt
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    patientHistoryValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    videoCallLink
    additionalTimeslots {
      date
      time
      locationID
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    historyMrrCrossValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    caseID
    briefingModelVersion
    briefingGdocExportLink
    briefingGdocExportedAt
    createdAt
    updatedAt
    appointmentRecordMedicalAssistantId
    appointmentRecordSchedulingAssistantId
    appointmentRecordOnSiteOpId
    appointmentRecordReportOpId
    appointmentRecordBillingOpId
    appointmentRecordPreVisitReviewerId
    appointmentRecordHuddleNoteId
    appointmentRecordHistoryOfInjuryNotesId
    appointmentRecordCurrentComplaintNotesId
    appointmentRecordHistoryCallAssistantId
    appointmentRecordHistoryOfInjuryInsightsId
    appointmentRecordReviewOfMedicalRecordsInsightsId
    appointmentRecordPhysicalExamInsightsId
    appointmentRecordPastInjuryMatrixId
    appointmentRecordBriefingId
    appointmentRecordIntroParagraphId
    appointmentRecordAssessmentId
    appointmentRecordAssessmentValidationId
    appointmentRecordOpinionRecapId
    appointmentRecordHistoryValidationId
    appointmentRecordPatientHistoryValidationId
    appointmentRecordMrrValidationId
    appointmentRecordHistoryMrrCrossValidationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAppointmentRecordMutationVariables,
  APITypes.UpdateAppointmentRecordMutation
>;
export const deleteAppointmentRecord = /* GraphQL */ `mutation DeleteAppointmentRecord(
  $input: DeleteAppointmentRecordInput!
  $condition: ModelAppointmentRecordConditionInput
) {
  deleteAppointmentRecord(input: $input, condition: $condition) {
    id
    doctorOwnerCognitoId
    assistantCognitoIds
    globalPartitionKey
    originalAppointmentID
    supplementalAppointmentIDs
    supplementalSourceAppointmentIDs
    depositionAppointmentIDs
    depositionSourceAppointmentIDs
    rescheduledFromAppointmentID
    rescheduledToAppointmentID
    date
    yearMonth
    doctorYearMonth
    time
    bookedInFlexibleTime
    inquiryDate
    inquiryYearMonth
    type
    doctorID
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    locationID
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    visitForm
    jotformSubmissions {
      id
      receivedAt
      populatedAt
      __typename
    }
    historyTranscriptPopulations {
      uploadedFileID
      populatedAt
      __typename
    }
    active
    durationMinutes
    reportDue
    reportSubmitted
    status
    reportStatus
    paymentStatus
    billingStatus
    difficultyLevel
    scheduler {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    schedulingAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    onSiteOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    reportOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    billingOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    preVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    inquirerInfo {
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      inquiringParty
      name
      inquiryDate
      notification_110_required
      __typename
    }
    notes {
      items {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      nextToken
      __typename
    }
    huddleNote {
      id
      appointmentRecordID
      contentMarkdown
      createdAt
      updatedAt
      __typename
    }
    patientCases {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    employments {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    employmentGaps {
      type
      startDate {
        value
        precision
        __typename
      }
      endDate {
        value
        precision
        __typename
      }
      notes
      __typename
    }
    patientDescribedInjuries
    uploadedFilesSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    uploadedFilesSetID
    referredBy
    s3FileKey
    medicalRecordsReceived
    medicalRecordsBriefingFileID
    medicalRecordsBriefingExecutionArn
    medicalRecordsTotalPagesProcessed
    reportGenerationFileID
    reportGenerationExecutionArn
    reportGenerationGeneratedAt
    historyOfInjuryFileID
    historyOfInjuryGeneratedAt
    evaluationFileID
    assessmentFileID
    depositionPreparationFileID
    documentStatus {
      evaluationPublished
      assessmentPublished
      historyInProgress
      historyPublished
      historyCleaned
      reportPublished
      briefingInProgress
      briefingPublished
      briefingCleaned
      __typename
    }
    cancellationReason
    cancellationRequestedBy
    cancellationRequestedInternally
    cancellationNote
    cancellationDate
    inquiryClosingReason
    inquiryClosingNote
    inquiryClosingDate
    noShowReason
    noShowNote
    reschedulingReason
    reschedulingOthersReason
    reschedulingRequestedBy
    reschedulingRequestedInternally
    reschedulingNote
    reschedulingDate
    interpreter {
      certificateId
      name
      companyName
      phoneNumber
      phoneExtension
      note
      confirmed
      __typename
    }
    historyOfInjuryNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    currentComplaintNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    historyCallDate
    historyCallTime
    historyCallAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    historyCallCompleted
    historyCallCompletedWithoutRecords
    historyCallCompletedOnSite
    historyCallNoShow
    historyCallCalendarEventID
    historyCallCalendarLink
    billingInfo {
      diagnosisMappings {
        code
        pointer
        description
        __typename
      }
      serviceDetails {
        dateOfStart
        dateOfEnd
        place
        emergencyIndicator
        serviceType
        modifiers
        diagnosisPointers
        chargedAmount
        quantity
        amountPaid
        renderingProviderId
        __typename
      }
      totalCharge
      amountPaid
      billingCounter
      billedDate
      paidDate
      correctionDate
      __typename
    }
    caseInfo {
      confirmationEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      recordsFollowupEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      attendanceEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      __typename
    }
    isProd
    isDemo
    primaryPatientCaseID
    calendarEventID
    reportConfiguration {
      history
      physicalExamination
      assessment
      __typename
    }
    workflowExecutions {
      items {
        executionArn
        appointmentRecordID
        type
        status
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    historyOfInjuryInsights {
      id
      appointmentRecordID
      mechanismOfInjury
      employerJobDescription
      injuryCausations {
        injuryType
        dateOfInjury
        dateOfInjuryEnd
        bodyParts
        mechanismOfInjury
        employerJobDescription
        __typename
      }
      currentSymptoms {
        bodyParts
        description
        __typename
      }
      priorSymptomsBeforeCurrentInjury {
        bodyParts
        description
        __typename
      }
      previousSurgeries {
        date
        bodyParts
        type
        __typename
      }
      previousWorkInjuries {
        date
        bodyParts
        description
        __typename
      }
      previousInjuries {
        date
        bodyParts
        description
        __typename
      }
      injuryEmploymentStatus
      currentWorkRestrictionsFromPatient
      activitiesOfDailyLiving
      createdAt
      updatedAt
      __typename
    }
    reviewOfMedicalRecordsInsights {
      id
      appointmentRecordID
      latestDiagnosis {
        bodyPart
        date
        descriptions
        __typename
      }
      diagnosticStudies {
        date
        typeOfStudy
        bodyPart
        impression
        source
        __typename
      }
      treatments {
        discreteTreatment {
          date
          treatmentType
          bodyPart
          description
          __typename
        }
        recurringTreatment {
          year
          treatmentType
          frequency
          description
          __typename
        }
        __typename
      }
      currentWorkRestrictionsFromMedicalRecords
      previousReports {
        date
        reportType
        reportContent
        __typename
      }
      durableMedicalEquipment {
        startDate
        endDate
        bodyParts
        equipmentType
        description
        __typename
      }
      derivedFromDocumentInsightIDs
      derivedAt
      createdAt
      updatedAt
      __typename
    }
    physicalExamInsights {
      id
      appointmentRecordID
      physicalExaminationInfo
      createdAt
      updatedAt
      __typename
    }
    pastInjuryMatrix {
      id
      appointmentRecordID
      preExistingConditions
      familyHistory
      injuryMatrix {
        date
        bodyPart
        status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    briefing {
      id
      logicalBriefingID
      segmentMappings {
        items {
          id
          briefingID
          logicalSegmentID
          publishedSegmentID
          draftSegmentID
          markedForDeletion
          markedForCreation
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      generatedAt
      lastEditedAt
      lastEditedBy
      googleDocExportLink
      googleDocExportedAt
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
        __typename
      }
      editingPresence
      createdAt
      updatedAt
      __typename
    }
    introParagraph {
      id
      appointmentRecordID
      introParagraphText
      sourceRecaps {
        coverLetterRecapID
        uploadedFileID
        recapText
        generatedAt
        __typename
      }
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    impairmentRatingResults {
      ts
      bodyParts
      enabledStrictRating
      enabledPainRating
      enabledAG
      enabledStrengthRating
      enabledDBE
      autoMode
      result
      resultFeedback {
        exists
        isGood
        notes
        __typename
      }
      __typename
    }
    defenseAttorneyPagesDeclaration
    applicantAttorneyPagesDeclaration
    fieldTemplateRef {
      id
      version
      __typename
    }
    dataFieldValuesMappings {
      dataFieldID
      value
      __typename
    }
    physicalEvalTemplateRef {
      id
      version
      __typename
    }
    physicalExamValues {
      sectionID
      questionID
      side
      value
      note
      excluded
      __typename
    }
    physicalExamOtherFindings {
      sectionID
      text
      __typename
    }
    assessment {
      id
      appointmentId
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussedBodyParts
      bodyPartsNotDiscussedReason
      discussions
      diagnoses {
        diagnosis
        icdCode
        evidenceSources
        evidence
        __typename
      }
      bodyPartMMIStatus {
        discussByBodyPart
        allBodyPartsMMI {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        bodyPartMMIStatuses {
          bodyPart
          __typename
        }
        __typename
      }
      workStatus
      markedAsDone
      discussDiagnosesFreeForm
      diagnosesFreeform
      discussCausationFreeForm
      causationFreeForm
      discussMMIImpairmentRatingApportionmentFreeForm
      hasPatientReachedMMIFreeForm
      discussMMIByBodyPartFreeForm
      impairmentRatingByBodyPartFreeForm
      apportionmentByBodyPartFreeForm
      impairmentRatingOtherComments
      apportionmentOtherComments
      assessmentMode
      assessmentFreeForm {
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussions
        diagnosesAndEvidence
        causation
        hasPatientReachedMMI
        discussMMIByBodyPart
        impairmentRatingByBodyPart
        apportionmentByBodyPart
        workStatus
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    assessmentValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    opinionRecap {
      id
      appointmentRecordID
      causation
      diagnosis
      mmiFutureMedicalTreatment
      impairmentRating
      apportionment
      workStatus
      sourceReportFileID
      createdAt
      updatedAt
      __typename
    }
    tempUploadedIntakeFormS3Keys
    featureFlags {
      featureFlagKey
      enabled
      __typename
    }
    opsChecklist {
      panel
      contact_info
      all_parties
      notice_110
      cover_letter
      record_review
      history_call
      history_of_injury
      interpreter_info
      jotform
      deu_100
      final_report
      __typename
    }
    panelUnavailable
    panelSpecialty
    defenseAttorneyNotPresent
    applicantAttorneyNotPresent
    contactUnavailability {
      patient {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      adjuster {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      applicantAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      defenseAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      __typename
    }
    historyValidation {
      id
      appointmentRecordID
      status
      groups {
        id
        title
        status
        issues {
          id
          title
          description
          patientInfoSection
          issueType
          __typename
        }
        __typename
      }
      validatedAt
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    patientHistoryValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    videoCallLink
    additionalTimeslots {
      date
      time
      locationID
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    historyMrrCrossValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    caseID
    briefingModelVersion
    briefingGdocExportLink
    briefingGdocExportedAt
    createdAt
    updatedAt
    appointmentRecordMedicalAssistantId
    appointmentRecordSchedulingAssistantId
    appointmentRecordOnSiteOpId
    appointmentRecordReportOpId
    appointmentRecordBillingOpId
    appointmentRecordPreVisitReviewerId
    appointmentRecordHuddleNoteId
    appointmentRecordHistoryOfInjuryNotesId
    appointmentRecordCurrentComplaintNotesId
    appointmentRecordHistoryCallAssistantId
    appointmentRecordHistoryOfInjuryInsightsId
    appointmentRecordReviewOfMedicalRecordsInsightsId
    appointmentRecordPhysicalExamInsightsId
    appointmentRecordPastInjuryMatrixId
    appointmentRecordBriefingId
    appointmentRecordIntroParagraphId
    appointmentRecordAssessmentId
    appointmentRecordAssessmentValidationId
    appointmentRecordOpinionRecapId
    appointmentRecordHistoryValidationId
    appointmentRecordPatientHistoryValidationId
    appointmentRecordMrrValidationId
    appointmentRecordHistoryMrrCrossValidationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAppointmentRecordMutationVariables,
  APITypes.DeleteAppointmentRecordMutation
>;
export const createPatient = /* GraphQL */ `mutation CreatePatient(
  $input: CreatePatientInput!
  $condition: ModelPatientConditionInput
) {
  createPatient(input: $input, condition: $condition) {
    id
    name
    dateOfBirth
    SSN
    language
    dominantHand
    cases {
      items {
        id
        patientID
        patient {
          id
          name
          dateOfBirth
          SSN
          language
          dominantHand
          occupation
          sex
          weightLb
          createdAt
          updatedAt
          __typename
        }
        claimNumber
        qmePanelNumber
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        injuryInfo {
          injuryType
          injuredBodyParts
          claimedBodyParts
          description
          dateOfInjury
          startDateOfInjury
          __typename
        }
        workersCompInsurance {
          insuranceCarrier
          adjuster
          __typename
        }
        insuranceCarrierID
        insuranceCarrier {
          id
          name
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierAddressID
        insuranceCarrierAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierFaxNumberID
        insuranceCarrierFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierPhoneNumberID
        insuranceCarrierPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        applicantAttorney {
          name
          lawFirmName
          __typename
        }
        applicantAttorneyLawFirmID
        applicantAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyAddressID
        applicantAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyFaxNumberID
        applicantAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyPhoneNumberID
        applicantAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorney {
          name
          lawFirmName
          __typename
        }
        defenseAttorneyLawFirmID
        defenseAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyAddressID
        defenseAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyFaxNumberID
        defenseAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyPhoneNumberID
        defenseAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nurseCaseManager {
          name
          organizationName
          __typename
        }
        ccPerson {
          name
          organizationName
          __typename
        }
        applicantAttorneyCcEmails
        defenseAttorneyCcEmails
        adjusterCcEmails
        scheduledCommsSuppressedParties
        employmentAtInjury {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        WCAB
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    occupation
    sex
    weightLb
    height {
      feet
      inches
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePatientMutationVariables,
  APITypes.CreatePatientMutation
>;
export const updatePatient = /* GraphQL */ `mutation UpdatePatient(
  $input: UpdatePatientInput!
  $condition: ModelPatientConditionInput
) {
  updatePatient(input: $input, condition: $condition) {
    id
    name
    dateOfBirth
    SSN
    language
    dominantHand
    cases {
      items {
        id
        patientID
        patient {
          id
          name
          dateOfBirth
          SSN
          language
          dominantHand
          occupation
          sex
          weightLb
          createdAt
          updatedAt
          __typename
        }
        claimNumber
        qmePanelNumber
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        injuryInfo {
          injuryType
          injuredBodyParts
          claimedBodyParts
          description
          dateOfInjury
          startDateOfInjury
          __typename
        }
        workersCompInsurance {
          insuranceCarrier
          adjuster
          __typename
        }
        insuranceCarrierID
        insuranceCarrier {
          id
          name
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierAddressID
        insuranceCarrierAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierFaxNumberID
        insuranceCarrierFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierPhoneNumberID
        insuranceCarrierPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        applicantAttorney {
          name
          lawFirmName
          __typename
        }
        applicantAttorneyLawFirmID
        applicantAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyAddressID
        applicantAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyFaxNumberID
        applicantAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyPhoneNumberID
        applicantAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorney {
          name
          lawFirmName
          __typename
        }
        defenseAttorneyLawFirmID
        defenseAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyAddressID
        defenseAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyFaxNumberID
        defenseAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyPhoneNumberID
        defenseAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nurseCaseManager {
          name
          organizationName
          __typename
        }
        ccPerson {
          name
          organizationName
          __typename
        }
        applicantAttorneyCcEmails
        defenseAttorneyCcEmails
        adjusterCcEmails
        scheduledCommsSuppressedParties
        employmentAtInjury {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        WCAB
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    occupation
    sex
    weightLb
    height {
      feet
      inches
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePatientMutationVariables,
  APITypes.UpdatePatientMutation
>;
export const deletePatient = /* GraphQL */ `mutation DeletePatient(
  $input: DeletePatientInput!
  $condition: ModelPatientConditionInput
) {
  deletePatient(input: $input, condition: $condition) {
    id
    name
    dateOfBirth
    SSN
    language
    dominantHand
    cases {
      items {
        id
        patientID
        patient {
          id
          name
          dateOfBirth
          SSN
          language
          dominantHand
          occupation
          sex
          weightLb
          createdAt
          updatedAt
          __typename
        }
        claimNumber
        qmePanelNumber
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        injuryInfo {
          injuryType
          injuredBodyParts
          claimedBodyParts
          description
          dateOfInjury
          startDateOfInjury
          __typename
        }
        workersCompInsurance {
          insuranceCarrier
          adjuster
          __typename
        }
        insuranceCarrierID
        insuranceCarrier {
          id
          name
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierAddressID
        insuranceCarrierAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierFaxNumberID
        insuranceCarrierFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        insuranceCarrierPhoneNumberID
        insuranceCarrierPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        applicantAttorney {
          name
          lawFirmName
          __typename
        }
        applicantAttorneyLawFirmID
        applicantAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyAddressID
        applicantAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyFaxNumberID
        applicantAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        applicantAttorneyPhoneNumberID
        applicantAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorney {
          name
          lawFirmName
          __typename
        }
        defenseAttorneyLawFirmID
        defenseAttorneyLawFirm {
          id
          name
          type
          defaultAddressID
          defaultFaxNumberID
          defaultPhoneNumberID
          defaultEmail
          supportedDomains
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyAddressID
        defenseAttorneyAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyFaxNumberID
        defenseAttorneyFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        defenseAttorneyPhoneNumberID
        defenseAttorneyPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nurseCaseManager {
          name
          organizationName
          __typename
        }
        ccPerson {
          name
          organizationName
          __typename
        }
        applicantAttorneyCcEmails
        defenseAttorneyCcEmails
        adjusterCcEmails
        scheduledCommsSuppressedParties
        employmentAtInjury {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        WCAB
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    occupation
    sex
    weightLb
    height {
      feet
      inches
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePatientMutationVariables,
  APITypes.DeletePatientMutation
>;
export const createPatientCase = /* GraphQL */ `mutation CreatePatientCase(
  $input: CreatePatientCaseInput!
  $condition: ModelPatientCaseConditionInput
) {
  createPatientCase(input: $input, condition: $condition) {
    id
    patientID
    patient {
      id
      name
      dateOfBirth
      SSN
      language
      dominantHand
      cases {
        items {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      occupation
      sex
      weightLb
      height {
        feet
        inches
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    claimNumber
    qmePanelNumber
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    injuryInfo {
      injuryType
      injuredBodyParts
      claimedBodyParts
      description
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      startDateOfInjury
      startDateOfInjuryFlexible {
        value
        precision
        __typename
      }
      __typename
    }
    workersCompInsurance {
      insuranceCarrier
      adjuster
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    insuranceCarrierID
    insuranceCarrier {
      id
      name
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierAddressID
    insuranceCarrierAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierFaxNumberID
    insuranceCarrierFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierPhoneNumberID
    insuranceCarrierPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    appointments {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    applicantAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyLawFirmID
    applicantAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyAddressID
    applicantAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyFaxNumberID
    applicantAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyPhoneNumberID
    applicantAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    defenseAttorneyLawFirmID
    defenseAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyAddressID
    defenseAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyFaxNumberID
    defenseAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyPhoneNumberID
    defenseAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nurseCaseManager {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    ccPerson {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyCcEmails
    defenseAttorneyCcEmails
    adjusterCcEmails
    scheduledCommsSuppressedParties
    employmentAtInjury {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    WCAB
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePatientCaseMutationVariables,
  APITypes.CreatePatientCaseMutation
>;
export const updatePatientCase = /* GraphQL */ `mutation UpdatePatientCase(
  $input: UpdatePatientCaseInput!
  $condition: ModelPatientCaseConditionInput
) {
  updatePatientCase(input: $input, condition: $condition) {
    id
    patientID
    patient {
      id
      name
      dateOfBirth
      SSN
      language
      dominantHand
      cases {
        items {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      occupation
      sex
      weightLb
      height {
        feet
        inches
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    claimNumber
    qmePanelNumber
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    injuryInfo {
      injuryType
      injuredBodyParts
      claimedBodyParts
      description
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      startDateOfInjury
      startDateOfInjuryFlexible {
        value
        precision
        __typename
      }
      __typename
    }
    workersCompInsurance {
      insuranceCarrier
      adjuster
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    insuranceCarrierID
    insuranceCarrier {
      id
      name
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierAddressID
    insuranceCarrierAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierFaxNumberID
    insuranceCarrierFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierPhoneNumberID
    insuranceCarrierPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    appointments {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    applicantAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyLawFirmID
    applicantAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyAddressID
    applicantAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyFaxNumberID
    applicantAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyPhoneNumberID
    applicantAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    defenseAttorneyLawFirmID
    defenseAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyAddressID
    defenseAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyFaxNumberID
    defenseAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyPhoneNumberID
    defenseAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nurseCaseManager {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    ccPerson {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyCcEmails
    defenseAttorneyCcEmails
    adjusterCcEmails
    scheduledCommsSuppressedParties
    employmentAtInjury {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    WCAB
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePatientCaseMutationVariables,
  APITypes.UpdatePatientCaseMutation
>;
export const deletePatientCase = /* GraphQL */ `mutation DeletePatientCase(
  $input: DeletePatientCaseInput!
  $condition: ModelPatientCaseConditionInput
) {
  deletePatientCase(input: $input, condition: $condition) {
    id
    patientID
    patient {
      id
      name
      dateOfBirth
      SSN
      language
      dominantHand
      cases {
        items {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      occupation
      sex
      weightLb
      height {
        feet
        inches
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    claimNumber
    qmePanelNumber
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    injuryInfo {
      injuryType
      injuredBodyParts
      claimedBodyParts
      description
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      startDateOfInjury
      startDateOfInjuryFlexible {
        value
        precision
        __typename
      }
      __typename
    }
    workersCompInsurance {
      insuranceCarrier
      adjuster
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    insuranceCarrierID
    insuranceCarrier {
      id
      name
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierAddressID
    insuranceCarrierAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierFaxNumberID
    insuranceCarrierFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierPhoneNumberID
    insuranceCarrierPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    appointments {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    applicantAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyLawFirmID
    applicantAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyAddressID
    applicantAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyFaxNumberID
    applicantAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyPhoneNumberID
    applicantAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    defenseAttorneyLawFirmID
    defenseAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyAddressID
    defenseAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyFaxNumberID
    defenseAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyPhoneNumberID
    defenseAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nurseCaseManager {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    ccPerson {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyCcEmails
    defenseAttorneyCcEmails
    adjusterCcEmails
    scheduledCommsSuppressedParties
    employmentAtInjury {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    WCAB
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePatientCaseMutationVariables,
  APITypes.DeletePatientCaseMutation
>;
export const createDoctor = /* GraphQL */ `mutation CreateDoctor(
  $input: CreateDoctorInput!
  $condition: ModelDoctorConditionInput
) {
  createDoctor(input: $input, condition: $condition) {
    id
    ownerCognitoId
    firstName
    middleName
    lastName
    name
    signatureName
    status
    ramped
    title
    titleExtension
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    officePhone
    cellPhone
    clinicPhone
    workCity
    workState
    collectionRate
    licenseNumber
    licenseRenewalDate
    qmeLicense {
      licenseNumber
      approvalDate
      renewalDate
      __typename
    }
    locations {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    specialties
    npi
    bankingInfo {
      bankEntityName
      accountNumber
      routingNumber
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          appointmentId
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    availabilities {
      generalAvailabilities {
        during {
          start
          end
          __typename
        }
        recurrence
        dayOfWeek
        dayOfMonth
        weekOfMonth
        monthInterval
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      additionalAvailabilities {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      blackoutDates {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      __typename
    }
    availabilitiesNote
    emails
    profileImages {
      type
      name
      order
      s3Prefix
      widthInInches
      heightInInches
      __typename
    }
    qmeReportConfigs {
      hasIntroTitle
      introTemplate
      __typename
    }
    physicalEvalConfigs {
      templates
      __typename
    }
    signatureDepartment
    profileAssetS3Prefix
    calendarPreference {
      mailingList
      showPatientFullName
      showPatientAddress
      showPatientDOB
      showPortalLink
      __typename
    }
    homeOffice {
      county
      state
      __typename
    }
    reportFormatPreferences {
      evaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      reEvaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      supplementalReport {
        sections
        assessmentSubSections
        __typename
      }
      __typename
    }
    evaluationInputPreferences {
      evaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      reEvaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      supplementalReport {
        assessment
        __typename
      }
      __typename
    }
    preferredAssessmentMode
    caseSummaryFields {
      items {
        id
        doctorId
        caseSummaryFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        caseSummaryField {
          id
          name
          default
          description
          summaryPrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    briefingFields {
      items {
        id
        doctorId
        briefingFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        briefingField {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    isDemo
    fieldTemplateId
    templateFolderLink
    physicianPartner {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPrimaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSecondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultScheduler {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPreVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultBillingOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSupplementalReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    supplementalReportOpsAssignments {
      medicalAssistantID
      weightPercentage
      __typename
    }
    supportingMAs {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    defaultAppointmentDurationMinutes {
      qme
      qmeReevaluation
      ime
      deposition
      __typename
    }
    defaultEarlyArrivalTimeMinutes {
      workersComp
      ime
      deposition
      __typename
    }
    assessmentTreatmentOptions
    dismissedProTips
    createdAt
    updatedAt
    doctorPhysicianPartnerId
    doctorDefaultPrimaryOnsiteOpsId
    doctorDefaultSecondaryOnsiteOpsId
    doctorDefaultSchedulerId
    doctorDefaultReportOpsId
    doctorDefaultPreVisitReviewerId
    doctorDefaultBillingOpsId
    doctorDefaultSupplementalReportOpsId
    doctorUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDoctorMutationVariables,
  APITypes.CreateDoctorMutation
>;
export const updateDoctor = /* GraphQL */ `mutation UpdateDoctor(
  $input: UpdateDoctorInput!
  $condition: ModelDoctorConditionInput
) {
  updateDoctor(input: $input, condition: $condition) {
    id
    ownerCognitoId
    firstName
    middleName
    lastName
    name
    signatureName
    status
    ramped
    title
    titleExtension
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    officePhone
    cellPhone
    clinicPhone
    workCity
    workState
    collectionRate
    licenseNumber
    licenseRenewalDate
    qmeLicense {
      licenseNumber
      approvalDate
      renewalDate
      __typename
    }
    locations {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    specialties
    npi
    bankingInfo {
      bankEntityName
      accountNumber
      routingNumber
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          appointmentId
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    availabilities {
      generalAvailabilities {
        during {
          start
          end
          __typename
        }
        recurrence
        dayOfWeek
        dayOfMonth
        weekOfMonth
        monthInterval
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      additionalAvailabilities {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      blackoutDates {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      __typename
    }
    availabilitiesNote
    emails
    profileImages {
      type
      name
      order
      s3Prefix
      widthInInches
      heightInInches
      __typename
    }
    qmeReportConfigs {
      hasIntroTitle
      introTemplate
      __typename
    }
    physicalEvalConfigs {
      templates
      __typename
    }
    signatureDepartment
    profileAssetS3Prefix
    calendarPreference {
      mailingList
      showPatientFullName
      showPatientAddress
      showPatientDOB
      showPortalLink
      __typename
    }
    homeOffice {
      county
      state
      __typename
    }
    reportFormatPreferences {
      evaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      reEvaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      supplementalReport {
        sections
        assessmentSubSections
        __typename
      }
      __typename
    }
    evaluationInputPreferences {
      evaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      reEvaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      supplementalReport {
        assessment
        __typename
      }
      __typename
    }
    preferredAssessmentMode
    caseSummaryFields {
      items {
        id
        doctorId
        caseSummaryFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        caseSummaryField {
          id
          name
          default
          description
          summaryPrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    briefingFields {
      items {
        id
        doctorId
        briefingFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        briefingField {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    isDemo
    fieldTemplateId
    templateFolderLink
    physicianPartner {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPrimaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSecondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultScheduler {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPreVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultBillingOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSupplementalReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    supplementalReportOpsAssignments {
      medicalAssistantID
      weightPercentage
      __typename
    }
    supportingMAs {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    defaultAppointmentDurationMinutes {
      qme
      qmeReevaluation
      ime
      deposition
      __typename
    }
    defaultEarlyArrivalTimeMinutes {
      workersComp
      ime
      deposition
      __typename
    }
    assessmentTreatmentOptions
    dismissedProTips
    createdAt
    updatedAt
    doctorPhysicianPartnerId
    doctorDefaultPrimaryOnsiteOpsId
    doctorDefaultSecondaryOnsiteOpsId
    doctorDefaultSchedulerId
    doctorDefaultReportOpsId
    doctorDefaultPreVisitReviewerId
    doctorDefaultBillingOpsId
    doctorDefaultSupplementalReportOpsId
    doctorUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDoctorMutationVariables,
  APITypes.UpdateDoctorMutation
>;
export const deleteDoctor = /* GraphQL */ `mutation DeleteDoctor(
  $input: DeleteDoctorInput!
  $condition: ModelDoctorConditionInput
) {
  deleteDoctor(input: $input, condition: $condition) {
    id
    ownerCognitoId
    firstName
    middleName
    lastName
    name
    signatureName
    status
    ramped
    title
    titleExtension
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    officePhone
    cellPhone
    clinicPhone
    workCity
    workState
    collectionRate
    licenseNumber
    licenseRenewalDate
    qmeLicense {
      licenseNumber
      approvalDate
      renewalDate
      __typename
    }
    locations {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    specialties
    npi
    bankingInfo {
      bankEntityName
      accountNumber
      routingNumber
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          appointmentId
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    availabilities {
      generalAvailabilities {
        during {
          start
          end
          __typename
        }
        recurrence
        dayOfWeek
        dayOfMonth
        weekOfMonth
        monthInterval
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      additionalAvailabilities {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      blackoutDates {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      __typename
    }
    availabilitiesNote
    emails
    profileImages {
      type
      name
      order
      s3Prefix
      widthInInches
      heightInInches
      __typename
    }
    qmeReportConfigs {
      hasIntroTitle
      introTemplate
      __typename
    }
    physicalEvalConfigs {
      templates
      __typename
    }
    signatureDepartment
    profileAssetS3Prefix
    calendarPreference {
      mailingList
      showPatientFullName
      showPatientAddress
      showPatientDOB
      showPortalLink
      __typename
    }
    homeOffice {
      county
      state
      __typename
    }
    reportFormatPreferences {
      evaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      reEvaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      supplementalReport {
        sections
        assessmentSubSections
        __typename
      }
      __typename
    }
    evaluationInputPreferences {
      evaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      reEvaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      supplementalReport {
        assessment
        __typename
      }
      __typename
    }
    preferredAssessmentMode
    caseSummaryFields {
      items {
        id
        doctorId
        caseSummaryFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        caseSummaryField {
          id
          name
          default
          description
          summaryPrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    briefingFields {
      items {
        id
        doctorId
        briefingFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        briefingField {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    isDemo
    fieldTemplateId
    templateFolderLink
    physicianPartner {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPrimaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSecondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultScheduler {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPreVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultBillingOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSupplementalReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    supplementalReportOpsAssignments {
      medicalAssistantID
      weightPercentage
      __typename
    }
    supportingMAs {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    defaultAppointmentDurationMinutes {
      qme
      qmeReevaluation
      ime
      deposition
      __typename
    }
    defaultEarlyArrivalTimeMinutes {
      workersComp
      ime
      deposition
      __typename
    }
    assessmentTreatmentOptions
    dismissedProTips
    createdAt
    updatedAt
    doctorPhysicianPartnerId
    doctorDefaultPrimaryOnsiteOpsId
    doctorDefaultSecondaryOnsiteOpsId
    doctorDefaultSchedulerId
    doctorDefaultReportOpsId
    doctorDefaultPreVisitReviewerId
    doctorDefaultBillingOpsId
    doctorDefaultSupplementalReportOpsId
    doctorUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDoctorMutationVariables,
  APITypes.DeleteDoctorMutation
>;
export const createLocation = /* GraphQL */ `mutation CreateLocation(
  $input: CreateLocationInput!
  $condition: ModelLocationConditionInput
) {
  createLocation(input: $input, condition: $condition) {
    id
    name
    abbreviation
    status
    region
    address {
      street
      city
      state
      zip
      county
      __typename
    }
    indigoOfficePhoneNumber
    isWaitingArea
    additionalRoomsNumber
    landlordContactInfo {
      name
      phone
      email
      __typename
    }
    calendarCcEmails
    isParkingFree
    parkingRate
    isFrontDoorLocked
    frontDoorCode
    backDoor
    backDoorCode
    securityUnlockingProcess
    securityLockingProcess
    maleBathroomCode
    femaleBathroomCode
    wifiName
    wifiPassword
    defaultOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    secondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    locationInstructionsForVisitor
    additionalNote
    doctors {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          appointmentId
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    locationDefaultOnsiteOpsId
    locationSecondaryOnsiteOpsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLocationMutationVariables,
  APITypes.CreateLocationMutation
>;
export const updateLocation = /* GraphQL */ `mutation UpdateLocation(
  $input: UpdateLocationInput!
  $condition: ModelLocationConditionInput
) {
  updateLocation(input: $input, condition: $condition) {
    id
    name
    abbreviation
    status
    region
    address {
      street
      city
      state
      zip
      county
      __typename
    }
    indigoOfficePhoneNumber
    isWaitingArea
    additionalRoomsNumber
    landlordContactInfo {
      name
      phone
      email
      __typename
    }
    calendarCcEmails
    isParkingFree
    parkingRate
    isFrontDoorLocked
    frontDoorCode
    backDoor
    backDoorCode
    securityUnlockingProcess
    securityLockingProcess
    maleBathroomCode
    femaleBathroomCode
    wifiName
    wifiPassword
    defaultOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    secondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    locationInstructionsForVisitor
    additionalNote
    doctors {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          appointmentId
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    locationDefaultOnsiteOpsId
    locationSecondaryOnsiteOpsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLocationMutationVariables,
  APITypes.UpdateLocationMutation
>;
export const deleteLocation = /* GraphQL */ `mutation DeleteLocation(
  $input: DeleteLocationInput!
  $condition: ModelLocationConditionInput
) {
  deleteLocation(input: $input, condition: $condition) {
    id
    name
    abbreviation
    status
    region
    address {
      street
      city
      state
      zip
      county
      __typename
    }
    indigoOfficePhoneNumber
    isWaitingArea
    additionalRoomsNumber
    landlordContactInfo {
      name
      phone
      email
      __typename
    }
    calendarCcEmails
    isParkingFree
    parkingRate
    isFrontDoorLocked
    frontDoorCode
    backDoor
    backDoorCode
    securityUnlockingProcess
    securityLockingProcess
    maleBathroomCode
    femaleBathroomCode
    wifiName
    wifiPassword
    defaultOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    secondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    locationInstructionsForVisitor
    additionalNote
    doctors {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          appointmentId
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    locationDefaultOnsiteOpsId
    locationSecondaryOnsiteOpsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLocationMutationVariables,
  APITypes.DeleteLocationMutation
>;
export const createWorkflowExecution = /* GraphQL */ `mutation CreateWorkflowExecution(
  $input: CreateWorkflowExecutionInput!
  $condition: ModelWorkflowExecutionConditionInput
) {
  createWorkflowExecution(input: $input, condition: $condition) {
    executionArn
    appointmentRecordID
    type
    status
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkflowExecutionMutationVariables,
  APITypes.CreateWorkflowExecutionMutation
>;
export const updateWorkflowExecution = /* GraphQL */ `mutation UpdateWorkflowExecution(
  $input: UpdateWorkflowExecutionInput!
  $condition: ModelWorkflowExecutionConditionInput
) {
  updateWorkflowExecution(input: $input, condition: $condition) {
    executionArn
    appointmentRecordID
    type
    status
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkflowExecutionMutationVariables,
  APITypes.UpdateWorkflowExecutionMutation
>;
export const deleteWorkflowExecution = /* GraphQL */ `mutation DeleteWorkflowExecution(
  $input: DeleteWorkflowExecutionInput!
  $condition: ModelWorkflowExecutionConditionInput
) {
  deleteWorkflowExecution(input: $input, condition: $condition) {
    executionArn
    appointmentRecordID
    type
    status
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkflowExecutionMutationVariables,
  APITypes.DeleteWorkflowExecutionMutation
>;
export const createHistoryOfInjuryInsights = /* GraphQL */ `mutation CreateHistoryOfInjuryInsights(
  $input: CreateHistoryOfInjuryInsightsInput!
  $condition: ModelHistoryOfInjuryInsightsConditionInput
) {
  createHistoryOfInjuryInsights(input: $input, condition: $condition) {
    id
    appointmentRecordID
    mechanismOfInjury
    employerJobDescription
    injuryCausations {
      injuryType
      dateOfInjury
      dateOfInjuryEnd
      bodyParts
      mechanismOfInjury
      employerJobDescription
      __typename
    }
    currentSymptoms {
      bodyParts
      description
      __typename
    }
    priorSymptomsBeforeCurrentInjury {
      bodyParts
      description
      __typename
    }
    previousSurgeries {
      date
      bodyParts
      type
      __typename
    }
    previousWorkInjuries {
      date
      bodyParts
      description
      __typename
    }
    previousInjuries {
      date
      bodyParts
      description
      __typename
    }
    injuryEmploymentStatus
    currentWorkRestrictionsFromPatient
    activitiesOfDailyLiving
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHistoryOfInjuryInsightsMutationVariables,
  APITypes.CreateHistoryOfInjuryInsightsMutation
>;
export const updateHistoryOfInjuryInsights = /* GraphQL */ `mutation UpdateHistoryOfInjuryInsights(
  $input: UpdateHistoryOfInjuryInsightsInput!
  $condition: ModelHistoryOfInjuryInsightsConditionInput
) {
  updateHistoryOfInjuryInsights(input: $input, condition: $condition) {
    id
    appointmentRecordID
    mechanismOfInjury
    employerJobDescription
    injuryCausations {
      injuryType
      dateOfInjury
      dateOfInjuryEnd
      bodyParts
      mechanismOfInjury
      employerJobDescription
      __typename
    }
    currentSymptoms {
      bodyParts
      description
      __typename
    }
    priorSymptomsBeforeCurrentInjury {
      bodyParts
      description
      __typename
    }
    previousSurgeries {
      date
      bodyParts
      type
      __typename
    }
    previousWorkInjuries {
      date
      bodyParts
      description
      __typename
    }
    previousInjuries {
      date
      bodyParts
      description
      __typename
    }
    injuryEmploymentStatus
    currentWorkRestrictionsFromPatient
    activitiesOfDailyLiving
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHistoryOfInjuryInsightsMutationVariables,
  APITypes.UpdateHistoryOfInjuryInsightsMutation
>;
export const deleteHistoryOfInjuryInsights = /* GraphQL */ `mutation DeleteHistoryOfInjuryInsights(
  $input: DeleteHistoryOfInjuryInsightsInput!
  $condition: ModelHistoryOfInjuryInsightsConditionInput
) {
  deleteHistoryOfInjuryInsights(input: $input, condition: $condition) {
    id
    appointmentRecordID
    mechanismOfInjury
    employerJobDescription
    injuryCausations {
      injuryType
      dateOfInjury
      dateOfInjuryEnd
      bodyParts
      mechanismOfInjury
      employerJobDescription
      __typename
    }
    currentSymptoms {
      bodyParts
      description
      __typename
    }
    priorSymptomsBeforeCurrentInjury {
      bodyParts
      description
      __typename
    }
    previousSurgeries {
      date
      bodyParts
      type
      __typename
    }
    previousWorkInjuries {
      date
      bodyParts
      description
      __typename
    }
    previousInjuries {
      date
      bodyParts
      description
      __typename
    }
    injuryEmploymentStatus
    currentWorkRestrictionsFromPatient
    activitiesOfDailyLiving
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHistoryOfInjuryInsightsMutationVariables,
  APITypes.DeleteHistoryOfInjuryInsightsMutation
>;
export const createOpinionRecap = /* GraphQL */ `mutation CreateOpinionRecap(
  $input: CreateOpinionRecapInput!
  $condition: ModelOpinionRecapConditionInput
) {
  createOpinionRecap(input: $input, condition: $condition) {
    id
    appointmentRecordID
    causation
    diagnosis
    mmiFutureMedicalTreatment
    impairmentRating
    apportionment
    workStatus
    sourceReportFileID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOpinionRecapMutationVariables,
  APITypes.CreateOpinionRecapMutation
>;
export const updateOpinionRecap = /* GraphQL */ `mutation UpdateOpinionRecap(
  $input: UpdateOpinionRecapInput!
  $condition: ModelOpinionRecapConditionInput
) {
  updateOpinionRecap(input: $input, condition: $condition) {
    id
    appointmentRecordID
    causation
    diagnosis
    mmiFutureMedicalTreatment
    impairmentRating
    apportionment
    workStatus
    sourceReportFileID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOpinionRecapMutationVariables,
  APITypes.UpdateOpinionRecapMutation
>;
export const deleteOpinionRecap = /* GraphQL */ `mutation DeleteOpinionRecap(
  $input: DeleteOpinionRecapInput!
  $condition: ModelOpinionRecapConditionInput
) {
  deleteOpinionRecap(input: $input, condition: $condition) {
    id
    appointmentRecordID
    causation
    diagnosis
    mmiFutureMedicalTreatment
    impairmentRating
    apportionment
    workStatus
    sourceReportFileID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOpinionRecapMutationVariables,
  APITypes.DeleteOpinionRecapMutation
>;
export const createReviewOfMedicalRecordsInsights = /* GraphQL */ `mutation CreateReviewOfMedicalRecordsInsights(
  $input: CreateReviewOfMedicalRecordsInsightsInput!
  $condition: ModelReviewOfMedicalRecordsInsightsConditionInput
) {
  createReviewOfMedicalRecordsInsights(input: $input, condition: $condition) {
    id
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    derivedFromDocumentInsightIDs
    derivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReviewOfMedicalRecordsInsightsMutationVariables,
  APITypes.CreateReviewOfMedicalRecordsInsightsMutation
>;
export const updateReviewOfMedicalRecordsInsights = /* GraphQL */ `mutation UpdateReviewOfMedicalRecordsInsights(
  $input: UpdateReviewOfMedicalRecordsInsightsInput!
  $condition: ModelReviewOfMedicalRecordsInsightsConditionInput
) {
  updateReviewOfMedicalRecordsInsights(input: $input, condition: $condition) {
    id
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    derivedFromDocumentInsightIDs
    derivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReviewOfMedicalRecordsInsightsMutationVariables,
  APITypes.UpdateReviewOfMedicalRecordsInsightsMutation
>;
export const deleteReviewOfMedicalRecordsInsights = /* GraphQL */ `mutation DeleteReviewOfMedicalRecordsInsights(
  $input: DeleteReviewOfMedicalRecordsInsightsInput!
  $condition: ModelReviewOfMedicalRecordsInsightsConditionInput
) {
  deleteReviewOfMedicalRecordsInsights(input: $input, condition: $condition) {
    id
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    derivedFromDocumentInsightIDs
    derivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReviewOfMedicalRecordsInsightsMutationVariables,
  APITypes.DeleteReviewOfMedicalRecordsInsightsMutation
>;
export const createDocumentBriefingInsights = /* GraphQL */ `mutation CreateDocumentBriefingInsights(
  $input: CreateDocumentBriefingInsightsInput!
  $condition: ModelDocumentBriefingInsightsConditionInput
) {
  createDocumentBriefingInsights(input: $input, condition: $condition) {
    id
    documentID
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    sourceRecordBriefingID
    generatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentBriefingInsightsMutationVariables,
  APITypes.CreateDocumentBriefingInsightsMutation
>;
export const updateDocumentBriefingInsights = /* GraphQL */ `mutation UpdateDocumentBriefingInsights(
  $input: UpdateDocumentBriefingInsightsInput!
  $condition: ModelDocumentBriefingInsightsConditionInput
) {
  updateDocumentBriefingInsights(input: $input, condition: $condition) {
    id
    documentID
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    sourceRecordBriefingID
    generatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentBriefingInsightsMutationVariables,
  APITypes.UpdateDocumentBriefingInsightsMutation
>;
export const deleteDocumentBriefingInsights = /* GraphQL */ `mutation DeleteDocumentBriefingInsights(
  $input: DeleteDocumentBriefingInsightsInput!
  $condition: ModelDocumentBriefingInsightsConditionInput
) {
  deleteDocumentBriefingInsights(input: $input, condition: $condition) {
    id
    documentID
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    sourceRecordBriefingID
    generatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentBriefingInsightsMutationVariables,
  APITypes.DeleteDocumentBriefingInsightsMutation
>;
export const createPhysicalExamInsights = /* GraphQL */ `mutation CreatePhysicalExamInsights(
  $input: CreatePhysicalExamInsightsInput!
  $condition: ModelPhysicalExamInsightsConditionInput
) {
  createPhysicalExamInsights(input: $input, condition: $condition) {
    id
    appointmentRecordID
    physicalExaminationInfo
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePhysicalExamInsightsMutationVariables,
  APITypes.CreatePhysicalExamInsightsMutation
>;
export const updatePhysicalExamInsights = /* GraphQL */ `mutation UpdatePhysicalExamInsights(
  $input: UpdatePhysicalExamInsightsInput!
  $condition: ModelPhysicalExamInsightsConditionInput
) {
  updatePhysicalExamInsights(input: $input, condition: $condition) {
    id
    appointmentRecordID
    physicalExaminationInfo
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePhysicalExamInsightsMutationVariables,
  APITypes.UpdatePhysicalExamInsightsMutation
>;
export const deletePhysicalExamInsights = /* GraphQL */ `mutation DeletePhysicalExamInsights(
  $input: DeletePhysicalExamInsightsInput!
  $condition: ModelPhysicalExamInsightsConditionInput
) {
  deletePhysicalExamInsights(input: $input, condition: $condition) {
    id
    appointmentRecordID
    physicalExaminationInfo
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePhysicalExamInsightsMutationVariables,
  APITypes.DeletePhysicalExamInsightsMutation
>;
export const createDataField = /* GraphQL */ `mutation CreateDataField(
  $input: CreateDataFieldInput!
  $condition: ModelDataFieldConditionInput
) {
  createDataField(input: $input, condition: $condition) {
    id
    name
    category
    dataType
    default
    description
    sectionID
    section {
      id
      name
      default
      fields {
        items {
          id
          name
          category
          dataType
          default
          description
          sectionID
          migrationKey
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    migrationKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDataFieldMutationVariables,
  APITypes.CreateDataFieldMutation
>;
export const updateDataField = /* GraphQL */ `mutation UpdateDataField(
  $input: UpdateDataFieldInput!
  $condition: ModelDataFieldConditionInput
) {
  updateDataField(input: $input, condition: $condition) {
    id
    name
    category
    dataType
    default
    description
    sectionID
    section {
      id
      name
      default
      fields {
        items {
          id
          name
          category
          dataType
          default
          description
          sectionID
          migrationKey
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    migrationKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDataFieldMutationVariables,
  APITypes.UpdateDataFieldMutation
>;
export const deleteDataField = /* GraphQL */ `mutation DeleteDataField(
  $input: DeleteDataFieldInput!
  $condition: ModelDataFieldConditionInput
) {
  deleteDataField(input: $input, condition: $condition) {
    id
    name
    category
    dataType
    default
    description
    sectionID
    section {
      id
      name
      default
      fields {
        items {
          id
          name
          category
          dataType
          default
          description
          sectionID
          migrationKey
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    migrationKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDataFieldMutationVariables,
  APITypes.DeleteDataFieldMutation
>;
export const createDataFieldSection = /* GraphQL */ `mutation CreateDataFieldSection(
  $input: CreateDataFieldSectionInput!
  $condition: ModelDataFieldSectionConditionInput
) {
  createDataFieldSection(input: $input, condition: $condition) {
    id
    name
    default
    fields {
      items {
        id
        name
        category
        dataType
        default
        description
        sectionID
        section {
          id
          name
          default
          createdAt
          updatedAt
          __typename
        }
        migrationKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDataFieldSectionMutationVariables,
  APITypes.CreateDataFieldSectionMutation
>;
export const updateDataFieldSection = /* GraphQL */ `mutation UpdateDataFieldSection(
  $input: UpdateDataFieldSectionInput!
  $condition: ModelDataFieldSectionConditionInput
) {
  updateDataFieldSection(input: $input, condition: $condition) {
    id
    name
    default
    fields {
      items {
        id
        name
        category
        dataType
        default
        description
        sectionID
        section {
          id
          name
          default
          createdAt
          updatedAt
          __typename
        }
        migrationKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDataFieldSectionMutationVariables,
  APITypes.UpdateDataFieldSectionMutation
>;
export const deleteDataFieldSection = /* GraphQL */ `mutation DeleteDataFieldSection(
  $input: DeleteDataFieldSectionInput!
  $condition: ModelDataFieldSectionConditionInput
) {
  deleteDataFieldSection(input: $input, condition: $condition) {
    id
    name
    default
    fields {
      items {
        id
        name
        category
        dataType
        default
        description
        sectionID
        section {
          id
          name
          default
          createdAt
          updatedAt
          __typename
        }
        migrationKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDataFieldSectionMutationVariables,
  APITypes.DeleteDataFieldSectionMutation
>;
export const createBriefingField = /* GraphQL */ `mutation CreateBriefingField(
  $input: CreateBriefingFieldInput!
  $condition: ModelBriefingFieldConditionInput
) {
  createBriefingField(input: $input, condition: $condition) {
    id
    name
    default
    description
    briefingPrompt
    doctors {
      items {
        id
        doctorId
        briefingFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        briefingField {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    briefingRecordTypeID
    recordType {
      id
      name
      recordType
      description
      default
      classificationPrompt
      recordBasePrompt
      briefingFields {
        items {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBriefingFieldMutationVariables,
  APITypes.CreateBriefingFieldMutation
>;
export const updateBriefingField = /* GraphQL */ `mutation UpdateBriefingField(
  $input: UpdateBriefingFieldInput!
  $condition: ModelBriefingFieldConditionInput
) {
  updateBriefingField(input: $input, condition: $condition) {
    id
    name
    default
    description
    briefingPrompt
    doctors {
      items {
        id
        doctorId
        briefingFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        briefingField {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    briefingRecordTypeID
    recordType {
      id
      name
      recordType
      description
      default
      classificationPrompt
      recordBasePrompt
      briefingFields {
        items {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBriefingFieldMutationVariables,
  APITypes.UpdateBriefingFieldMutation
>;
export const deleteBriefingField = /* GraphQL */ `mutation DeleteBriefingField(
  $input: DeleteBriefingFieldInput!
  $condition: ModelBriefingFieldConditionInput
) {
  deleteBriefingField(input: $input, condition: $condition) {
    id
    name
    default
    description
    briefingPrompt
    doctors {
      items {
        id
        doctorId
        briefingFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        briefingField {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    briefingRecordTypeID
    recordType {
      id
      name
      recordType
      description
      default
      classificationPrompt
      recordBasePrompt
      briefingFields {
        items {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBriefingFieldMutationVariables,
  APITypes.DeleteBriefingFieldMutation
>;
export const createCaseSummaryField = /* GraphQL */ `mutation CreateCaseSummaryField(
  $input: CreateCaseSummaryFieldInput!
  $condition: ModelCaseSummaryFieldConditionInput
) {
  createCaseSummaryField(input: $input, condition: $condition) {
    id
    name
    default
    description
    summaryPrompt
    doctors {
      items {
        id
        doctorId
        caseSummaryFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        caseSummaryField {
          id
          name
          default
          description
          summaryPrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCaseSummaryFieldMutationVariables,
  APITypes.CreateCaseSummaryFieldMutation
>;
export const updateCaseSummaryField = /* GraphQL */ `mutation UpdateCaseSummaryField(
  $input: UpdateCaseSummaryFieldInput!
  $condition: ModelCaseSummaryFieldConditionInput
) {
  updateCaseSummaryField(input: $input, condition: $condition) {
    id
    name
    default
    description
    summaryPrompt
    doctors {
      items {
        id
        doctorId
        caseSummaryFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        caseSummaryField {
          id
          name
          default
          description
          summaryPrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCaseSummaryFieldMutationVariables,
  APITypes.UpdateCaseSummaryFieldMutation
>;
export const deleteCaseSummaryField = /* GraphQL */ `mutation DeleteCaseSummaryField(
  $input: DeleteCaseSummaryFieldInput!
  $condition: ModelCaseSummaryFieldConditionInput
) {
  deleteCaseSummaryField(input: $input, condition: $condition) {
    id
    name
    default
    description
    summaryPrompt
    doctors {
      items {
        id
        doctorId
        caseSummaryFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        caseSummaryField {
          id
          name
          default
          description
          summaryPrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCaseSummaryFieldMutationVariables,
  APITypes.DeleteCaseSummaryFieldMutation
>;
export const createPastInjuryMatrix = /* GraphQL */ `mutation CreatePastInjuryMatrix(
  $input: CreatePastInjuryMatrixInput!
  $condition: ModelPastInjuryMatrixConditionInput
) {
  createPastInjuryMatrix(input: $input, condition: $condition) {
    id
    appointmentRecordID
    preExistingConditions
    familyHistory
    injuryMatrix {
      date
      bodyPart
      status
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePastInjuryMatrixMutationVariables,
  APITypes.CreatePastInjuryMatrixMutation
>;
export const updatePastInjuryMatrix = /* GraphQL */ `mutation UpdatePastInjuryMatrix(
  $input: UpdatePastInjuryMatrixInput!
  $condition: ModelPastInjuryMatrixConditionInput
) {
  updatePastInjuryMatrix(input: $input, condition: $condition) {
    id
    appointmentRecordID
    preExistingConditions
    familyHistory
    injuryMatrix {
      date
      bodyPart
      status
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePastInjuryMatrixMutationVariables,
  APITypes.UpdatePastInjuryMatrixMutation
>;
export const deletePastInjuryMatrix = /* GraphQL */ `mutation DeletePastInjuryMatrix(
  $input: DeletePastInjuryMatrixInput!
  $condition: ModelPastInjuryMatrixConditionInput
) {
  deletePastInjuryMatrix(input: $input, condition: $condition) {
    id
    appointmentRecordID
    preExistingConditions
    familyHistory
    injuryMatrix {
      date
      bodyPart
      status
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePastInjuryMatrixMutationVariables,
  APITypes.DeletePastInjuryMatrixMutation
>;
export const createAppointmentFilterPreset = /* GraphQL */ `mutation CreateAppointmentFilterPreset(
  $input: CreateAppointmentFilterPresetInput!
  $condition: ModelAppointmentFilterPresetConditionInput
) {
  createAppointmentFilterPreset(input: $input, condition: $condition) {
    id
    name
    filters {
      type
      values
      __typename
    }
    appliesTo
    view
    users {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAppointmentFilterPresetMutationVariables,
  APITypes.CreateAppointmentFilterPresetMutation
>;
export const updateAppointmentFilterPreset = /* GraphQL */ `mutation UpdateAppointmentFilterPreset(
  $input: UpdateAppointmentFilterPresetInput!
  $condition: ModelAppointmentFilterPresetConditionInput
) {
  updateAppointmentFilterPreset(input: $input, condition: $condition) {
    id
    name
    filters {
      type
      values
      __typename
    }
    appliesTo
    view
    users {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAppointmentFilterPresetMutationVariables,
  APITypes.UpdateAppointmentFilterPresetMutation
>;
export const deleteAppointmentFilterPreset = /* GraphQL */ `mutation DeleteAppointmentFilterPreset(
  $input: DeleteAppointmentFilterPresetInput!
  $condition: ModelAppointmentFilterPresetConditionInput
) {
  deleteAppointmentFilterPreset(input: $input, condition: $condition) {
    id
    name
    filters {
      type
      values
      __typename
    }
    appliesTo
    view
    users {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAppointmentFilterPresetMutationVariables,
  APITypes.DeleteAppointmentFilterPresetMutation
>;
export const createRecordBriefingSegment = /* GraphQL */ `mutation CreateRecordBriefingSegment(
  $input: CreateRecordBriefingSegmentInput!
  $condition: ModelRecordBriefingSegmentConditionInput
) {
  createRecordBriefingSegment(input: $input, condition: $condition) {
    id
    logicalSegmentID
    title
    text
    bodyParts
    injuredBodyParts
    editedBy
    pdfFileName
    sourceTag
    segmentNumber
    sourcePdfS3Key
    startPageNumber
    endPageNumber
    recordType
    extractedDate
    doctorName
    processingModel
    classificationConfidence
    hasDate
    potentialDuplicateID
    needsReview
    status
    documentID
    videoStartTime
    videoEndTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecordBriefingSegmentMutationVariables,
  APITypes.CreateRecordBriefingSegmentMutation
>;
export const updateRecordBriefingSegment = /* GraphQL */ `mutation UpdateRecordBriefingSegment(
  $input: UpdateRecordBriefingSegmentInput!
  $condition: ModelRecordBriefingSegmentConditionInput
) {
  updateRecordBriefingSegment(input: $input, condition: $condition) {
    id
    logicalSegmentID
    title
    text
    bodyParts
    injuredBodyParts
    editedBy
    pdfFileName
    sourceTag
    segmentNumber
    sourcePdfS3Key
    startPageNumber
    endPageNumber
    recordType
    extractedDate
    doctorName
    processingModel
    classificationConfidence
    hasDate
    potentialDuplicateID
    needsReview
    status
    documentID
    videoStartTime
    videoEndTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingSegmentMutationVariables,
  APITypes.UpdateRecordBriefingSegmentMutation
>;
export const deleteRecordBriefingSegment = /* GraphQL */ `mutation DeleteRecordBriefingSegment(
  $input: DeleteRecordBriefingSegmentInput!
  $condition: ModelRecordBriefingSegmentConditionInput
) {
  deleteRecordBriefingSegment(input: $input, condition: $condition) {
    id
    logicalSegmentID
    title
    text
    bodyParts
    injuredBodyParts
    editedBy
    pdfFileName
    sourceTag
    segmentNumber
    sourcePdfS3Key
    startPageNumber
    endPageNumber
    recordType
    extractedDate
    doctorName
    processingModel
    classificationConfidence
    hasDate
    potentialDuplicateID
    needsReview
    status
    documentID
    videoStartTime
    videoEndTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecordBriefingSegmentMutationVariables,
  APITypes.DeleteRecordBriefingSegmentMutation
>;
export const createRecordBriefingSegmentMapping = /* GraphQL */ `mutation CreateRecordBriefingSegmentMapping(
  $input: CreateRecordBriefingSegmentMappingInput!
  $condition: ModelRecordBriefingSegmentMappingConditionInput
) {
  createRecordBriefingSegmentMapping(input: $input, condition: $condition) {
    id
    briefingID
    logicalSegmentID
    publishedSegmentID
    draftSegmentID
    markedForDeletion
    markedForCreation
    publishedSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    draftSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecordBriefingSegmentMappingMutationVariables,
  APITypes.CreateRecordBriefingSegmentMappingMutation
>;
export const updateRecordBriefingSegmentMapping = /* GraphQL */ `mutation UpdateRecordBriefingSegmentMapping(
  $input: UpdateRecordBriefingSegmentMappingInput!
  $condition: ModelRecordBriefingSegmentMappingConditionInput
) {
  updateRecordBriefingSegmentMapping(input: $input, condition: $condition) {
    id
    briefingID
    logicalSegmentID
    publishedSegmentID
    draftSegmentID
    markedForDeletion
    markedForCreation
    publishedSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    draftSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingSegmentMappingMutationVariables,
  APITypes.UpdateRecordBriefingSegmentMappingMutation
>;
export const deleteRecordBriefingSegmentMapping = /* GraphQL */ `mutation DeleteRecordBriefingSegmentMapping(
  $input: DeleteRecordBriefingSegmentMappingInput!
  $condition: ModelRecordBriefingSegmentMappingConditionInput
) {
  deleteRecordBriefingSegmentMapping(input: $input, condition: $condition) {
    id
    briefingID
    logicalSegmentID
    publishedSegmentID
    draftSegmentID
    markedForDeletion
    markedForCreation
    publishedSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    draftSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecordBriefingSegmentMappingMutationVariables,
  APITypes.DeleteRecordBriefingSegmentMappingMutation
>;
export const createRecordBriefing = /* GraphQL */ `mutation CreateRecordBriefing(
  $input: CreateRecordBriefingInput!
  $condition: ModelRecordBriefingConditionInput
) {
  createRecordBriefing(input: $input, condition: $condition) {
    id
    logicalBriefingID
    segmentMappings {
      items {
        id
        briefingID
        logicalSegmentID
        publishedSegmentID
        draftSegmentID
        markedForDeletion
        markedForCreation
        publishedSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        draftSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    generatedAt
    lastEditedAt
    lastEditedBy
    googleDocExportLink
    googleDocExportedAt
    suggestionGeneration {
      status
      jobId
      startedAt
      completedAt
      error
      __typename
    }
    editingPresence
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecordBriefingMutationVariables,
  APITypes.CreateRecordBriefingMutation
>;
export const updateRecordBriefing = /* GraphQL */ `mutation UpdateRecordBriefing(
  $input: UpdateRecordBriefingInput!
  $condition: ModelRecordBriefingConditionInput
) {
  updateRecordBriefing(input: $input, condition: $condition) {
    id
    logicalBriefingID
    segmentMappings {
      items {
        id
        briefingID
        logicalSegmentID
        publishedSegmentID
        draftSegmentID
        markedForDeletion
        markedForCreation
        publishedSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        draftSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    generatedAt
    lastEditedAt
    lastEditedBy
    googleDocExportLink
    googleDocExportedAt
    suggestionGeneration {
      status
      jobId
      startedAt
      completedAt
      error
      __typename
    }
    editingPresence
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingMutationVariables,
  APITypes.UpdateRecordBriefingMutation
>;
export const deleteRecordBriefing = /* GraphQL */ `mutation DeleteRecordBriefing(
  $input: DeleteRecordBriefingInput!
  $condition: ModelRecordBriefingConditionInput
) {
  deleteRecordBriefing(input: $input, condition: $condition) {
    id
    logicalBriefingID
    segmentMappings {
      items {
        id
        briefingID
        logicalSegmentID
        publishedSegmentID
        draftSegmentID
        markedForDeletion
        markedForCreation
        publishedSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        draftSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    generatedAt
    lastEditedAt
    lastEditedBy
    googleDocExportLink
    googleDocExportedAt
    suggestionGeneration {
      status
      jobId
      startedAt
      completedAt
      error
      __typename
    }
    editingPresence
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecordBriefingMutationVariables,
  APITypes.DeleteRecordBriefingMutation
>;
export const createRecordBriefingSegmentAnnotation = /* GraphQL */ `mutation CreateRecordBriefingSegmentAnnotation(
  $input: CreateRecordBriefingSegmentAnnotationInput!
  $condition: ModelRecordBriefingSegmentAnnotationConditionInput
) {
  createRecordBriefingSegmentAnnotation(input: $input, condition: $condition) {
    id
    logicalSegmentID
    isStarred
    isImportant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecordBriefingSegmentAnnotationMutationVariables,
  APITypes.CreateRecordBriefingSegmentAnnotationMutation
>;
export const updateRecordBriefingSegmentAnnotation = /* GraphQL */ `mutation UpdateRecordBriefingSegmentAnnotation(
  $input: UpdateRecordBriefingSegmentAnnotationInput!
  $condition: ModelRecordBriefingSegmentAnnotationConditionInput
) {
  updateRecordBriefingSegmentAnnotation(input: $input, condition: $condition) {
    id
    logicalSegmentID
    isStarred
    isImportant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingSegmentAnnotationMutationVariables,
  APITypes.UpdateRecordBriefingSegmentAnnotationMutation
>;
export const deleteRecordBriefingSegmentAnnotation = /* GraphQL */ `mutation DeleteRecordBriefingSegmentAnnotation(
  $input: DeleteRecordBriefingSegmentAnnotationInput!
  $condition: ModelRecordBriefingSegmentAnnotationConditionInput
) {
  deleteRecordBriefingSegmentAnnotation(input: $input, condition: $condition) {
    id
    logicalSegmentID
    isStarred
    isImportant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecordBriefingSegmentAnnotationMutationVariables,
  APITypes.DeleteRecordBriefingSegmentAnnotationMutation
>;
export const createRecordBriefingSegmentSuggestion = /* GraphQL */ `mutation CreateRecordBriefingSegmentSuggestion(
  $input: CreateRecordBriefingSegmentSuggestionInput!
  $condition: ModelRecordBriefingSegmentSuggestionConditionInput
) {
  createRecordBriefingSegmentSuggestion(input: $input, condition: $condition) {
    id
    briefingID
    logicalSegmentID
    suggestionType
    reason
    reasonDetails
    textRange {
      textToDelete
      occurrenceIndex
      prefixContext
      suffixContext
      __typename
    }
    status
    resolvedBy
    resolvedAt
    seen
    confidence
    relatedSegmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecordBriefingSegmentSuggestionMutationVariables,
  APITypes.CreateRecordBriefingSegmentSuggestionMutation
>;
export const updateRecordBriefingSegmentSuggestion = /* GraphQL */ `mutation UpdateRecordBriefingSegmentSuggestion(
  $input: UpdateRecordBriefingSegmentSuggestionInput!
  $condition: ModelRecordBriefingSegmentSuggestionConditionInput
) {
  updateRecordBriefingSegmentSuggestion(input: $input, condition: $condition) {
    id
    briefingID
    logicalSegmentID
    suggestionType
    reason
    reasonDetails
    textRange {
      textToDelete
      occurrenceIndex
      prefixContext
      suffixContext
      __typename
    }
    status
    resolvedBy
    resolvedAt
    seen
    confidence
    relatedSegmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingSegmentSuggestionMutationVariables,
  APITypes.UpdateRecordBriefingSegmentSuggestionMutation
>;
export const deleteRecordBriefingSegmentSuggestion = /* GraphQL */ `mutation DeleteRecordBriefingSegmentSuggestion(
  $input: DeleteRecordBriefingSegmentSuggestionInput!
  $condition: ModelRecordBriefingSegmentSuggestionConditionInput
) {
  deleteRecordBriefingSegmentSuggestion(input: $input, condition: $condition) {
    id
    briefingID
    logicalSegmentID
    suggestionType
    reason
    reasonDetails
    textRange {
      textToDelete
      occurrenceIndex
      prefixContext
      suffixContext
      __typename
    }
    status
    resolvedBy
    resolvedAt
    seen
    confidence
    relatedSegmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecordBriefingSegmentSuggestionMutationVariables,
  APITypes.DeleteRecordBriefingSegmentSuggestionMutation
>;
export const createSummaryCitation = /* GraphQL */ `mutation CreateSummaryCitation(
  $input: CreateSummaryCitationInput!
  $condition: ModelSummaryCitationConditionInput
) {
  createSummaryCitation(input: $input, condition: $condition) {
    id
    briefingID
    logicalSegmentID
    summaryText
    citationID
    status
    removedBy
    removedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSummaryCitationMutationVariables,
  APITypes.CreateSummaryCitationMutation
>;
export const updateSummaryCitation = /* GraphQL */ `mutation UpdateSummaryCitation(
  $input: UpdateSummaryCitationInput!
  $condition: ModelSummaryCitationConditionInput
) {
  updateSummaryCitation(input: $input, condition: $condition) {
    id
    briefingID
    logicalSegmentID
    summaryText
    citationID
    status
    removedBy
    removedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSummaryCitationMutationVariables,
  APITypes.UpdateSummaryCitationMutation
>;
export const deleteSummaryCitation = /* GraphQL */ `mutation DeleteSummaryCitation(
  $input: DeleteSummaryCitationInput!
  $condition: ModelSummaryCitationConditionInput
) {
  deleteSummaryCitation(input: $input, condition: $condition) {
    id
    briefingID
    logicalSegmentID
    summaryText
    citationID
    status
    removedBy
    removedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSummaryCitationMutationVariables,
  APITypes.DeleteSummaryCitationMutation
>;
export const createSuggestion = /* GraphQL */ `mutation CreateSuggestion(
  $input: CreateSuggestionInput!
  $condition: ModelSuggestionConditionInput
) {
  createSuggestion(input: $input, condition: $condition) {
    id
    appointmentID
    source
    changeType
    resourceURI
    suggestedValue
    existingValue
    rationale
    status
    resolvedByUserID
    resolvedAt
    versionID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSuggestionMutationVariables,
  APITypes.CreateSuggestionMutation
>;
export const updateSuggestion = /* GraphQL */ `mutation UpdateSuggestion(
  $input: UpdateSuggestionInput!
  $condition: ModelSuggestionConditionInput
) {
  updateSuggestion(input: $input, condition: $condition) {
    id
    appointmentID
    source
    changeType
    resourceURI
    suggestedValue
    existingValue
    rationale
    status
    resolvedByUserID
    resolvedAt
    versionID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSuggestionMutationVariables,
  APITypes.UpdateSuggestionMutation
>;
export const deleteSuggestion = /* GraphQL */ `mutation DeleteSuggestion(
  $input: DeleteSuggestionInput!
  $condition: ModelSuggestionConditionInput
) {
  deleteSuggestion(input: $input, condition: $condition) {
    id
    appointmentID
    source
    changeType
    resourceURI
    suggestedValue
    existingValue
    rationale
    status
    resolvedByUserID
    resolvedAt
    versionID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSuggestionMutationVariables,
  APITypes.DeleteSuggestionMutation
>;
export const createOnsiteOpsConfig = /* GraphQL */ `mutation CreateOnsiteOpsConfig(
  $input: CreateOnsiteOpsConfigInput!
  $condition: ModelOnsiteOpsConfigConditionInput
) {
  createOnsiteOpsConfig(input: $input, condition: $condition) {
    doctorLocationKey
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    secondaryMedicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    assignmentEffectiveDate
    createdAt
    updatedAt
    onsiteOpsConfigDoctorId
    onsiteOpsConfigLocationId
    onsiteOpsConfigMedicalAssistantId
    onsiteOpsConfigSecondaryMedicalAssistantId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOnsiteOpsConfigMutationVariables,
  APITypes.CreateOnsiteOpsConfigMutation
>;
export const updateOnsiteOpsConfig = /* GraphQL */ `mutation UpdateOnsiteOpsConfig(
  $input: UpdateOnsiteOpsConfigInput!
  $condition: ModelOnsiteOpsConfigConditionInput
) {
  updateOnsiteOpsConfig(input: $input, condition: $condition) {
    doctorLocationKey
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    secondaryMedicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    assignmentEffectiveDate
    createdAt
    updatedAt
    onsiteOpsConfigDoctorId
    onsiteOpsConfigLocationId
    onsiteOpsConfigMedicalAssistantId
    onsiteOpsConfigSecondaryMedicalAssistantId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOnsiteOpsConfigMutationVariables,
  APITypes.UpdateOnsiteOpsConfigMutation
>;
export const deleteOnsiteOpsConfig = /* GraphQL */ `mutation DeleteOnsiteOpsConfig(
  $input: DeleteOnsiteOpsConfigInput!
  $condition: ModelOnsiteOpsConfigConditionInput
) {
  deleteOnsiteOpsConfig(input: $input, condition: $condition) {
    doctorLocationKey
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    secondaryMedicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    assignmentEffectiveDate
    createdAt
    updatedAt
    onsiteOpsConfigDoctorId
    onsiteOpsConfigLocationId
    onsiteOpsConfigMedicalAssistantId
    onsiteOpsConfigSecondaryMedicalAssistantId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOnsiteOpsConfigMutationVariables,
  APITypes.DeleteOnsiteOpsConfigMutation
>;
export const createOpsGlobalSettings = /* GraphQL */ `mutation CreateOpsGlobalSettings(
  $input: CreateOpsGlobalSettingsInput!
  $condition: ModelOpsGlobalSettingsConditionInput
) {
  createOpsGlobalSettings(input: $input, condition: $condition) {
    key
    inPersonEvaluationPreVisitDurationDays
    supplementalPreVisitDurationDays
    depositionPreVisitDurationDays
    defaultGlobalOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalMA {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalScheduler {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalPreVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalBillingOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    appointmentTypeMAAssignments {
      appointmentType
      maWeights {
        medicalAssistantID
        weightPercentage
        __typename
      }
      __typename
    }
    maAssignmentCapacitySettings {
      level1WeeklyPointBudget
      level2WeeklyPointBudget
      level3WeeklyPointBudget
      level4WeeklyPointBudget
      maxAppointmentsPerMAWeek
      maxAppointmentsPerMADay
      __typename
    }
    bodyPartSpecialtiesMappings {
      bodyPart
      specialties
      __typename
    }
    createdAt
    updatedAt
    opsGlobalSettingsDefaultGlobalOnsiteOpsId
    opsGlobalSettingsDefaultGlobalMAId
    opsGlobalSettingsDefaultGlobalSchedulerId
    opsGlobalSettingsDefaultGlobalReportOpsId
    opsGlobalSettingsDefaultGlobalPreVisitReviewerId
    opsGlobalSettingsDefaultGlobalBillingOpsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOpsGlobalSettingsMutationVariables,
  APITypes.CreateOpsGlobalSettingsMutation
>;
export const updateOpsGlobalSettings = /* GraphQL */ `mutation UpdateOpsGlobalSettings(
  $input: UpdateOpsGlobalSettingsInput!
  $condition: ModelOpsGlobalSettingsConditionInput
) {
  updateOpsGlobalSettings(input: $input, condition: $condition) {
    key
    inPersonEvaluationPreVisitDurationDays
    supplementalPreVisitDurationDays
    depositionPreVisitDurationDays
    defaultGlobalOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalMA {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalScheduler {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalPreVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalBillingOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    appointmentTypeMAAssignments {
      appointmentType
      maWeights {
        medicalAssistantID
        weightPercentage
        __typename
      }
      __typename
    }
    maAssignmentCapacitySettings {
      level1WeeklyPointBudget
      level2WeeklyPointBudget
      level3WeeklyPointBudget
      level4WeeklyPointBudget
      maxAppointmentsPerMAWeek
      maxAppointmentsPerMADay
      __typename
    }
    bodyPartSpecialtiesMappings {
      bodyPart
      specialties
      __typename
    }
    createdAt
    updatedAt
    opsGlobalSettingsDefaultGlobalOnsiteOpsId
    opsGlobalSettingsDefaultGlobalMAId
    opsGlobalSettingsDefaultGlobalSchedulerId
    opsGlobalSettingsDefaultGlobalReportOpsId
    opsGlobalSettingsDefaultGlobalPreVisitReviewerId
    opsGlobalSettingsDefaultGlobalBillingOpsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOpsGlobalSettingsMutationVariables,
  APITypes.UpdateOpsGlobalSettingsMutation
>;
export const deleteOpsGlobalSettings = /* GraphQL */ `mutation DeleteOpsGlobalSettings(
  $input: DeleteOpsGlobalSettingsInput!
  $condition: ModelOpsGlobalSettingsConditionInput
) {
  deleteOpsGlobalSettings(input: $input, condition: $condition) {
    key
    inPersonEvaluationPreVisitDurationDays
    supplementalPreVisitDurationDays
    depositionPreVisitDurationDays
    defaultGlobalOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalMA {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalScheduler {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalPreVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultGlobalBillingOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    appointmentTypeMAAssignments {
      appointmentType
      maWeights {
        medicalAssistantID
        weightPercentage
        __typename
      }
      __typename
    }
    maAssignmentCapacitySettings {
      level1WeeklyPointBudget
      level2WeeklyPointBudget
      level3WeeklyPointBudget
      level4WeeklyPointBudget
      maxAppointmentsPerMAWeek
      maxAppointmentsPerMADay
      __typename
    }
    bodyPartSpecialtiesMappings {
      bodyPart
      specialties
      __typename
    }
    createdAt
    updatedAt
    opsGlobalSettingsDefaultGlobalOnsiteOpsId
    opsGlobalSettingsDefaultGlobalMAId
    opsGlobalSettingsDefaultGlobalSchedulerId
    opsGlobalSettingsDefaultGlobalReportOpsId
    opsGlobalSettingsDefaultGlobalPreVisitReviewerId
    opsGlobalSettingsDefaultGlobalBillingOpsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOpsGlobalSettingsMutationVariables,
  APITypes.DeleteOpsGlobalSettingsMutation
>;
export const createSpecialtyCategory = /* GraphQL */ `mutation CreateSpecialtyCategory(
  $input: CreateSpecialtyCategoryInput!
  $condition: ModelSpecialtyCategoryConditionInput
) {
  createSpecialtyCategory(input: $input, condition: $condition) {
    id
    name
    specialties
    fallbackMA {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    medicalAssistants {
      items {
        id
        medicalAssistantId
        specialtyCategoryId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        specialtyCategory {
          id
          name
          specialties
          createdAt
          updatedAt
          specialtyCategoryFallbackMAId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    specialtyCategoryFallbackMAId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSpecialtyCategoryMutationVariables,
  APITypes.CreateSpecialtyCategoryMutation
>;
export const updateSpecialtyCategory = /* GraphQL */ `mutation UpdateSpecialtyCategory(
  $input: UpdateSpecialtyCategoryInput!
  $condition: ModelSpecialtyCategoryConditionInput
) {
  updateSpecialtyCategory(input: $input, condition: $condition) {
    id
    name
    specialties
    fallbackMA {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    medicalAssistants {
      items {
        id
        medicalAssistantId
        specialtyCategoryId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        specialtyCategory {
          id
          name
          specialties
          createdAt
          updatedAt
          specialtyCategoryFallbackMAId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    specialtyCategoryFallbackMAId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSpecialtyCategoryMutationVariables,
  APITypes.UpdateSpecialtyCategoryMutation
>;
export const deleteSpecialtyCategory = /* GraphQL */ `mutation DeleteSpecialtyCategory(
  $input: DeleteSpecialtyCategoryInput!
  $condition: ModelSpecialtyCategoryConditionInput
) {
  deleteSpecialtyCategory(input: $input, condition: $condition) {
    id
    name
    specialties
    fallbackMA {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    medicalAssistants {
      items {
        id
        medicalAssistantId
        specialtyCategoryId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        specialtyCategory {
          id
          name
          specialties
          createdAt
          updatedAt
          specialtyCategoryFallbackMAId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    specialtyCategoryFallbackMAId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSpecialtyCategoryMutationVariables,
  APITypes.DeleteSpecialtyCategoryMutation
>;
export const createCoverLetterRecap = /* GraphQL */ `mutation CreateCoverLetterRecap(
  $input: CreateCoverLetterRecapInput!
  $condition: ModelCoverLetterRecapConditionInput
) {
  createCoverLetterRecap(input: $input, condition: $condition) {
    id
    uploadedFileID
    recapText
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCoverLetterRecapMutationVariables,
  APITypes.CreateCoverLetterRecapMutation
>;
export const updateCoverLetterRecap = /* GraphQL */ `mutation UpdateCoverLetterRecap(
  $input: UpdateCoverLetterRecapInput!
  $condition: ModelCoverLetterRecapConditionInput
) {
  updateCoverLetterRecap(input: $input, condition: $condition) {
    id
    uploadedFileID
    recapText
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCoverLetterRecapMutationVariables,
  APITypes.UpdateCoverLetterRecapMutation
>;
export const deleteCoverLetterRecap = /* GraphQL */ `mutation DeleteCoverLetterRecap(
  $input: DeleteCoverLetterRecapInput!
  $condition: ModelCoverLetterRecapConditionInput
) {
  deleteCoverLetterRecap(input: $input, condition: $condition) {
    id
    uploadedFileID
    recapText
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCoverLetterRecapMutationVariables,
  APITypes.DeleteCoverLetterRecapMutation
>;
export const createIntroParagraph = /* GraphQL */ `mutation CreateIntroParagraph(
  $input: CreateIntroParagraphInput!
  $condition: ModelIntroParagraphConditionInput
) {
  createIntroParagraph(input: $input, condition: $condition) {
    id
    appointmentRecordID
    introParagraphText
    sourceRecaps {
      coverLetterRecapID
      uploadedFileID
      recapText
      generatedAt
      __typename
    }
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateIntroParagraphMutationVariables,
  APITypes.CreateIntroParagraphMutation
>;
export const updateIntroParagraph = /* GraphQL */ `mutation UpdateIntroParagraph(
  $input: UpdateIntroParagraphInput!
  $condition: ModelIntroParagraphConditionInput
) {
  updateIntroParagraph(input: $input, condition: $condition) {
    id
    appointmentRecordID
    introParagraphText
    sourceRecaps {
      coverLetterRecapID
      uploadedFileID
      recapText
      generatedAt
      __typename
    }
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIntroParagraphMutationVariables,
  APITypes.UpdateIntroParagraphMutation
>;
export const deleteIntroParagraph = /* GraphQL */ `mutation DeleteIntroParagraph(
  $input: DeleteIntroParagraphInput!
  $condition: ModelIntroParagraphConditionInput
) {
  deleteIntroParagraph(input: $input, condition: $condition) {
    id
    appointmentRecordID
    introParagraphText
    sourceRecaps {
      coverLetterRecapID
      uploadedFileID
      recapText
      generatedAt
      __typename
    }
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteIntroParagraphMutationVariables,
  APITypes.DeleteIntroParagraphMutation
>;
export const createIntroductionStatement = /* GraphQL */ `mutation CreateIntroductionStatement(
  $input: CreateIntroductionStatementInput!
  $condition: ModelIntroductionStatementConditionInput
) {
  createIntroductionStatement(input: $input, condition: $condition) {
    id
    appointmentRecordID
    kind
    text
    lastEditedAt
    lastEditedBy
    selectedCoverLetterFileID
    selectionConfirmedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateIntroductionStatementMutationVariables,
  APITypes.CreateIntroductionStatementMutation
>;
export const updateIntroductionStatement = /* GraphQL */ `mutation UpdateIntroductionStatement(
  $input: UpdateIntroductionStatementInput!
  $condition: ModelIntroductionStatementConditionInput
) {
  updateIntroductionStatement(input: $input, condition: $condition) {
    id
    appointmentRecordID
    kind
    text
    lastEditedAt
    lastEditedBy
    selectedCoverLetterFileID
    selectionConfirmedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIntroductionStatementMutationVariables,
  APITypes.UpdateIntroductionStatementMutation
>;
export const deleteIntroductionStatement = /* GraphQL */ `mutation DeleteIntroductionStatement(
  $input: DeleteIntroductionStatementInput!
  $condition: ModelIntroductionStatementConditionInput
) {
  deleteIntroductionStatement(input: $input, condition: $condition) {
    id
    appointmentRecordID
    kind
    text
    lastEditedAt
    lastEditedBy
    selectedCoverLetterFileID
    selectionConfirmedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteIntroductionStatementMutationVariables,
  APITypes.DeleteIntroductionStatementMutation
>;
export const createAssessment = /* GraphQL */ `mutation CreateAssessment(
  $input: CreateAssessmentInput!
  $condition: ModelAssessmentConditionInput
) {
  createAssessment(input: $input, condition: $condition) {
    id
    appointmentId
    injuries {
      injuryType
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      dateOfInjuryEnd
      dateOfInjuryEndFlexible {
        value
        precision
        __typename
      }
      bodyParts
      causeOfInjury
      causedByWork
      causedByWorkExplanation
      __typename
    }
    discussedBodyParts
    bodyPartsNotDiscussedReason
    discussions
    diagnoses {
      diagnosis
      icdCode
      evidenceSources
      evidence
      __typename
    }
    bodyPartMMIStatus {
      discussByBodyPart
      allBodyPartsMMI {
        mmi
        mmiReason
        expectedMMITimeRange
        expectedMMITimeRangeExplanation
        treatments
        treatmentsExplanation
        discussions
        impairmentRating
        impairmentRatingNotApplicable
        deferImpairmentRating
        deferImpairmentRatingReason
        apportionment
        apportionmentNotApplicable
        deferApportionment
        deferApportionmentReason
        __typename
      }
      bodyPartMMIStatuses {
        bodyPart
        evaluation {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        __typename
      }
      __typename
    }
    workStatus
    markedAsDone
    discussDiagnosesFreeForm
    diagnosesFreeform
    discussCausationFreeForm
    causationFreeForm
    discussMMIImpairmentRatingApportionmentFreeForm
    hasPatientReachedMMIFreeForm
    discussMMIByBodyPartFreeForm
    impairmentRatingByBodyPartFreeForm
    apportionmentByBodyPartFreeForm
    impairmentRatingOtherComments
    apportionmentOtherComments
    assessmentMode
    assessmentFreeForm {
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussions
      diagnosesAndEvidence
      causation
      hasPatientReachedMMI
      discussMMIByBodyPart
      impairmentRatingByBodyPart
      apportionmentByBodyPart
      workStatus
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentMutationVariables,
  APITypes.CreateAssessmentMutation
>;
export const updateAssessment = /* GraphQL */ `mutation UpdateAssessment(
  $input: UpdateAssessmentInput!
  $condition: ModelAssessmentConditionInput
) {
  updateAssessment(input: $input, condition: $condition) {
    id
    appointmentId
    injuries {
      injuryType
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      dateOfInjuryEnd
      dateOfInjuryEndFlexible {
        value
        precision
        __typename
      }
      bodyParts
      causeOfInjury
      causedByWork
      causedByWorkExplanation
      __typename
    }
    discussedBodyParts
    bodyPartsNotDiscussedReason
    discussions
    diagnoses {
      diagnosis
      icdCode
      evidenceSources
      evidence
      __typename
    }
    bodyPartMMIStatus {
      discussByBodyPart
      allBodyPartsMMI {
        mmi
        mmiReason
        expectedMMITimeRange
        expectedMMITimeRangeExplanation
        treatments
        treatmentsExplanation
        discussions
        impairmentRating
        impairmentRatingNotApplicable
        deferImpairmentRating
        deferImpairmentRatingReason
        apportionment
        apportionmentNotApplicable
        deferApportionment
        deferApportionmentReason
        __typename
      }
      bodyPartMMIStatuses {
        bodyPart
        evaluation {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        __typename
      }
      __typename
    }
    workStatus
    markedAsDone
    discussDiagnosesFreeForm
    diagnosesFreeform
    discussCausationFreeForm
    causationFreeForm
    discussMMIImpairmentRatingApportionmentFreeForm
    hasPatientReachedMMIFreeForm
    discussMMIByBodyPartFreeForm
    impairmentRatingByBodyPartFreeForm
    apportionmentByBodyPartFreeForm
    impairmentRatingOtherComments
    apportionmentOtherComments
    assessmentMode
    assessmentFreeForm {
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussions
      diagnosesAndEvidence
      causation
      hasPatientReachedMMI
      discussMMIByBodyPart
      impairmentRatingByBodyPart
      apportionmentByBodyPart
      workStatus
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentMutationVariables,
  APITypes.UpdateAssessmentMutation
>;
export const deleteAssessment = /* GraphQL */ `mutation DeleteAssessment(
  $input: DeleteAssessmentInput!
  $condition: ModelAssessmentConditionInput
) {
  deleteAssessment(input: $input, condition: $condition) {
    id
    appointmentId
    injuries {
      injuryType
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      dateOfInjuryEnd
      dateOfInjuryEndFlexible {
        value
        precision
        __typename
      }
      bodyParts
      causeOfInjury
      causedByWork
      causedByWorkExplanation
      __typename
    }
    discussedBodyParts
    bodyPartsNotDiscussedReason
    discussions
    diagnoses {
      diagnosis
      icdCode
      evidenceSources
      evidence
      __typename
    }
    bodyPartMMIStatus {
      discussByBodyPart
      allBodyPartsMMI {
        mmi
        mmiReason
        expectedMMITimeRange
        expectedMMITimeRangeExplanation
        treatments
        treatmentsExplanation
        discussions
        impairmentRating
        impairmentRatingNotApplicable
        deferImpairmentRating
        deferImpairmentRatingReason
        apportionment
        apportionmentNotApplicable
        deferApportionment
        deferApportionmentReason
        __typename
      }
      bodyPartMMIStatuses {
        bodyPart
        evaluation {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        __typename
      }
      __typename
    }
    workStatus
    markedAsDone
    discussDiagnosesFreeForm
    diagnosesFreeform
    discussCausationFreeForm
    causationFreeForm
    discussMMIImpairmentRatingApportionmentFreeForm
    hasPatientReachedMMIFreeForm
    discussMMIByBodyPartFreeForm
    impairmentRatingByBodyPartFreeForm
    apportionmentByBodyPartFreeForm
    impairmentRatingOtherComments
    apportionmentOtherComments
    assessmentMode
    assessmentFreeForm {
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussions
      diagnosesAndEvidence
      causation
      hasPatientReachedMMI
      discussMMIByBodyPart
      impairmentRatingByBodyPart
      apportionmentByBodyPart
      workStatus
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentMutationVariables,
  APITypes.DeleteAssessmentMutation
>;
export const createValidationCheck = /* GraphQL */ `mutation CreateValidationCheck(
  $input: CreateValidationCheckInput!
  $condition: ModelValidationCheckConditionInput
) {
  createValidationCheck(input: $input, condition: $condition) {
    id
    validationID
    checkType
    inputResourceURIs
    status
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateValidationCheckMutationVariables,
  APITypes.CreateValidationCheckMutation
>;
export const updateValidationCheck = /* GraphQL */ `mutation UpdateValidationCheck(
  $input: UpdateValidationCheckInput!
  $condition: ModelValidationCheckConditionInput
) {
  updateValidationCheck(input: $input, condition: $condition) {
    id
    validationID
    checkType
    inputResourceURIs
    status
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateValidationCheckMutationVariables,
  APITypes.UpdateValidationCheckMutation
>;
export const deleteValidationCheck = /* GraphQL */ `mutation DeleteValidationCheck(
  $input: DeleteValidationCheckInput!
  $condition: ModelValidationCheckConditionInput
) {
  deleteValidationCheck(input: $input, condition: $condition) {
    id
    validationID
    checkType
    inputResourceURIs
    status
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteValidationCheckMutationVariables,
  APITypes.DeleteValidationCheckMutation
>;
export const createValidationIssue = /* GraphQL */ `mutation CreateValidationIssue(
  $input: CreateValidationIssueInput!
  $condition: ModelValidationIssueConditionInput
) {
  createValidationIssue(input: $input, condition: $condition) {
    id
    validationID
    validationCheckID
    title
    issue
    status
    resourceURI
    issueGroup
    issueType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateValidationIssueMutationVariables,
  APITypes.CreateValidationIssueMutation
>;
export const updateValidationIssue = /* GraphQL */ `mutation UpdateValidationIssue(
  $input: UpdateValidationIssueInput!
  $condition: ModelValidationIssueConditionInput
) {
  updateValidationIssue(input: $input, condition: $condition) {
    id
    validationID
    validationCheckID
    title
    issue
    status
    resourceURI
    issueGroup
    issueType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateValidationIssueMutationVariables,
  APITypes.UpdateValidationIssueMutation
>;
export const deleteValidationIssue = /* GraphQL */ `mutation DeleteValidationIssue(
  $input: DeleteValidationIssueInput!
  $condition: ModelValidationIssueConditionInput
) {
  deleteValidationIssue(input: $input, condition: $condition) {
    id
    validationID
    validationCheckID
    title
    issue
    status
    resourceURI
    issueGroup
    issueType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteValidationIssueMutationVariables,
  APITypes.DeleteValidationIssueMutation
>;
export const createValidation = /* GraphQL */ `mutation CreateValidation(
  $input: CreateValidationInput!
  $condition: ModelValidationConditionInput
) {
  createValidation(input: $input, condition: $condition) {
    id
    issueGroups
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateValidationMutationVariables,
  APITypes.CreateValidationMutation
>;
export const updateValidation = /* GraphQL */ `mutation UpdateValidation(
  $input: UpdateValidationInput!
  $condition: ModelValidationConditionInput
) {
  updateValidation(input: $input, condition: $condition) {
    id
    issueGroups
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateValidationMutationVariables,
  APITypes.UpdateValidationMutation
>;
export const deleteValidation = /* GraphQL */ `mutation DeleteValidation(
  $input: DeleteValidationInput!
  $condition: ModelValidationConditionInput
) {
  deleteValidation(input: $input, condition: $condition) {
    id
    issueGroups
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteValidationMutationVariables,
  APITypes.DeleteValidationMutation
>;
export const createWorkflowAuditEntry = /* GraphQL */ `mutation CreateWorkflowAuditEntry(
  $input: CreateWorkflowAuditEntryInput!
  $condition: ModelWorkflowAuditEntryConditionInput
) {
  createWorkflowAuditEntry(input: $input, condition: $condition) {
    id
    workflowAuditID
    message
    actorType
    actorID
    entryType
    attachments {
      bucket
      key
      __typename
    }
    relatedActionIDs
    payload
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkflowAuditEntryMutationVariables,
  APITypes.CreateWorkflowAuditEntryMutation
>;
export const updateWorkflowAuditEntry = /* GraphQL */ `mutation UpdateWorkflowAuditEntry(
  $input: UpdateWorkflowAuditEntryInput!
  $condition: ModelWorkflowAuditEntryConditionInput
) {
  updateWorkflowAuditEntry(input: $input, condition: $condition) {
    id
    workflowAuditID
    message
    actorType
    actorID
    entryType
    attachments {
      bucket
      key
      __typename
    }
    relatedActionIDs
    payload
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkflowAuditEntryMutationVariables,
  APITypes.UpdateWorkflowAuditEntryMutation
>;
export const deleteWorkflowAuditEntry = /* GraphQL */ `mutation DeleteWorkflowAuditEntry(
  $input: DeleteWorkflowAuditEntryInput!
  $condition: ModelWorkflowAuditEntryConditionInput
) {
  deleteWorkflowAuditEntry(input: $input, condition: $condition) {
    id
    workflowAuditID
    message
    actorType
    actorID
    entryType
    attachments {
      bucket
      key
      __typename
    }
    relatedActionIDs
    payload
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkflowAuditEntryMutationVariables,
  APITypes.DeleteWorkflowAuditEntryMutation
>;
export const createWorkflowAudit = /* GraphQL */ `mutation CreateWorkflowAudit(
  $input: CreateWorkflowAuditInput!
  $condition: ModelWorkflowAuditConditionInput
) {
  createWorkflowAudit(input: $input, condition: $condition) {
    id
    workflowType
    entityID
    entityType
    appointmentID
    entries {
      items {
        id
        workflowAuditID
        message
        actorType
        actorID
        entryType
        attachments {
          bucket
          key
          __typename
        }
        relatedActionIDs
        payload
        correlationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkflowAuditMutationVariables,
  APITypes.CreateWorkflowAuditMutation
>;
export const updateWorkflowAudit = /* GraphQL */ `mutation UpdateWorkflowAudit(
  $input: UpdateWorkflowAuditInput!
  $condition: ModelWorkflowAuditConditionInput
) {
  updateWorkflowAudit(input: $input, condition: $condition) {
    id
    workflowType
    entityID
    entityType
    appointmentID
    entries {
      items {
        id
        workflowAuditID
        message
        actorType
        actorID
        entryType
        attachments {
          bucket
          key
          __typename
        }
        relatedActionIDs
        payload
        correlationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkflowAuditMutationVariables,
  APITypes.UpdateWorkflowAuditMutation
>;
export const deleteWorkflowAudit = /* GraphQL */ `mutation DeleteWorkflowAudit(
  $input: DeleteWorkflowAuditInput!
  $condition: ModelWorkflowAuditConditionInput
) {
  deleteWorkflowAudit(input: $input, condition: $condition) {
    id
    workflowType
    entityID
    entityType
    appointmentID
    entries {
      items {
        id
        workflowAuditID
        message
        actorType
        actorID
        entryType
        attachments {
          bucket
          key
          __typename
        }
        relatedActionIDs
        payload
        correlationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkflowAuditMutationVariables,
  APITypes.DeleteWorkflowAuditMutation
>;
export const createWorkflowAuditAction = /* GraphQL */ `mutation CreateWorkflowAuditAction(
  $input: CreateWorkflowAuditActionInput!
  $condition: ModelWorkflowAuditActionConditionInput
) {
  createWorkflowAuditAction(input: $input, condition: $condition) {
    id
    workflowAuditID
    appointmentID
    actionType
    status
    payload
    rationale
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkflowAuditActionMutationVariables,
  APITypes.CreateWorkflowAuditActionMutation
>;
export const updateWorkflowAuditAction = /* GraphQL */ `mutation UpdateWorkflowAuditAction(
  $input: UpdateWorkflowAuditActionInput!
  $condition: ModelWorkflowAuditActionConditionInput
) {
  updateWorkflowAuditAction(input: $input, condition: $condition) {
    id
    workflowAuditID
    appointmentID
    actionType
    status
    payload
    rationale
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkflowAuditActionMutationVariables,
  APITypes.UpdateWorkflowAuditActionMutation
>;
export const deleteWorkflowAuditAction = /* GraphQL */ `mutation DeleteWorkflowAuditAction(
  $input: DeleteWorkflowAuditActionInput!
  $condition: ModelWorkflowAuditActionConditionInput
) {
  deleteWorkflowAuditAction(input: $input, condition: $condition) {
    id
    workflowAuditID
    appointmentID
    actionType
    status
    payload
    rationale
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkflowAuditActionMutationVariables,
  APITypes.DeleteWorkflowAuditActionMutation
>;
export const createFormDataDraft = /* GraphQL */ `mutation CreateFormDataDraft(
  $input: CreateFormDataDraftInput!
  $condition: ModelFormDataDraftConditionInput
) {
  createFormDataDraft(input: $input, condition: $condition) {
    id
    timestamp
    formType
    appointmentId
    data
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFormDataDraftMutationVariables,
  APITypes.CreateFormDataDraftMutation
>;
export const updateFormDataDraft = /* GraphQL */ `mutation UpdateFormDataDraft(
  $input: UpdateFormDataDraftInput!
  $condition: ModelFormDataDraftConditionInput
) {
  updateFormDataDraft(input: $input, condition: $condition) {
    id
    timestamp
    formType
    appointmentId
    data
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFormDataDraftMutationVariables,
  APITypes.UpdateFormDataDraftMutation
>;
export const deleteFormDataDraft = /* GraphQL */ `mutation DeleteFormDataDraft(
  $input: DeleteFormDataDraftInput!
  $condition: ModelFormDataDraftConditionInput
) {
  deleteFormDataDraft(input: $input, condition: $condition) {
    id
    timestamp
    formType
    appointmentId
    data
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFormDataDraftMutationVariables,
  APITypes.DeleteFormDataDraftMutation
>;
export const createHistoryValidation = /* GraphQL */ `mutation CreateHistoryValidation(
  $input: CreateHistoryValidationInput!
  $condition: ModelHistoryValidationConditionInput
) {
  createHistoryValidation(input: $input, condition: $condition) {
    id
    appointmentRecordID
    status
    groups {
      id
      title
      status
      issues {
        id
        title
        description
        patientInfoSection
        issueType
        __typename
      }
      __typename
    }
    validatedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHistoryValidationMutationVariables,
  APITypes.CreateHistoryValidationMutation
>;
export const updateHistoryValidation = /* GraphQL */ `mutation UpdateHistoryValidation(
  $input: UpdateHistoryValidationInput!
  $condition: ModelHistoryValidationConditionInput
) {
  updateHistoryValidation(input: $input, condition: $condition) {
    id
    appointmentRecordID
    status
    groups {
      id
      title
      status
      issues {
        id
        title
        description
        patientInfoSection
        issueType
        __typename
      }
      __typename
    }
    validatedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHistoryValidationMutationVariables,
  APITypes.UpdateHistoryValidationMutation
>;
export const deleteHistoryValidation = /* GraphQL */ `mutation DeleteHistoryValidation(
  $input: DeleteHistoryValidationInput!
  $condition: ModelHistoryValidationConditionInput
) {
  deleteHistoryValidation(input: $input, condition: $condition) {
    id
    appointmentRecordID
    status
    groups {
      id
      title
      status
      issues {
        id
        title
        description
        patientInfoSection
        issueType
        __typename
      }
      __typename
    }
    validatedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHistoryValidationMutationVariables,
  APITypes.DeleteHistoryValidationMutation
>;
export const createFieldTemplate = /* GraphQL */ `mutation CreateFieldTemplate(
  $input: CreateFieldTemplateInput!
  $condition: ModelFieldTemplateConditionInput
) {
  createFieldTemplate(input: $input, condition: $condition) {
    id
    version
    templateType
    specialty
    doctorId
    latestMarker
    adlFieldSectionMappings {
      ADLFieldSectionID
      ADLFieldIDs
      __typename
    }
    medicalHistoryFieldIDs
    createdAt
    updatedAt
    lastUpdatedBy
    changeDescription
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFieldTemplateMutationVariables,
  APITypes.CreateFieldTemplateMutation
>;
export const updateFieldTemplate = /* GraphQL */ `mutation UpdateFieldTemplate(
  $input: UpdateFieldTemplateInput!
  $condition: ModelFieldTemplateConditionInput
) {
  updateFieldTemplate(input: $input, condition: $condition) {
    id
    version
    templateType
    specialty
    doctorId
    latestMarker
    adlFieldSectionMappings {
      ADLFieldSectionID
      ADLFieldIDs
      __typename
    }
    medicalHistoryFieldIDs
    createdAt
    updatedAt
    lastUpdatedBy
    changeDescription
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFieldTemplateMutationVariables,
  APITypes.UpdateFieldTemplateMutation
>;
export const deleteFieldTemplate = /* GraphQL */ `mutation DeleteFieldTemplate(
  $input: DeleteFieldTemplateInput!
  $condition: ModelFieldTemplateConditionInput
) {
  deleteFieldTemplate(input: $input, condition: $condition) {
    id
    version
    templateType
    specialty
    doctorId
    latestMarker
    adlFieldSectionMappings {
      ADLFieldSectionID
      ADLFieldIDs
      __typename
    }
    medicalHistoryFieldIDs
    createdAt
    updatedAt
    lastUpdatedBy
    changeDescription
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFieldTemplateMutationVariables,
  APITypes.DeleteFieldTemplateMutation
>;
export const createPhysicalEvalTemplate = /* GraphQL */ `mutation CreatePhysicalEvalTemplate(
  $input: CreatePhysicalEvalTemplateInput!
  $condition: ModelPhysicalEvalTemplateConditionInput
) {
  createPhysicalEvalTemplate(input: $input, condition: $condition) {
    id
    version
    templateType
    specialtyCategoryId
    doctorId
    latestMarker
    exams {
      examID
      name
      bodyParts
      instructions
      sections {
        sectionID
        name
        fieldType
        config {
          minValue
          maxValue
          increment
          allowPlusMinus
          allowPlus
          unit
          freeformInputCount
          laterality
          hasNote
          hasDefault
          hasOtherFindings
          renderStyle
          __typename
        }
        questions {
          questionID
          label
          defaultValue
          defaultValueLeft
          defaultValueRight
          phrasing
          positiveText
          negativeText
          __typename
        }
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    lastUpdatedBy
    changeDescription
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePhysicalEvalTemplateMutationVariables,
  APITypes.CreatePhysicalEvalTemplateMutation
>;
export const updatePhysicalEvalTemplate = /* GraphQL */ `mutation UpdatePhysicalEvalTemplate(
  $input: UpdatePhysicalEvalTemplateInput!
  $condition: ModelPhysicalEvalTemplateConditionInput
) {
  updatePhysicalEvalTemplate(input: $input, condition: $condition) {
    id
    version
    templateType
    specialtyCategoryId
    doctorId
    latestMarker
    exams {
      examID
      name
      bodyParts
      instructions
      sections {
        sectionID
        name
        fieldType
        config {
          minValue
          maxValue
          increment
          allowPlusMinus
          allowPlus
          unit
          freeformInputCount
          laterality
          hasNote
          hasDefault
          hasOtherFindings
          renderStyle
          __typename
        }
        questions {
          questionID
          label
          defaultValue
          defaultValueLeft
          defaultValueRight
          phrasing
          positiveText
          negativeText
          __typename
        }
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    lastUpdatedBy
    changeDescription
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePhysicalEvalTemplateMutationVariables,
  APITypes.UpdatePhysicalEvalTemplateMutation
>;
export const deletePhysicalEvalTemplate = /* GraphQL */ `mutation DeletePhysicalEvalTemplate(
  $input: DeletePhysicalEvalTemplateInput!
  $condition: ModelPhysicalEvalTemplateConditionInput
) {
  deletePhysicalEvalTemplate(input: $input, condition: $condition) {
    id
    version
    templateType
    specialtyCategoryId
    doctorId
    latestMarker
    exams {
      examID
      name
      bodyParts
      instructions
      sections {
        sectionID
        name
        fieldType
        config {
          minValue
          maxValue
          increment
          allowPlusMinus
          allowPlus
          unit
          freeformInputCount
          laterality
          hasNote
          hasDefault
          hasOtherFindings
          renderStyle
          __typename
        }
        questions {
          questionID
          label
          defaultValue
          defaultValueLeft
          defaultValueRight
          phrasing
          positiveText
          negativeText
          __typename
        }
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    lastUpdatedBy
    changeDescription
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePhysicalEvalTemplateMutationVariables,
  APITypes.DeletePhysicalEvalTemplateMutation
>;
export const createZendeskTicket = /* GraphQL */ `mutation CreateZendeskTicket(
  $input: CreateZendeskTicketInput!
  $condition: ModelZendeskTicketConditionInput
) {
  createZendeskTicket(input: $input, condition: $condition) {
    id
    ticketID
    appointmentRecordID
    recipientParty
    isPrimary
    isTextTicket
    claimNumber
    version
    lastSyncedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateZendeskTicketMutationVariables,
  APITypes.CreateZendeskTicketMutation
>;
export const updateZendeskTicket = /* GraphQL */ `mutation UpdateZendeskTicket(
  $input: UpdateZendeskTicketInput!
  $condition: ModelZendeskTicketConditionInput
) {
  updateZendeskTicket(input: $input, condition: $condition) {
    id
    ticketID
    appointmentRecordID
    recipientParty
    isPrimary
    isTextTicket
    claimNumber
    version
    lastSyncedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateZendeskTicketMutationVariables,
  APITypes.UpdateZendeskTicketMutation
>;
export const deleteZendeskTicket = /* GraphQL */ `mutation DeleteZendeskTicket(
  $input: DeleteZendeskTicketInput!
  $condition: ModelZendeskTicketConditionInput
) {
  deleteZendeskTicket(input: $input, condition: $condition) {
    id
    ticketID
    appointmentRecordID
    recipientParty
    isPrimary
    isTextTicket
    claimNumber
    version
    lastSyncedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteZendeskTicketMutationVariables,
  APITypes.DeleteZendeskTicketMutation
>;
export const createScheduledCommunication = /* GraphQL */ `mutation CreateScheduledCommunication(
  $input: CreateScheduledCommunicationInput!
  $condition: ModelScheduledCommunicationConditionInput
) {
  createScheduledCommunication(input: $input, condition: $condition) {
    id
    appointmentRecordID
    communicationType
    targetParty
    scheduledDate
    status
    templateParams
    bodyOverride
    sentAt
    zendeskTicketID
    sentToPhone
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateScheduledCommunicationMutationVariables,
  APITypes.CreateScheduledCommunicationMutation
>;
export const updateScheduledCommunication = /* GraphQL */ `mutation UpdateScheduledCommunication(
  $input: UpdateScheduledCommunicationInput!
  $condition: ModelScheduledCommunicationConditionInput
) {
  updateScheduledCommunication(input: $input, condition: $condition) {
    id
    appointmentRecordID
    communicationType
    targetParty
    scheduledDate
    status
    templateParams
    bodyOverride
    sentAt
    zendeskTicketID
    sentToPhone
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScheduledCommunicationMutationVariables,
  APITypes.UpdateScheduledCommunicationMutation
>;
export const deleteScheduledCommunication = /* GraphQL */ `mutation DeleteScheduledCommunication(
  $input: DeleteScheduledCommunicationInput!
  $condition: ModelScheduledCommunicationConditionInput
) {
  deleteScheduledCommunication(input: $input, condition: $condition) {
    id
    appointmentRecordID
    communicationType
    targetParty
    scheduledDate
    status
    templateParams
    bodyOverride
    sentAt
    zendeskTicketID
    sentToPhone
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteScheduledCommunicationMutationVariables,
  APITypes.DeleteScheduledCommunicationMutation
>;
export const createAppointmentEvent = /* GraphQL */ `mutation CreateAppointmentEvent(
  $input: CreateAppointmentEventInput!
  $condition: ModelAppointmentEventConditionInput
) {
  createAppointmentEvent(input: $input, condition: $condition) {
    id
    appointmentRecordID
    entity
    entityID
    action
    actorType
    actorID
    timestamp
    properties
    source
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAppointmentEventMutationVariables,
  APITypes.CreateAppointmentEventMutation
>;
export const updateAppointmentEvent = /* GraphQL */ `mutation UpdateAppointmentEvent(
  $input: UpdateAppointmentEventInput!
  $condition: ModelAppointmentEventConditionInput
) {
  updateAppointmentEvent(input: $input, condition: $condition) {
    id
    appointmentRecordID
    entity
    entityID
    action
    actorType
    actorID
    timestamp
    properties
    source
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAppointmentEventMutationVariables,
  APITypes.UpdateAppointmentEventMutation
>;
export const deleteAppointmentEvent = /* GraphQL */ `mutation DeleteAppointmentEvent(
  $input: DeleteAppointmentEventInput!
  $condition: ModelAppointmentEventConditionInput
) {
  deleteAppointmentEvent(input: $input, condition: $condition) {
    id
    appointmentRecordID
    entity
    entityID
    action
    actorType
    actorID
    timestamp
    properties
    source
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAppointmentEventMutationVariables,
  APITypes.DeleteAppointmentEventMutation
>;
export const createAppointmentNotification = /* GraphQL */ `mutation CreateAppointmentNotification(
  $input: CreateAppointmentNotificationInput!
  $condition: ModelAppointmentNotificationConditionInput
) {
  createAppointmentNotification(input: $input, condition: $condition) {
    id
    appointmentRecordID
    entityType
    entityID
    notificationType
    channel
    recipientType
    recipientID
    recipientName
    title
    body
    status
    readAt
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAppointmentNotificationMutationVariables,
  APITypes.CreateAppointmentNotificationMutation
>;
export const updateAppointmentNotification = /* GraphQL */ `mutation UpdateAppointmentNotification(
  $input: UpdateAppointmentNotificationInput!
  $condition: ModelAppointmentNotificationConditionInput
) {
  updateAppointmentNotification(input: $input, condition: $condition) {
    id
    appointmentRecordID
    entityType
    entityID
    notificationType
    channel
    recipientType
    recipientID
    recipientName
    title
    body
    status
    readAt
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAppointmentNotificationMutationVariables,
  APITypes.UpdateAppointmentNotificationMutation
>;
export const deleteAppointmentNotification = /* GraphQL */ `mutation DeleteAppointmentNotification(
  $input: DeleteAppointmentNotificationInput!
  $condition: ModelAppointmentNotificationConditionInput
) {
  deleteAppointmentNotification(input: $input, condition: $condition) {
    id
    appointmentRecordID
    entityType
    entityID
    notificationType
    channel
    recipientType
    recipientID
    recipientName
    title
    body
    status
    readAt
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAppointmentNotificationMutationVariables,
  APITypes.DeleteAppointmentNotificationMutation
>;
export const createEmailNotificationQueue = /* GraphQL */ `mutation CreateEmailNotificationQueue(
  $input: CreateEmailNotificationQueueInput!
  $condition: ModelEmailNotificationQueueConditionInput
) {
  createEmailNotificationQueue(input: $input, condition: $condition) {
    id
    appointmentRecordID
    notificationType
    recipientID
    status
    emailDeliveryID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEmailNotificationQueueMutationVariables,
  APITypes.CreateEmailNotificationQueueMutation
>;
export const updateEmailNotificationQueue = /* GraphQL */ `mutation UpdateEmailNotificationQueue(
  $input: UpdateEmailNotificationQueueInput!
  $condition: ModelEmailNotificationQueueConditionInput
) {
  updateEmailNotificationQueue(input: $input, condition: $condition) {
    id
    appointmentRecordID
    notificationType
    recipientID
    status
    emailDeliveryID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEmailNotificationQueueMutationVariables,
  APITypes.UpdateEmailNotificationQueueMutation
>;
export const deleteEmailNotificationQueue = /* GraphQL */ `mutation DeleteEmailNotificationQueue(
  $input: DeleteEmailNotificationQueueInput!
  $condition: ModelEmailNotificationQueueConditionInput
) {
  deleteEmailNotificationQueue(input: $input, condition: $condition) {
    id
    appointmentRecordID
    notificationType
    recipientID
    status
    emailDeliveryID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEmailNotificationQueueMutationVariables,
  APITypes.DeleteEmailNotificationQueueMutation
>;
export const createEmailDelivery = /* GraphQL */ `mutation CreateEmailDelivery(
  $input: CreateEmailDeliveryInput!
  $condition: ModelEmailDeliveryConditionInput
) {
  createEmailDelivery(input: $input, condition: $condition) {
    id
    emailType
    recipientID
    recipientEmail
    subject
    body
    htmlBody
    status
    sentAt
    failureReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEmailDeliveryMutationVariables,
  APITypes.CreateEmailDeliveryMutation
>;
export const updateEmailDelivery = /* GraphQL */ `mutation UpdateEmailDelivery(
  $input: UpdateEmailDeliveryInput!
  $condition: ModelEmailDeliveryConditionInput
) {
  updateEmailDelivery(input: $input, condition: $condition) {
    id
    emailType
    recipientID
    recipientEmail
    subject
    body
    htmlBody
    status
    sentAt
    failureReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEmailDeliveryMutationVariables,
  APITypes.UpdateEmailDeliveryMutation
>;
export const deleteEmailDelivery = /* GraphQL */ `mutation DeleteEmailDelivery(
  $input: DeleteEmailDeliveryInput!
  $condition: ModelEmailDeliveryConditionInput
) {
  deleteEmailDelivery(input: $input, condition: $condition) {
    id
    emailType
    recipientID
    recipientEmail
    subject
    body
    htmlBody
    status
    sentAt
    failureReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEmailDeliveryMutationVariables,
  APITypes.DeleteEmailDeliveryMutation
>;
export const createChatbotMessage = /* GraphQL */ `mutation CreateChatbotMessage(
  $input: CreateChatbotMessageInput!
  $condition: ModelChatbotMessageConditionInput
) {
  createChatbotMessage(input: $input, condition: $condition) {
    userId
    conversationIdTimestamp
    messageId
    conversationId
    role
    content
    suggestedUserPrompt
    createdAt
    llmInput
    llmProvider
    llmModel
    inputTokens
    outputTokens
    reasoningTokens
    cachedTokens
    totalTokens
    toolsCalled
    toolsSucceeded
    toolsFailed
    ttftMs
    total_latency_ms
    userPaused
    agentTurns
    attachments {
      filename
      contentType
      sizeBytes
      s3Bucket
      s3Key
      slackUrl
      source
      __typename
    }
    dataBlocks
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChatbotMessageMutationVariables,
  APITypes.CreateChatbotMessageMutation
>;
export const updateChatbotMessage = /* GraphQL */ `mutation UpdateChatbotMessage(
  $input: UpdateChatbotMessageInput!
  $condition: ModelChatbotMessageConditionInput
) {
  updateChatbotMessage(input: $input, condition: $condition) {
    userId
    conversationIdTimestamp
    messageId
    conversationId
    role
    content
    suggestedUserPrompt
    createdAt
    llmInput
    llmProvider
    llmModel
    inputTokens
    outputTokens
    reasoningTokens
    cachedTokens
    totalTokens
    toolsCalled
    toolsSucceeded
    toolsFailed
    ttftMs
    total_latency_ms
    userPaused
    agentTurns
    attachments {
      filename
      contentType
      sizeBytes
      s3Bucket
      s3Key
      slackUrl
      source
      __typename
    }
    dataBlocks
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateChatbotMessageMutationVariables,
  APITypes.UpdateChatbotMessageMutation
>;
export const deleteChatbotMessage = /* GraphQL */ `mutation DeleteChatbotMessage(
  $input: DeleteChatbotMessageInput!
  $condition: ModelChatbotMessageConditionInput
) {
  deleteChatbotMessage(input: $input, condition: $condition) {
    userId
    conversationIdTimestamp
    messageId
    conversationId
    role
    content
    suggestedUserPrompt
    createdAt
    llmInput
    llmProvider
    llmModel
    inputTokens
    outputTokens
    reasoningTokens
    cachedTokens
    totalTokens
    toolsCalled
    toolsSucceeded
    toolsFailed
    ttftMs
    total_latency_ms
    userPaused
    agentTurns
    attachments {
      filename
      contentType
      sizeBytes
      s3Bucket
      s3Key
      slackUrl
      source
      __typename
    }
    dataBlocks
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChatbotMessageMutationVariables,
  APITypes.DeleteChatbotMessageMutation
>;
export const createChatbotConversation = /* GraphQL */ `mutation CreateChatbotConversation(
  $input: CreateChatbotConversationInput!
  $condition: ModelChatbotConversationConditionInput
) {
  createChatbotConversation(input: $input, condition: $condition) {
    userId
    conversationId
    createdAt
    updatedAt
    name
    archived
    pausedStreaming
    modelConversationId
    claudeSessionId
    routineId
    routineRunId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChatbotConversationMutationVariables,
  APITypes.CreateChatbotConversationMutation
>;
export const updateChatbotConversation = /* GraphQL */ `mutation UpdateChatbotConversation(
  $input: UpdateChatbotConversationInput!
  $condition: ModelChatbotConversationConditionInput
) {
  updateChatbotConversation(input: $input, condition: $condition) {
    userId
    conversationId
    createdAt
    updatedAt
    name
    archived
    pausedStreaming
    modelConversationId
    claudeSessionId
    routineId
    routineRunId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateChatbotConversationMutationVariables,
  APITypes.UpdateChatbotConversationMutation
>;
export const deleteChatbotConversation = /* GraphQL */ `mutation DeleteChatbotConversation(
  $input: DeleteChatbotConversationInput!
  $condition: ModelChatbotConversationConditionInput
) {
  deleteChatbotConversation(input: $input, condition: $condition) {
    userId
    conversationId
    createdAt
    updatedAt
    name
    archived
    pausedStreaming
    modelConversationId
    claudeSessionId
    routineId
    routineRunId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChatbotConversationMutationVariables,
  APITypes.DeleteChatbotConversationMutation
>;
export const createChatbotMonitoring = /* GraphQL */ `mutation CreateChatbotMonitoring(
  $input: CreateChatbotMonitoringInput!
  $condition: ModelChatbotMonitoringConditionInput
) {
  createChatbotMonitoring(input: $input, condition: $condition) {
    userId
    totalTokens
    lastWeekTokens
    totalConversations
    totalToolsCalled
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChatbotMonitoringMutationVariables,
  APITypes.CreateChatbotMonitoringMutation
>;
export const updateChatbotMonitoring = /* GraphQL */ `mutation UpdateChatbotMonitoring(
  $input: UpdateChatbotMonitoringInput!
  $condition: ModelChatbotMonitoringConditionInput
) {
  updateChatbotMonitoring(input: $input, condition: $condition) {
    userId
    totalTokens
    lastWeekTokens
    totalConversations
    totalToolsCalled
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateChatbotMonitoringMutationVariables,
  APITypes.UpdateChatbotMonitoringMutation
>;
export const deleteChatbotMonitoring = /* GraphQL */ `mutation DeleteChatbotMonitoring(
  $input: DeleteChatbotMonitoringInput!
  $condition: ModelChatbotMonitoringConditionInput
) {
  deleteChatbotMonitoring(input: $input, condition: $condition) {
    userId
    totalTokens
    lastWeekTokens
    totalConversations
    totalToolsCalled
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChatbotMonitoringMutationVariables,
  APITypes.DeleteChatbotMonitoringMutation
>;
export const createPromptExecution = /* GraphQL */ `mutation CreatePromptExecution(
  $input: CreatePromptExecutionInput!
  $condition: ModelPromptExecutionConditionInput
) {
  createPromptExecution(input: $input, condition: $condition) {
    id
    promptId
    attachments {
      blob {
        bucket
        key
        __typename
      }
      caption
      __typename
    }
    input {
      bucket
      key
      __typename
    }
    output {
      bucket
      key
      __typename
    }
    toolCalls {
      bucket
      key
      __typename
    }
    reasoningSummary
    executedAt
    appointmentID
    entityType
    entityId
    promptHash
    apiHash
    modelName
    modelConfig
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePromptExecutionMutationVariables,
  APITypes.CreatePromptExecutionMutation
>;
export const updatePromptExecution = /* GraphQL */ `mutation UpdatePromptExecution(
  $input: UpdatePromptExecutionInput!
  $condition: ModelPromptExecutionConditionInput
) {
  updatePromptExecution(input: $input, condition: $condition) {
    id
    promptId
    attachments {
      blob {
        bucket
        key
        __typename
      }
      caption
      __typename
    }
    input {
      bucket
      key
      __typename
    }
    output {
      bucket
      key
      __typename
    }
    toolCalls {
      bucket
      key
      __typename
    }
    reasoningSummary
    executedAt
    appointmentID
    entityType
    entityId
    promptHash
    apiHash
    modelName
    modelConfig
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePromptExecutionMutationVariables,
  APITypes.UpdatePromptExecutionMutation
>;
export const deletePromptExecution = /* GraphQL */ `mutation DeletePromptExecution(
  $input: DeletePromptExecutionInput!
  $condition: ModelPromptExecutionConditionInput
) {
  deletePromptExecution(input: $input, condition: $condition) {
    id
    promptId
    attachments {
      blob {
        bucket
        key
        __typename
      }
      caption
      __typename
    }
    input {
      bucket
      key
      __typename
    }
    output {
      bucket
      key
      __typename
    }
    toolCalls {
      bucket
      key
      __typename
    }
    reasoningSummary
    executedAt
    appointmentID
    entityType
    entityId
    promptHash
    apiHash
    modelName
    modelConfig
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePromptExecutionMutationVariables,
  APITypes.DeletePromptExecutionMutation
>;
export const createAppointmentEntityCorrelation = /* GraphQL */ `mutation CreateAppointmentEntityCorrelation(
  $input: CreateAppointmentEntityCorrelationInput!
  $condition: ModelAppointmentEntityCorrelationConditionInput
) {
  createAppointmentEntityCorrelation(input: $input, condition: $condition) {
    id
    appointmentID
    entityType
    entityID
    properties
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAppointmentEntityCorrelationMutationVariables,
  APITypes.CreateAppointmentEntityCorrelationMutation
>;
export const updateAppointmentEntityCorrelation = /* GraphQL */ `mutation UpdateAppointmentEntityCorrelation(
  $input: UpdateAppointmentEntityCorrelationInput!
  $condition: ModelAppointmentEntityCorrelationConditionInput
) {
  updateAppointmentEntityCorrelation(input: $input, condition: $condition) {
    id
    appointmentID
    entityType
    entityID
    properties
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAppointmentEntityCorrelationMutationVariables,
  APITypes.UpdateAppointmentEntityCorrelationMutation
>;
export const deleteAppointmentEntityCorrelation = /* GraphQL */ `mutation DeleteAppointmentEntityCorrelation(
  $input: DeleteAppointmentEntityCorrelationInput!
  $condition: ModelAppointmentEntityCorrelationConditionInput
) {
  deleteAppointmentEntityCorrelation(input: $input, condition: $condition) {
    id
    appointmentID
    entityType
    entityID
    properties
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAppointmentEntityCorrelationMutationVariables,
  APITypes.DeleteAppointmentEntityCorrelationMutation
>;
export const createPromptFeedback = /* GraphQL */ `mutation CreatePromptFeedback(
  $input: CreatePromptFeedbackInput!
  $condition: ModelPromptFeedbackConditionInput
) {
  createPromptFeedback(input: $input, condition: $condition) {
    id
    promptId
    promptExecutionId
    feedback
    feedbackSource
    actorType
    actorID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePromptFeedbackMutationVariables,
  APITypes.CreatePromptFeedbackMutation
>;
export const updatePromptFeedback = /* GraphQL */ `mutation UpdatePromptFeedback(
  $input: UpdatePromptFeedbackInput!
  $condition: ModelPromptFeedbackConditionInput
) {
  updatePromptFeedback(input: $input, condition: $condition) {
    id
    promptId
    promptExecutionId
    feedback
    feedbackSource
    actorType
    actorID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePromptFeedbackMutationVariables,
  APITypes.UpdatePromptFeedbackMutation
>;
export const deletePromptFeedback = /* GraphQL */ `mutation DeletePromptFeedback(
  $input: DeletePromptFeedbackInput!
  $condition: ModelPromptFeedbackConditionInput
) {
  deletePromptFeedback(input: $input, condition: $condition) {
    id
    promptId
    promptExecutionId
    feedback
    feedbackSource
    actorType
    actorID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePromptFeedbackMutationVariables,
  APITypes.DeletePromptFeedbackMutation
>;
export const createPromptOfflineEvalCase = /* GraphQL */ `mutation CreatePromptOfflineEvalCase(
  $input: CreatePromptOfflineEvalCaseInput!
  $condition: ModelPromptOfflineEvalCaseConditionInput
) {
  createPromptOfflineEvalCase(input: $input, condition: $condition) {
    id
    promptId
    sourcePromptExecutionId
    apiHash
    attachments {
      blob {
        bucket
        key
        __typename
      }
      caption
      __typename
    }
    input {
      bucket
      key
      __typename
    }
    output {
      bucket
      key
      __typename
    }
    toolCalls {
      bucket
      key
      __typename
    }
    description
    verified
    tags
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePromptOfflineEvalCaseMutationVariables,
  APITypes.CreatePromptOfflineEvalCaseMutation
>;
export const updatePromptOfflineEvalCase = /* GraphQL */ `mutation UpdatePromptOfflineEvalCase(
  $input: UpdatePromptOfflineEvalCaseInput!
  $condition: ModelPromptOfflineEvalCaseConditionInput
) {
  updatePromptOfflineEvalCase(input: $input, condition: $condition) {
    id
    promptId
    sourcePromptExecutionId
    apiHash
    attachments {
      blob {
        bucket
        key
        __typename
      }
      caption
      __typename
    }
    input {
      bucket
      key
      __typename
    }
    output {
      bucket
      key
      __typename
    }
    toolCalls {
      bucket
      key
      __typename
    }
    description
    verified
    tags
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePromptOfflineEvalCaseMutationVariables,
  APITypes.UpdatePromptOfflineEvalCaseMutation
>;
export const deletePromptOfflineEvalCase = /* GraphQL */ `mutation DeletePromptOfflineEvalCase(
  $input: DeletePromptOfflineEvalCaseInput!
  $condition: ModelPromptOfflineEvalCaseConditionInput
) {
  deletePromptOfflineEvalCase(input: $input, condition: $condition) {
    id
    promptId
    sourcePromptExecutionId
    apiHash
    attachments {
      blob {
        bucket
        key
        __typename
      }
      caption
      __typename
    }
    input {
      bucket
      key
      __typename
    }
    output {
      bucket
      key
      __typename
    }
    toolCalls {
      bucket
      key
      __typename
    }
    description
    verified
    tags
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePromptOfflineEvalCaseMutationVariables,
  APITypes.DeletePromptOfflineEvalCaseMutation
>;
export const createSkill = /* GraphQL */ `mutation CreateSkill(
  $input: CreateSkillInput!
  $condition: ModelSkillConditionInput
) {
  createSkill(input: $input, condition: $condition) {
    id
    name
    description
    body
    scope
    ownerUserId
    roles
    inputs {
      name
      description
      required
      __typename
    }
    visibility
    version
    archivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSkillMutationVariables,
  APITypes.CreateSkillMutation
>;
export const updateSkill = /* GraphQL */ `mutation UpdateSkill(
  $input: UpdateSkillInput!
  $condition: ModelSkillConditionInput
) {
  updateSkill(input: $input, condition: $condition) {
    id
    name
    description
    body
    scope
    ownerUserId
    roles
    inputs {
      name
      description
      required
      __typename
    }
    visibility
    version
    archivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSkillMutationVariables,
  APITypes.UpdateSkillMutation
>;
export const deleteSkill = /* GraphQL */ `mutation DeleteSkill(
  $input: DeleteSkillInput!
  $condition: ModelSkillConditionInput
) {
  deleteSkill(input: $input, condition: $condition) {
    id
    name
    description
    body
    scope
    ownerUserId
    roles
    inputs {
      name
      description
      required
      __typename
    }
    visibility
    version
    archivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSkillMutationVariables,
  APITypes.DeleteSkillMutation
>;
export const updateRoutine = /* GraphQL */ `mutation UpdateRoutine(
  $input: UpdateRoutineInput!
  $condition: ModelRoutineConditionInput
) {
  updateRoutine(input: $input, condition: $condition) {
    id
    scope
    name
    description
    promptBody
    model
    reasoningEffort
    enableWebSearch
    maxAgentTurns
    conversationMode
    schedule {
      frequency
      intervalHours
      timeOfDay
      weekdays
      runAt
      __typename
    }
    timezone
    enabled
    notifyOwner
    slackChannel
    ownerUserId
    createdAt
    createdVia
    version
    archivedAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRoutineMutationVariables,
  APITypes.UpdateRoutineMutation
>;
export const updateRoutineState = /* GraphQL */ `mutation UpdateRoutineState(
  $input: UpdateRoutineStateInput!
  $condition: ModelRoutineStateConditionInput
) {
  updateRoutineState(input: $input, condition: $condition) {
    id
    scope
    ownerUserId
    definitionVersion
    schedulePartition
    nextRunAt
    currentConversationId
    activeRunId
    lastRunId
    consecutiveFailures
    endedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRoutineStateMutationVariables,
  APITypes.UpdateRoutineStateMutation
>;
export const updateRoutineRun = /* GraphQL */ `mutation UpdateRoutineRun(
  $input: UpdateRoutineRunInput!
  $condition: ModelRoutineRunConditionInput
) {
  updateRoutineRun(input: $input, condition: $condition) {
    id
    scope
    routineId
    routineVersion
    createdAt
    definitionSnapshot
    status
    trigger
    triggeredByUserId
    extraContext
    scheduledFor
    startedAt
    finishedAt
    durationMs
    processingStage
    nextProcessingAt
    dispatchAttempts
    lastDispatchedAt
    executionToken
    executionDeadlineAt
    conversationOwnerUserId
    conversationId
    previousConversationId
    userMessageId
    assistantMessageId
    outcome
    headline
    summary
    totalTokens
    agentTurns
    toolsCalled
    toolsFailed
    correlationId
    errorMessage
    ownerDelivery {
      status
      target
      claimToken
      claimExpiresAt
      attemptedAt
      finishedAt
      messageId
      errorMessage
      __typename
    }
    channelDelivery {
      status
      target
      claimToken
      claimExpiresAt
      attemptedAt
      finishedAt
      messageId
      errorMessage
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRoutineRunMutationVariables,
  APITypes.UpdateRoutineRunMutation
>;
export const createDoctorSupportingMA = /* GraphQL */ `mutation CreateDoctorSupportingMA(
  $input: CreateDoctorSupportingMAInput!
  $condition: ModelDoctorSupportingMAConditionInput
) {
  createDoctorSupportingMA(input: $input, condition: $condition) {
    id
    medicalAssistantId
    doctorId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDoctorSupportingMAMutationVariables,
  APITypes.CreateDoctorSupportingMAMutation
>;
export const updateDoctorSupportingMA = /* GraphQL */ `mutation UpdateDoctorSupportingMA(
  $input: UpdateDoctorSupportingMAInput!
  $condition: ModelDoctorSupportingMAConditionInput
) {
  updateDoctorSupportingMA(input: $input, condition: $condition) {
    id
    medicalAssistantId
    doctorId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDoctorSupportingMAMutationVariables,
  APITypes.UpdateDoctorSupportingMAMutation
>;
export const deleteDoctorSupportingMA = /* GraphQL */ `mutation DeleteDoctorSupportingMA(
  $input: DeleteDoctorSupportingMAInput!
  $condition: ModelDoctorSupportingMAConditionInput
) {
  deleteDoctorSupportingMA(input: $input, condition: $condition) {
    id
    medicalAssistantId
    doctorId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDoctorSupportingMAMutationVariables,
  APITypes.DeleteDoctorSupportingMAMutation
>;
export const createMedicalAssistantSpecialtyCategory = /* GraphQL */ `mutation CreateMedicalAssistantSpecialtyCategory(
  $input: CreateMedicalAssistantSpecialtyCategoryInput!
  $condition: ModelMedicalAssistantSpecialtyCategoryConditionInput
) {
  createMedicalAssistantSpecialtyCategory(
    input: $input
    condition: $condition
  ) {
    id
    medicalAssistantId
    specialtyCategoryId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    specialtyCategory {
      id
      name
      specialties
      fallbackMA {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      medicalAssistants {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      specialtyCategoryFallbackMAId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMedicalAssistantSpecialtyCategoryMutationVariables,
  APITypes.CreateMedicalAssistantSpecialtyCategoryMutation
>;
export const updateMedicalAssistantSpecialtyCategory = /* GraphQL */ `mutation UpdateMedicalAssistantSpecialtyCategory(
  $input: UpdateMedicalAssistantSpecialtyCategoryInput!
  $condition: ModelMedicalAssistantSpecialtyCategoryConditionInput
) {
  updateMedicalAssistantSpecialtyCategory(
    input: $input
    condition: $condition
  ) {
    id
    medicalAssistantId
    specialtyCategoryId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    specialtyCategory {
      id
      name
      specialties
      fallbackMA {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      medicalAssistants {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      specialtyCategoryFallbackMAId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMedicalAssistantSpecialtyCategoryMutationVariables,
  APITypes.UpdateMedicalAssistantSpecialtyCategoryMutation
>;
export const deleteMedicalAssistantSpecialtyCategory = /* GraphQL */ `mutation DeleteMedicalAssistantSpecialtyCategory(
  $input: DeleteMedicalAssistantSpecialtyCategoryInput!
  $condition: ModelMedicalAssistantSpecialtyCategoryConditionInput
) {
  deleteMedicalAssistantSpecialtyCategory(
    input: $input
    condition: $condition
  ) {
    id
    medicalAssistantId
    specialtyCategoryId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    specialtyCategory {
      id
      name
      specialties
      fallbackMA {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      medicalAssistants {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      specialtyCategoryFallbackMAId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMedicalAssistantSpecialtyCategoryMutationVariables,
  APITypes.DeleteMedicalAssistantSpecialtyCategoryMutation
>;
export const createUserAppointmentFilterPreset = /* GraphQL */ `mutation CreateUserAppointmentFilterPreset(
  $input: CreateUserAppointmentFilterPresetInput!
  $condition: ModelUserAppointmentFilterPresetConditionInput
) {
  createUserAppointmentFilterPreset(input: $input, condition: $condition) {
    id
    userId
    appointmentFilterPresetId
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    appointmentFilterPreset {
      id
      name
      filters {
        type
        values
        __typename
      }
      appliesTo
      view
      users {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserAppointmentFilterPresetMutationVariables,
  APITypes.CreateUserAppointmentFilterPresetMutation
>;
export const updateUserAppointmentFilterPreset = /* GraphQL */ `mutation UpdateUserAppointmentFilterPreset(
  $input: UpdateUserAppointmentFilterPresetInput!
  $condition: ModelUserAppointmentFilterPresetConditionInput
) {
  updateUserAppointmentFilterPreset(input: $input, condition: $condition) {
    id
    userId
    appointmentFilterPresetId
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    appointmentFilterPreset {
      id
      name
      filters {
        type
        values
        __typename
      }
      appliesTo
      view
      users {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserAppointmentFilterPresetMutationVariables,
  APITypes.UpdateUserAppointmentFilterPresetMutation
>;
export const deleteUserAppointmentFilterPreset = /* GraphQL */ `mutation DeleteUserAppointmentFilterPreset(
  $input: DeleteUserAppointmentFilterPresetInput!
  $condition: ModelUserAppointmentFilterPresetConditionInput
) {
  deleteUserAppointmentFilterPreset(input: $input, condition: $condition) {
    id
    userId
    appointmentFilterPresetId
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    appointmentFilterPreset {
      id
      name
      filters {
        type
        values
        __typename
      }
      appliesTo
      view
      users {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserAppointmentFilterPresetMutationVariables,
  APITypes.DeleteUserAppointmentFilterPresetMutation
>;
export const createAppointmentRecordPatientCase = /* GraphQL */ `mutation CreateAppointmentRecordPatientCase(
  $input: CreateAppointmentRecordPatientCaseInput!
  $condition: ModelAppointmentRecordPatientCaseConditionInput
) {
  createAppointmentRecordPatientCase(input: $input, condition: $condition) {
    id
    appointmentRecordId
    patientCaseId
    appointmentRecord {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        appointmentId
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    patientCase {
      id
      patientID
      patient {
        id
        name
        dateOfBirth
        SSN
        language
        dominantHand
        cases {
          nextToken
          __typename
        }
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        occupation
        sex
        weightLb
        height {
          feet
          inches
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      claimNumber
      qmePanelNumber
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      injuryInfo {
        injuryType
        injuredBodyParts
        claimedBodyParts
        description
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        startDateOfInjury
        startDateOfInjuryFlexible {
          value
          precision
          __typename
        }
        __typename
      }
      workersCompInsurance {
        insuranceCarrier
        adjuster
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      insuranceCarrierID
      insuranceCarrier {
        id
        name
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierAddressID
      insuranceCarrierAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierFaxNumberID
      insuranceCarrierFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierPhoneNumberID
      insuranceCarrierPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      appointments {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      applicantAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyLawFirmID
      applicantAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyAddressID
      applicantAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyFaxNumberID
      applicantAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyPhoneNumberID
      applicantAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      defenseAttorneyLawFirmID
      defenseAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyAddressID
      defenseAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyFaxNumberID
      defenseAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyPhoneNumberID
      defenseAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nurseCaseManager {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      ccPerson {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyCcEmails
      defenseAttorneyCcEmails
      adjusterCcEmails
      scheduledCommsSuppressedParties
      employmentAtInjury {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      WCAB
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    doctorOwnerCognitoId
    assistantCognitoIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAppointmentRecordPatientCaseMutationVariables,
  APITypes.CreateAppointmentRecordPatientCaseMutation
>;
export const updateAppointmentRecordPatientCase = /* GraphQL */ `mutation UpdateAppointmentRecordPatientCase(
  $input: UpdateAppointmentRecordPatientCaseInput!
  $condition: ModelAppointmentRecordPatientCaseConditionInput
) {
  updateAppointmentRecordPatientCase(input: $input, condition: $condition) {
    id
    appointmentRecordId
    patientCaseId
    appointmentRecord {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        appointmentId
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    patientCase {
      id
      patientID
      patient {
        id
        name
        dateOfBirth
        SSN
        language
        dominantHand
        cases {
          nextToken
          __typename
        }
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        occupation
        sex
        weightLb
        height {
          feet
          inches
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      claimNumber
      qmePanelNumber
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      injuryInfo {
        injuryType
        injuredBodyParts
        claimedBodyParts
        description
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        startDateOfInjury
        startDateOfInjuryFlexible {
          value
          precision
          __typename
        }
        __typename
      }
      workersCompInsurance {
        insuranceCarrier
        adjuster
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      insuranceCarrierID
      insuranceCarrier {
        id
        name
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierAddressID
      insuranceCarrierAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierFaxNumberID
      insuranceCarrierFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierPhoneNumberID
      insuranceCarrierPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      appointments {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      applicantAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyLawFirmID
      applicantAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyAddressID
      applicantAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyFaxNumberID
      applicantAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyPhoneNumberID
      applicantAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      defenseAttorneyLawFirmID
      defenseAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyAddressID
      defenseAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyFaxNumberID
      defenseAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyPhoneNumberID
      defenseAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nurseCaseManager {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      ccPerson {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyCcEmails
      defenseAttorneyCcEmails
      adjusterCcEmails
      scheduledCommsSuppressedParties
      employmentAtInjury {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      WCAB
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    doctorOwnerCognitoId
    assistantCognitoIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAppointmentRecordPatientCaseMutationVariables,
  APITypes.UpdateAppointmentRecordPatientCaseMutation
>;
export const deleteAppointmentRecordPatientCase = /* GraphQL */ `mutation DeleteAppointmentRecordPatientCase(
  $input: DeleteAppointmentRecordPatientCaseInput!
  $condition: ModelAppointmentRecordPatientCaseConditionInput
) {
  deleteAppointmentRecordPatientCase(input: $input, condition: $condition) {
    id
    appointmentRecordId
    patientCaseId
    appointmentRecord {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        appointmentId
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    patientCase {
      id
      patientID
      patient {
        id
        name
        dateOfBirth
        SSN
        language
        dominantHand
        cases {
          nextToken
          __typename
        }
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        occupation
        sex
        weightLb
        height {
          feet
          inches
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      claimNumber
      qmePanelNumber
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      injuryInfo {
        injuryType
        injuredBodyParts
        claimedBodyParts
        description
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        startDateOfInjury
        startDateOfInjuryFlexible {
          value
          precision
          __typename
        }
        __typename
      }
      workersCompInsurance {
        insuranceCarrier
        adjuster
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      insuranceCarrierID
      insuranceCarrier {
        id
        name
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierAddressID
      insuranceCarrierAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierFaxNumberID
      insuranceCarrierFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierPhoneNumberID
      insuranceCarrierPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      appointments {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      applicantAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyLawFirmID
      applicantAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyAddressID
      applicantAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyFaxNumberID
      applicantAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyPhoneNumberID
      applicantAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      defenseAttorneyLawFirmID
      defenseAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyAddressID
      defenseAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyFaxNumberID
      defenseAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyPhoneNumberID
      defenseAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nurseCaseManager {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      ccPerson {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyCcEmails
      defenseAttorneyCcEmails
      adjusterCcEmails
      scheduledCommsSuppressedParties
      employmentAtInjury {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      WCAB
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    doctorOwnerCognitoId
    assistantCognitoIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAppointmentRecordPatientCaseMutationVariables,
  APITypes.DeleteAppointmentRecordPatientCaseMutation
>;
export const createDoctorLocation = /* GraphQL */ `mutation CreateDoctorLocation(
  $input: CreateDoctorLocationInput!
  $condition: ModelDoctorLocationConditionInput
) {
  createDoctorLocation(input: $input, condition: $condition) {
    id
    doctorId
    locationId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDoctorLocationMutationVariables,
  APITypes.CreateDoctorLocationMutation
>;
export const updateDoctorLocation = /* GraphQL */ `mutation UpdateDoctorLocation(
  $input: UpdateDoctorLocationInput!
  $condition: ModelDoctorLocationConditionInput
) {
  updateDoctorLocation(input: $input, condition: $condition) {
    id
    doctorId
    locationId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDoctorLocationMutationVariables,
  APITypes.UpdateDoctorLocationMutation
>;
export const deleteDoctorLocation = /* GraphQL */ `mutation DeleteDoctorLocation(
  $input: DeleteDoctorLocationInput!
  $condition: ModelDoctorLocationConditionInput
) {
  deleteDoctorLocation(input: $input, condition: $condition) {
    id
    doctorId
    locationId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDoctorLocationMutationVariables,
  APITypes.DeleteDoctorLocationMutation
>;
export const createDoctorCaseSummaryField = /* GraphQL */ `mutation CreateDoctorCaseSummaryField(
  $input: CreateDoctorCaseSummaryFieldInput!
  $condition: ModelDoctorCaseSummaryFieldConditionInput
) {
  createDoctorCaseSummaryField(input: $input, condition: $condition) {
    id
    doctorId
    caseSummaryFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    caseSummaryField {
      id
      name
      default
      description
      summaryPrompt
      doctors {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDoctorCaseSummaryFieldMutationVariables,
  APITypes.CreateDoctorCaseSummaryFieldMutation
>;
export const updateDoctorCaseSummaryField = /* GraphQL */ `mutation UpdateDoctorCaseSummaryField(
  $input: UpdateDoctorCaseSummaryFieldInput!
  $condition: ModelDoctorCaseSummaryFieldConditionInput
) {
  updateDoctorCaseSummaryField(input: $input, condition: $condition) {
    id
    doctorId
    caseSummaryFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    caseSummaryField {
      id
      name
      default
      description
      summaryPrompt
      doctors {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDoctorCaseSummaryFieldMutationVariables,
  APITypes.UpdateDoctorCaseSummaryFieldMutation
>;
export const deleteDoctorCaseSummaryField = /* GraphQL */ `mutation DeleteDoctorCaseSummaryField(
  $input: DeleteDoctorCaseSummaryFieldInput!
  $condition: ModelDoctorCaseSummaryFieldConditionInput
) {
  deleteDoctorCaseSummaryField(input: $input, condition: $condition) {
    id
    doctorId
    caseSummaryFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    caseSummaryField {
      id
      name
      default
      description
      summaryPrompt
      doctors {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDoctorCaseSummaryFieldMutationVariables,
  APITypes.DeleteDoctorCaseSummaryFieldMutation
>;
export const createDoctorBriefingField = /* GraphQL */ `mutation CreateDoctorBriefingField(
  $input: CreateDoctorBriefingFieldInput!
  $condition: ModelDoctorBriefingFieldConditionInput
) {
  createDoctorBriefingField(input: $input, condition: $condition) {
    id
    doctorId
    briefingFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    briefingField {
      id
      name
      default
      description
      briefingPrompt
      doctors {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingRecordTypeID
      recordType {
        id
        name
        recordType
        description
        default
        classificationPrompt
        recordBasePrompt
        briefingFields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDoctorBriefingFieldMutationVariables,
  APITypes.CreateDoctorBriefingFieldMutation
>;
export const updateDoctorBriefingField = /* GraphQL */ `mutation UpdateDoctorBriefingField(
  $input: UpdateDoctorBriefingFieldInput!
  $condition: ModelDoctorBriefingFieldConditionInput
) {
  updateDoctorBriefingField(input: $input, condition: $condition) {
    id
    doctorId
    briefingFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    briefingField {
      id
      name
      default
      description
      briefingPrompt
      doctors {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingRecordTypeID
      recordType {
        id
        name
        recordType
        description
        default
        classificationPrompt
        recordBasePrompt
        briefingFields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDoctorBriefingFieldMutationVariables,
  APITypes.UpdateDoctorBriefingFieldMutation
>;
export const deleteDoctorBriefingField = /* GraphQL */ `mutation DeleteDoctorBriefingField(
  $input: DeleteDoctorBriefingFieldInput!
  $condition: ModelDoctorBriefingFieldConditionInput
) {
  deleteDoctorBriefingField(input: $input, condition: $condition) {
    id
    doctorId
    briefingFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    briefingField {
      id
      name
      default
      description
      briefingPrompt
      doctors {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingRecordTypeID
      recordType {
        id
        name
        recordType
        description
        default
        classificationPrompt
        recordBasePrompt
        briefingFields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDoctorBriefingFieldMutationVariables,
  APITypes.DeleteDoctorBriefingFieldMutation
>;
export const incrementGlobalBillingCounterAtomic = /* GraphQL */ `mutation IncrementGlobalBillingCounterAtomic {
  incrementGlobalBillingCounterAtomic {
    id
    count
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.IncrementGlobalBillingCounterAtomicMutationVariables,
  APITypes.IncrementGlobalBillingCounterAtomicMutation
>;
